import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { WatchNowOfferFragmentDoc } from '../../../../pages/graphql/fragments/WatchNowOffer.fragment';
import { TextRecommendationFragmentDoc } from '../../../why-to-watch/graphql/fragments/TextRecommendation.fragment';
import { ProfileInfoV2FragmentDoc } from '../../../user-profile/graphql/fragments/ProfileInfo.fragment';
import { SingleStepSportEventFragmentDoc } from '../../../../pages/graphql/fragments/SingleStepSportEvent.fragment';
import { MultiStepSportEventFragmentDoc } from '../../../../pages/graphql/fragments/MultiStepSportEvent.fragment';
import { AuthorDataFragmentDoc } from '../../../editorial/graphql/queries/GetArticleByUrl.query';
export type GetHomeModulesQueryVariables = Types.Exact<{
	fullPath: Types.Scalars['String']['input'];
	site?: Types.InputMaybe<Types.Scalars['String']['input']>;
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
	platform?: Types.Platform;
	locale: Types.Scalars['String']['input'];
	watchNowFilter: Types.WatchNowOfferFilter;
	includeUnreleasedEpisodes?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
	excludeTextRecommendationTitle?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;

export type GetHomeModulesQuery = {
	__typename?: 'Query';
	urlV2: {
		__typename: 'Url';
		fullPath: string;
		locale: string;
		objectType: Types.ObjectType;
		heading1?: string | null;
		heading2?: string | null;
		htmlContent?: string | null;
		htmlContentJson?: any | null;
		id: string;
		urlID: number;
		metaDescription?: string | null;
		metaKeywords?: string | null;
		metaRobots?: string | null;
		metaTitle?: string | null;
		hrefLangTags: Array<{ __typename?: 'HrefLangTag'; href: string; hrefLang: string; locale: string }>;
		node:
			| { __typename?: 'Article' }
			| { __typename?: 'Author' }
			| { __typename?: 'Bundle' }
			| { __typename?: 'Device' }
			| { __typename?: 'Episode' }
			| { __typename?: 'GenericTitleList' }
			| { __typename?: 'Genre' }
			| {
					__typename: 'HomePage';
					id: string;
					modules: Array<
						| {
								__typename: 'HMAVOD';
								moduleID: number;
								type: string;
								category: string;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMBecauseYouLikedTitle';
								moduleID: number;
								type: string;
								category: string;
								likedTitle:
									| {
											__typename?: 'Movie';
											id: string;
											content: {
												__typename?: 'MovieContent';
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											};
									  }
									| {
											__typename?: 'Season';
											id: string;
											content: {
												__typename?: 'SeasonContent';
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											};
									  }
									| {
											__typename?: 'Show';
											id: string;
											content: {
												__typename?: 'ShowContent';
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											};
									  };
								titles: Array<
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
									  }
									| {
											__typename: 'Season';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											content: {
												__typename?: 'SeasonContent';
												seasonNumber: number;
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
											show: {
												__typename: 'Show';
												id: string;
												objectType: Types.ObjectType;
												objectId: number;
												content: { __typename?: 'ShowContent'; title: string };
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											watchNextEpisode?: {
												__typename?: 'Episode';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												season: {
													__typename?: 'Season';
													id: string;
													content: {
														__typename?: 'SeasonContent';
														fullPath: string;
														posterUrl?: string | null;
													};
													seenState: {
														__typename?: 'ShowSeenState';
														releasedEpisodeCount: number;
														seenEpisodeCount: number;
														progress: number;
													};
												};
												content: {
													__typename?: 'EpisodeContent';
													title: string;
													episodeNumber: number;
													seasonNumber: number;
													upcomingReleases?: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														label: Types.UpcomingReleaseLabel;
													}>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												show: { __typename?: 'Show'; id: string };
											} | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'ShowContent';
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
									  }
								>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMContinueWatchingJWTV';
								moduleID: number;
								type: string;
								category: string;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMFeatureRotator';
								moduleID: number;
								type: string;
								category: string;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMHighlightArticle';
								moduleID: number;
								type: string;
								category: string;
								titles: Array<
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											appleTVPlusOffers: Array<{
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											}>;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
									  }
									| {
											__typename: 'Season';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											appleTVPlusOffers: Array<{
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											}>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											content: {
												__typename?: 'SeasonContent';
												seasonNumber: number;
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
											show: {
												__typename: 'Show';
												id: string;
												objectType: Types.ObjectType;
												objectId: number;
												content: { __typename?: 'ShowContent'; title: string };
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											appleTVPlusOffers: Array<{
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											}>;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											watchNextEpisode?: {
												__typename?: 'Episode';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												season: {
													__typename?: 'Season';
													id: string;
													content: {
														__typename?: 'SeasonContent';
														fullPath: string;
														posterUrl?: string | null;
													};
													seenState: {
														__typename?: 'ShowSeenState';
														releasedEpisodeCount: number;
														seenEpisodeCount: number;
														progress: number;
													};
												};
												content: {
													__typename?: 'EpisodeContent';
													title: string;
													episodeNumber: number;
													seasonNumber: number;
													upcomingReleases?: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														label: Types.UpcomingReleaseLabel;
													}>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												show: { __typename?: 'Show'; id: string };
											} | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'ShowContent';
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
									  }
								>;
								article: {
									__typename?: 'Article';
									id: string;
									author: {
										__typename?: 'Author';
										id: string;
										content: {
											__typename?: 'AuthorContent';
											bio: string;
											clearName: string;
											imageUrl?: string | null;
											fullPath: string;
											alumniOf: Array<string>;
											brand: string;
											languagesSpoken: Array<any>;
											occupation: Array<string>;
											publications?: Array<{
												__typename?: 'AuthorSpecificLink';
												name: string;
												url: string;
											}> | null;
											socialHandles?: Array<{
												__typename?: 'AuthorSpecificLink';
												name: string;
												url: string;
											}> | null;
										};
									};
									content: {
										__typename: 'ArticleContent';
										id: number;
										title?: string | null;
										fullPath: string;
										highlightLabel?: string | null;
										highlightTitle?: string | null;
									};
									linkedObjects: Array<{
										__typename?: 'ArticleLinkedObject';
										node:
											| { __typename?: 'Article' }
											| { __typename?: 'Author' }
											| { __typename?: 'Bundle' }
											| { __typename?: 'Device' }
											| { __typename?: 'Episode' }
											| {
													__typename?: 'GenericTitleList';
													id: string;
													followedlistEntry?: {
														__typename?: 'FollowedListEntry';
														createdAt: any;
														name: string;
													} | null;
											  }
											| { __typename?: 'Genre' }
											| { __typename?: 'HomePage' }
											| { __typename?: 'Movie' }
											| { __typename?: 'MultiStepSportEvent' }
											| { __typename?: 'Offer' }
											| { __typename?: 'OfferHistory' }
											| { __typename?: 'Package' }
											| { __typename?: 'Page' }
											| { __typename?: 'Person' }
											| { __typename?: 'ProfileV2' }
											| { __typename?: 'Season' }
											| { __typename?: 'Show' }
											| { __typename?: 'SingleStepSportEvent' }
											| { __typename?: 'SportCompetitionV2' }
											| { __typename?: 'SportCompetitorV2' }
											| { __typename?: 'SportMatch' }
											| { __typename?: 'Url' };
									}>;
								};
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMNewPerPackageToday';
								moduleID: number;
								type: string;
								category: string;
								packagesWithTitles: Array<{
									__typename?: 'PackageTitles';
									package: {
										__typename?: 'Package';
										id: string;
										clearName: string;
										shortName: string;
										packageId: number;
									};
									titlesWithTrend: Array<{
										__typename?: 'TitleWithTrend';
										trend: Types.TitleTrend;
										title:
											| {
													__typename: 'Movie';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													offerCount: number;
													watchlistEntryV2?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													likelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													dislikelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													customlistEntries: Array<{
														__typename?: 'TitleListEntry';
														createdAt: any;
													}>;
													seenlistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													watchNowOffer?: {
														__typename: 'Offer';
														id: string;
														standardWebURL?: string | null;
														preAffiliatedStandardWebURL?: string | null;
														streamUrl?: string | null;
														streamUrlExternalPlayer?: string | null;
														retailPrice?: string | null;
														retailPriceValue?: number | null;
														lastChangeRetailPriceValue?: number | null;
														currency?: string | null;
														presentationType: Types.PresentationType;
														monetizationType: Types.MonetizationType;
														availableTo?: any | null;
														dateCreated?: any | null;
														newElementCount?: number | null;
														package: {
															__typename?: 'Package';
															id: string;
															icon: string;
															packageId: number;
															clearName: string;
															shortName: string;
															technicalName: string;
															iconWide: string;
															hasRectangularIcon: boolean;
														};
													} | null;
													content: {
														__typename?: 'MovieContent';
														title: string;
														originalReleaseYear?: number | null;
														runtime?: number | null;
														fullPath: string;
														posterUrl?: string | null;
														backdrops: Array<{
															__typename?: 'Backdrop';
															backdropUrl: string;
														}>;
														scoring: { __typename?: 'Scoring'; viral?: number | null };
													};
											  }
											| {
													__typename: 'Season';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													offerCount: number;
													seenState: {
														__typename?: 'ShowSeenState';
														seenEpisodeCount: number;
														releasedEpisodeCount: number;
														progress: number;
														caughtUp: boolean;
														lastSeenEpisodeNumber?: number | null;
														lastSeenSeasonNumber?: number | null;
													};
													content: {
														__typename?: 'SeasonContent';
														seasonNumber: number;
														title: string;
														originalReleaseYear?: number | null;
														runtime?: number | null;
														fullPath: string;
														posterUrl?: string | null;
														backdrops: Array<{
															__typename?: 'Backdrop';
															backdropUrl: string;
														}>;
														scoring: { __typename?: 'Scoring'; viral?: number | null };
													};
													show: {
														__typename: 'Show';
														id: string;
														objectType: Types.ObjectType;
														objectId: number;
														content: { __typename?: 'ShowContent'; title: string };
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
													};
													watchNowOffer?: {
														__typename: 'Offer';
														id: string;
														standardWebURL?: string | null;
														preAffiliatedStandardWebURL?: string | null;
														streamUrl?: string | null;
														streamUrlExternalPlayer?: string | null;
														retailPrice?: string | null;
														retailPriceValue?: number | null;
														lastChangeRetailPriceValue?: number | null;
														currency?: string | null;
														presentationType: Types.PresentationType;
														monetizationType: Types.MonetizationType;
														availableTo?: any | null;
														dateCreated?: any | null;
														newElementCount?: number | null;
														package: {
															__typename?: 'Package';
															id: string;
															icon: string;
															packageId: number;
															clearName: string;
															shortName: string;
															technicalName: string;
															iconWide: string;
															hasRectangularIcon: boolean;
														};
													} | null;
											  }
											| {
													__typename: 'Show';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													offerCount: number;
													watchlistEntryV2?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													likelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													dislikelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													customlistEntries: Array<{
														__typename?: 'TitleListEntry';
														createdAt: any;
													}>;
													seenState: {
														__typename?: 'ShowSeenState';
														seenEpisodeCount: number;
														releasedEpisodeCount: number;
														progress: number;
														caughtUp: boolean;
														lastSeenEpisodeNumber?: number | null;
														lastSeenSeasonNumber?: number | null;
													};
													watchNextEpisode?: {
														__typename?: 'Episode';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														season: {
															__typename?: 'Season';
															id: string;
															content: {
																__typename?: 'SeasonContent';
																fullPath: string;
																posterUrl?: string | null;
															};
															seenState: {
																__typename?: 'ShowSeenState';
																releasedEpisodeCount: number;
																seenEpisodeCount: number;
																progress: number;
															};
														};
														content: {
															__typename?: 'EpisodeContent';
															title: string;
															episodeNumber: number;
															seasonNumber: number;
															upcomingReleases?: Array<{
																__typename?: 'UpcomingRelease';
																releaseDate?: any | null;
																label: Types.UpcomingReleaseLabel;
															}>;
														};
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														show: { __typename?: 'Show'; id: string };
													} | null;
													watchNowOffer?: {
														__typename: 'Offer';
														id: string;
														standardWebURL?: string | null;
														preAffiliatedStandardWebURL?: string | null;
														streamUrl?: string | null;
														streamUrlExternalPlayer?: string | null;
														retailPrice?: string | null;
														retailPriceValue?: number | null;
														lastChangeRetailPriceValue?: number | null;
														currency?: string | null;
														presentationType: Types.PresentationType;
														monetizationType: Types.MonetizationType;
														availableTo?: any | null;
														dateCreated?: any | null;
														newElementCount?: number | null;
														package: {
															__typename?: 'Package';
															id: string;
															icon: string;
															packageId: number;
															clearName: string;
															shortName: string;
															technicalName: string;
															iconWide: string;
															hasRectangularIcon: boolean;
														};
													} | null;
													content: {
														__typename?: 'ShowContent';
														title: string;
														originalReleaseYear?: number | null;
														runtime?: number | null;
														fullPath: string;
														posterUrl?: string | null;
														backdrops: Array<{
															__typename?: 'Backdrop';
															backdropUrl: string;
														}>;
														scoring: { __typename?: 'Scoring'; viral?: number | null };
													};
											  };
									}>;
								}>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMPermanentAudience';
								category: string;
								moduleID: number;
								type: string;
								titles: Array<
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
									  }
									| {
											__typename: 'Season';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											content: {
												__typename?: 'SeasonContent';
												seasonNumber: number;
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
											show: {
												__typename: 'Show';
												id: string;
												objectType: Types.ObjectType;
												objectId: number;
												content: { __typename?: 'ShowContent'; title: string };
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											watchNextEpisode?: {
												__typename?: 'Episode';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												season: {
													__typename?: 'Season';
													id: string;
													content: {
														__typename?: 'SeasonContent';
														fullPath: string;
														posterUrl?: string | null;
													};
													seenState: {
														__typename?: 'ShowSeenState';
														releasedEpisodeCount: number;
														seenEpisodeCount: number;
														progress: number;
													};
												};
												content: {
													__typename?: 'EpisodeContent';
													title: string;
													episodeNumber: number;
													seasonNumber: number;
													upcomingReleases?: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														label: Types.UpcomingReleaseLabel;
													}>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												show: { __typename?: 'Show'; id: string };
											} | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'ShowContent';
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
									  }
								>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMSQTV';
								moduleID: number;
								type: string;
								category: string;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMSportsLiveFootball';
								moduleID: number;
								type: string;
								category: string;
								events: Array<
									| { __typename?: 'MultiStepSportEvent' }
									| {
											__typename: 'SingleStepSportEvent';
											id: string;
											sport: Types.SportType;
											objectType: Types.ObjectType;
											objectId: number;
											offerCount: number;
											mysportlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename?: 'SportOffer';
												standardWebURL?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												audioLanguage?: string | null;
												sportObjectType: Types.SportObjectType;
												package: {
													__typename?: 'Package';
													clearName: string;
													icon: string;
													iconBlurHash?: string | null;
													id: string;
													packageId: number;
													technicalName: string;
													shortName: string;
													monetizationTypes: Array<Types.MonetizationType>;
													iconWide: string;
												};
											} | null;
											competition?: {
												__typename?: 'SportCompetitionV2';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												sport: Types.SportType;
												content: {
													__typename?: 'SportCompetitionContentV2';
													fullPath: string;
													iconBlurHash?: string | null;
													iconUrl?: string | null;
													name: string;
												};
												activeSeason?: {
													__typename?: 'SportSeason';
													name: string;
													seasonID: number;
												} | null;
											} | null;
											content: {
												__typename?: 'SingleStepSportEventContent';
												endAt?: any | null;
												fullPath?: string | null;
												name: string;
												startAt: any;
												status: Types.SportEventStatus;
												competitionStage: {
													__typename?: 'SportCompetitionStageV2';
													name: Types.SportCompetitionStageName;
													number?: number | null;
												};
												season?: {
													__typename?: 'SportSeason';
													name: string;
													seasonID: number;
												} | null;
												venue?: {
													__typename?: 'SportVenue';
													venueID: number;
													name: string;
												} | null;
												pastEvents: Array<{
													__typename?: 'SingleStepSportEvent';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													sport: Types.SportType;
													competition?: {
														__typename?: 'SportCompetitionV2';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														sport: Types.SportType;
														content: {
															__typename?: 'SportCompetitionContentV2';
															fullPath: string;
															name: string;
														};
													} | null;
													competitors: {
														__typename?: 'SingleStepSportCompetitorsV2';
														homeTeam: {
															__typename?: 'SingleStepSportCompetitorV2';
															score?: number | null;
															competitors: Array<{
																__typename?: 'SportCompetitorV2';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																sport: Types.SportType;
																content: {
																	__typename?: 'SportCompetitorContentV2';
																	firstName: string;
																	fullPath?: string | null;
																	lastName: string;
																	name: string;
																	iconUrl?: string | null;
																};
															}>;
														};
														awayTeam: {
															__typename?: 'SingleStepSportCompetitorV2';
															score?: number | null;
															competitors: Array<{
																__typename?: 'SportCompetitorV2';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																sport: Types.SportType;
																content: {
																	__typename?: 'SportCompetitorContentV2';
																	firstName: string;
																	fullPath?: string | null;
																	lastName: string;
																	name: string;
																	iconUrl?: string | null;
																};
															}>;
														};
													};
													content: {
														__typename?: 'SingleStepSportEventContent';
														name: string;
														startAt: any;
														status: Types.SportEventStatus;
														season?: {
															__typename?: 'SportSeason';
															name: string;
															seasonID: number;
														} | null;
													};
												}>;
											};
											competitors: {
												__typename?: 'SingleStepSportCompetitorsV2';
												homeTeam: {
													__typename?: 'SingleStepSportCompetitorV2';
													score?: number | null;
													winner: boolean;
													competitors: Array<{
														__typename?: 'SportCompetitorV2';
														id: string;
														objectId: number;
														content: {
															__typename?: 'SportCompetitorContentV2';
															name: string;
															iconUrl?: string | null;
															fullPath?: string | null;
														};
													}>;
												};
												awayTeam: {
													__typename?: 'SingleStepSportCompetitorV2';
													score?: number | null;
													winner: boolean;
													competitors: Array<{
														__typename?: 'SportCompetitorV2';
														id: string;
														objectId: number;
														content: {
															__typename?: 'SportCompetitorContentV2';
															name: string;
															iconUrl?: string | null;
															fullPath?: string | null;
														};
													}>;
												};
											};
											offers: Array<{
												__typename?: 'SportOffer';
												monetizationType: Types.MonetizationType;
												presentationType: Types.PresentationType;
												audioLanguage?: string | null;
												standardWebURL?: string | null;
												sportObjectType: Types.SportObjectType;
												package: {
													__typename?: 'Package';
													id: string;
													packageId: number;
													technicalName: string;
													clearName: string;
													shortName: string;
													monetizationTypes: Array<Types.MonetizationType>;
												};
											}>;
									  }
								>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMSportsUpcomingFootball';
								moduleID: number;
								type: string;
								category: string;
								events: Array<
									| { __typename?: 'MultiStepSportEvent' }
									| {
											__typename: 'SingleStepSportEvent';
											id: string;
											sport: Types.SportType;
											objectType: Types.ObjectType;
											objectId: number;
											offerCount: number;
											mysportlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename?: 'SportOffer';
												standardWebURL?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												audioLanguage?: string | null;
												sportObjectType: Types.SportObjectType;
												package: {
													__typename?: 'Package';
													clearName: string;
													icon: string;
													iconBlurHash?: string | null;
													id: string;
													packageId: number;
													technicalName: string;
													shortName: string;
													monetizationTypes: Array<Types.MonetizationType>;
													iconWide: string;
												};
											} | null;
											competition?: {
												__typename?: 'SportCompetitionV2';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												sport: Types.SportType;
												content: {
													__typename?: 'SportCompetitionContentV2';
													fullPath: string;
													iconBlurHash?: string | null;
													iconUrl?: string | null;
													name: string;
												};
												activeSeason?: {
													__typename?: 'SportSeason';
													name: string;
													seasonID: number;
												} | null;
											} | null;
											content: {
												__typename?: 'SingleStepSportEventContent';
												endAt?: any | null;
												fullPath?: string | null;
												name: string;
												startAt: any;
												status: Types.SportEventStatus;
												competitionStage: {
													__typename?: 'SportCompetitionStageV2';
													name: Types.SportCompetitionStageName;
													number?: number | null;
												};
												season?: {
													__typename?: 'SportSeason';
													name: string;
													seasonID: number;
												} | null;
												venue?: {
													__typename?: 'SportVenue';
													venueID: number;
													name: string;
												} | null;
												pastEvents: Array<{
													__typename?: 'SingleStepSportEvent';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													sport: Types.SportType;
													competition?: {
														__typename?: 'SportCompetitionV2';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														sport: Types.SportType;
														content: {
															__typename?: 'SportCompetitionContentV2';
															fullPath: string;
															name: string;
														};
													} | null;
													competitors: {
														__typename?: 'SingleStepSportCompetitorsV2';
														homeTeam: {
															__typename?: 'SingleStepSportCompetitorV2';
															score?: number | null;
															competitors: Array<{
																__typename?: 'SportCompetitorV2';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																sport: Types.SportType;
																content: {
																	__typename?: 'SportCompetitorContentV2';
																	firstName: string;
																	fullPath?: string | null;
																	lastName: string;
																	name: string;
																	iconUrl?: string | null;
																};
															}>;
														};
														awayTeam: {
															__typename?: 'SingleStepSportCompetitorV2';
															score?: number | null;
															competitors: Array<{
																__typename?: 'SportCompetitorV2';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																sport: Types.SportType;
																content: {
																	__typename?: 'SportCompetitorContentV2';
																	firstName: string;
																	fullPath?: string | null;
																	lastName: string;
																	name: string;
																	iconUrl?: string | null;
																};
															}>;
														};
													};
													content: {
														__typename?: 'SingleStepSportEventContent';
														name: string;
														startAt: any;
														status: Types.SportEventStatus;
														season?: {
															__typename?: 'SportSeason';
															name: string;
															seasonID: number;
														} | null;
													};
												}>;
											};
											competitors: {
												__typename?: 'SingleStepSportCompetitorsV2';
												homeTeam: {
													__typename?: 'SingleStepSportCompetitorV2';
													score?: number | null;
													winner: boolean;
													competitors: Array<{
														__typename?: 'SportCompetitorV2';
														id: string;
														objectId: number;
														content: {
															__typename?: 'SportCompetitorContentV2';
															name: string;
															iconUrl?: string | null;
															fullPath?: string | null;
														};
													}>;
												};
												awayTeam: {
													__typename?: 'SingleStepSportCompetitorV2';
													score?: number | null;
													winner: boolean;
													competitors: Array<{
														__typename?: 'SportCompetitorV2';
														id: string;
														objectId: number;
														content: {
															__typename?: 'SportCompetitorContentV2';
															name: string;
															iconUrl?: string | null;
															fullPath?: string | null;
														};
													}>;
												};
											};
											offers: Array<{
												__typename?: 'SportOffer';
												monetizationType: Types.MonetizationType;
												presentationType: Types.PresentationType;
												audioLanguage?: string | null;
												standardWebURL?: string | null;
												sportObjectType: Types.SportObjectType;
												package: {
													__typename?: 'Package';
													id: string;
													packageId: number;
													technicalName: string;
													clearName: string;
													shortName: string;
													monetizationTypes: Array<Types.MonetizationType>;
												};
											}>;
									  }
								>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMSpotlight';
								moduleID: number;
								type: string;
								category: string;
								modules: Array<
									| { __typename?: 'HMAVOD' }
									| { __typename?: 'HMBecauseYouLikedTitle' }
									| { __typename?: 'HMContinueWatchingJWTV' }
									| { __typename?: 'HMFeatureRotator' }
									| { __typename?: 'HMHighlightArticle' }
									| { __typename?: 'HMNewPerPackageToday' }
									| { __typename?: 'HMPermanentAudience' }
									| { __typename?: 'HMSQTV' }
									| { __typename?: 'HMSportsLiveFootball' }
									| { __typename?: 'HMSportsUpcomingFootball' }
									| { __typename?: 'HMSpotlight' }
									| {
											__typename: 'HMSpotlightContinueWatching';
											moduleID: number;
											type: string;
											category: string;
											titles: Array<
												| {
														__typename: 'Movie';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenlistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														content: {
															__typename?: 'MovieContent';
															title: string;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															scoring: { __typename?: 'Scoring'; viral?: number | null };
														};
												  }
												| {
														__typename: 'Season';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														content: {
															__typename?: 'SeasonContent';
															seasonNumber: number;
															title: string;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															scoring: { __typename?: 'Scoring'; viral?: number | null };
														};
														show: {
															__typename: 'Show';
															id: string;
															objectType: Types.ObjectType;
															objectId: number;
															content: { __typename?: 'ShowContent'; title: string };
															watchlistEntryV2?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															likelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															dislikelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
														};
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
												| {
														__typename: 'Show';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														watchNextEpisode?: {
															__typename?: 'Episode';
															id: string;
															objectId: number;
															objectType: Types.ObjectType;
															offerCount: number;
															season: {
																__typename?: 'Season';
																id: string;
																content: {
																	__typename?: 'SeasonContent';
																	fullPath: string;
																	posterUrl?: string | null;
																};
																seenState: {
																	__typename?: 'ShowSeenState';
																	releasedEpisodeCount: number;
																	seenEpisodeCount: number;
																	progress: number;
																};
															};
															content: {
																__typename?: 'EpisodeContent';
																title: string;
																episodeNumber: number;
																seasonNumber: number;
																upcomingReleases?: Array<{
																	__typename?: 'UpcomingRelease';
																	releaseDate?: any | null;
																	label: Types.UpcomingReleaseLabel;
																}>;
															};
															watchNowOffer?: {
																__typename: 'Offer';
																id: string;
																standardWebURL?: string | null;
																preAffiliatedStandardWebURL?: string | null;
																streamUrl?: string | null;
																streamUrlExternalPlayer?: string | null;
																retailPrice?: string | null;
																retailPriceValue?: number | null;
																lastChangeRetailPriceValue?: number | null;
																currency?: string | null;
																presentationType: Types.PresentationType;
																monetizationType: Types.MonetizationType;
																availableTo?: any | null;
																dateCreated?: any | null;
																newElementCount?: number | null;
																package: {
																	__typename?: 'Package';
																	id: string;
																	icon: string;
																	packageId: number;
																	clearName: string;
																	shortName: string;
																	technicalName: string;
																	iconWide: string;
																	hasRectangularIcon: boolean;
																};
															} | null;
															show: { __typename?: 'Show'; id: string };
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														content: {
															__typename?: 'ShowContent';
															title: string;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															scoring: { __typename?: 'Scoring'; viral?: number | null };
														};
												  }
											>;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMSpotlightGoingViral';
											moduleID: number;
											type: string;
											category: string;
											titles: Array<
												| {
														__typename: 'Movie';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenlistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														content: {
															__typename?: 'MovieContent';
															title: string;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															scoring: { __typename?: 'Scoring'; viral?: number | null };
														};
												  }
												| {
														__typename: 'Season';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														content: {
															__typename?: 'SeasonContent';
															seasonNumber: number;
															title: string;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															scoring: { __typename?: 'Scoring'; viral?: number | null };
														};
														show: {
															__typename: 'Show';
															id: string;
															objectType: Types.ObjectType;
															objectId: number;
															content: { __typename?: 'ShowContent'; title: string };
															watchlistEntryV2?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															likelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															dislikelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
														};
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
												| {
														__typename: 'Show';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														watchNextEpisode?: {
															__typename?: 'Episode';
															id: string;
															objectId: number;
															objectType: Types.ObjectType;
															offerCount: number;
															season: {
																__typename?: 'Season';
																id: string;
																content: {
																	__typename?: 'SeasonContent';
																	fullPath: string;
																	posterUrl?: string | null;
																};
																seenState: {
																	__typename?: 'ShowSeenState';
																	releasedEpisodeCount: number;
																	seenEpisodeCount: number;
																	progress: number;
																};
															};
															content: {
																__typename?: 'EpisodeContent';
																title: string;
																episodeNumber: number;
																seasonNumber: number;
																upcomingReleases?: Array<{
																	__typename?: 'UpcomingRelease';
																	releaseDate?: any | null;
																	label: Types.UpcomingReleaseLabel;
																}>;
															};
															watchNowOffer?: {
																__typename: 'Offer';
																id: string;
																standardWebURL?: string | null;
																preAffiliatedStandardWebURL?: string | null;
																streamUrl?: string | null;
																streamUrlExternalPlayer?: string | null;
																retailPrice?: string | null;
																retailPriceValue?: number | null;
																lastChangeRetailPriceValue?: number | null;
																currency?: string | null;
																presentationType: Types.PresentationType;
																monetizationType: Types.MonetizationType;
																availableTo?: any | null;
																dateCreated?: any | null;
																newElementCount?: number | null;
																package: {
																	__typename?: 'Package';
																	id: string;
																	icon: string;
																	packageId: number;
																	clearName: string;
																	shortName: string;
																	technicalName: string;
																	iconWide: string;
																	hasRectangularIcon: boolean;
																};
															} | null;
															show: { __typename?: 'Show'; id: string };
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														content: {
															__typename?: 'ShowContent';
															title: string;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															scoring: { __typename?: 'Scoring'; viral?: number | null };
														};
												  }
											>;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMSpotlightNewOnYourWatchlist';
											moduleID: number;
											type: string;
											category: string;
											titles: Array<
												| {
														__typename: 'Movie';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														content: {
															__typename?: 'MovieContent';
															title: string;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															isReleased: boolean;
															upcomingReleases: Array<{
																__typename?: 'UpcomingRelease';
																releaseDate?: any | null;
															}>;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															scoring: { __typename?: 'Scoring'; viral?: number | null };
														};
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenlistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
												| {
														__typename: 'Season';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														content: {
															__typename?: 'SeasonContent';
															seasonNumber: number;
															title: string;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															isReleased: boolean;
															upcomingReleases: Array<{
																__typename?: 'UpcomingRelease';
																releaseDate?: any | null;
															}>;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															scoring: { __typename?: 'Scoring'; viral?: number | null };
														};
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														show: {
															__typename: 'Show';
															id: string;
															objectType: Types.ObjectType;
															objectId: number;
															content: { __typename?: 'ShowContent'; title: string };
															watchlistEntryV2?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															likelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															dislikelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
														};
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
												| {
														__typename: 'Show';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														content: {
															__typename?: 'ShowContent';
															title: string;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															isReleased: boolean;
															upcomingReleases: Array<{
																__typename?: 'UpcomingRelease';
																releaseDate?: any | null;
															}>;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															scoring: { __typename?: 'Scoring'; viral?: number | null };
														};
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														watchNextEpisode?: {
															__typename?: 'Episode';
															id: string;
															objectId: number;
															objectType: Types.ObjectType;
															offerCount: number;
															season: {
																__typename?: 'Season';
																id: string;
																content: {
																	__typename?: 'SeasonContent';
																	fullPath: string;
																	posterUrl?: string | null;
																};
																seenState: {
																	__typename?: 'ShowSeenState';
																	releasedEpisodeCount: number;
																	seenEpisodeCount: number;
																	progress: number;
																};
															};
															content: {
																__typename?: 'EpisodeContent';
																title: string;
																episodeNumber: number;
																seasonNumber: number;
																upcomingReleases?: Array<{
																	__typename?: 'UpcomingRelease';
																	releaseDate?: any | null;
																	label: Types.UpcomingReleaseLabel;
																}>;
															};
															watchNowOffer?: {
																__typename: 'Offer';
																id: string;
																standardWebURL?: string | null;
																preAffiliatedStandardWebURL?: string | null;
																streamUrl?: string | null;
																streamUrlExternalPlayer?: string | null;
																retailPrice?: string | null;
																retailPriceValue?: number | null;
																lastChangeRetailPriceValue?: number | null;
																currency?: string | null;
																presentationType: Types.PresentationType;
																monetizationType: Types.MonetizationType;
																availableTo?: any | null;
																dateCreated?: any | null;
																newElementCount?: number | null;
																package: {
																	__typename?: 'Package';
																	id: string;
																	icon: string;
																	packageId: number;
																	clearName: string;
																	shortName: string;
																	technicalName: string;
																	iconWide: string;
																	hasRectangularIcon: boolean;
																};
															} | null;
															show: { __typename?: 'Show'; id: string };
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
											>;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMSpotlightNewSimilarToLikedTitle';
											moduleID: number;
											type: string;
											category: string;
											likedTitle:
												| {
														__typename?: 'Movie';
														id: string;
														content: {
															__typename?: 'MovieContent';
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
														};
												  }
												| {
														__typename?: 'Season';
														id: string;
														content: {
															__typename?: 'SeasonContent';
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
														};
												  }
												| {
														__typename?: 'Show';
														id: string;
														content: {
															__typename?: 'ShowContent';
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
														};
												  };
											titles: Array<
												| {
														__typename: 'Movie';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														content: {
															__typename?: 'MovieContent';
															title: string;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															isReleased: boolean;
															upcomingReleases: Array<{
																__typename?: 'UpcomingRelease';
																releaseDate?: any | null;
															}>;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															scoring: { __typename?: 'Scoring'; viral?: number | null };
														};
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenlistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
												| {
														__typename: 'Season';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														content: {
															__typename?: 'SeasonContent';
															seasonNumber: number;
															title: string;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															isReleased: boolean;
															upcomingReleases: Array<{
																__typename?: 'UpcomingRelease';
																releaseDate?: any | null;
															}>;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															scoring: { __typename?: 'Scoring'; viral?: number | null };
														};
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														show: {
															__typename: 'Show';
															id: string;
															objectType: Types.ObjectType;
															objectId: number;
															content: { __typename?: 'ShowContent'; title: string };
															watchlistEntryV2?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															likelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															dislikelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
														};
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
												| {
														__typename: 'Show';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														content: {
															__typename?: 'ShowContent';
															title: string;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															isReleased: boolean;
															upcomingReleases: Array<{
																__typename?: 'UpcomingRelease';
																releaseDate?: any | null;
															}>;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															scoring: { __typename?: 'Scoring'; viral?: number | null };
														};
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														watchNextEpisode?: {
															__typename?: 'Episode';
															id: string;
															objectId: number;
															objectType: Types.ObjectType;
															offerCount: number;
															season: {
																__typename?: 'Season';
																id: string;
																content: {
																	__typename?: 'SeasonContent';
																	fullPath: string;
																	posterUrl?: string | null;
																};
																seenState: {
																	__typename?: 'ShowSeenState';
																	releasedEpisodeCount: number;
																	seenEpisodeCount: number;
																	progress: number;
																};
															};
															content: {
																__typename?: 'EpisodeContent';
																title: string;
																episodeNumber: number;
																seasonNumber: number;
																upcomingReleases?: Array<{
																	__typename?: 'UpcomingRelease';
																	releaseDate?: any | null;
																	label: Types.UpcomingReleaseLabel;
																}>;
															};
															watchNowOffer?: {
																__typename: 'Offer';
																id: string;
																standardWebURL?: string | null;
																preAffiliatedStandardWebURL?: string | null;
																streamUrl?: string | null;
																streamUrlExternalPlayer?: string | null;
																retailPrice?: string | null;
																retailPriceValue?: number | null;
																lastChangeRetailPriceValue?: number | null;
																currency?: string | null;
																presentationType: Types.PresentationType;
																monetizationType: Types.MonetizationType;
																availableTo?: any | null;
																dateCreated?: any | null;
																newElementCount?: number | null;
																package: {
																	__typename?: 'Package';
																	id: string;
																	icon: string;
																	packageId: number;
																	clearName: string;
																	shortName: string;
																	technicalName: string;
																	iconWide: string;
																	hasRectangularIcon: boolean;
																};
															} | null;
															show: { __typename?: 'Show'; id: string };
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
											>;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMSpotlightNewWithHighRatings';
											moduleID: number;
											type: string;
											category: string;
											titles: Array<
												| {
														__typename: 'Movie';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														content: {
															__typename?: 'MovieContent';
															title: string;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															isReleased: boolean;
															upcomingReleases: Array<{
																__typename?: 'UpcomingRelease';
																releaseDate?: any | null;
															}>;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															scoring: { __typename?: 'Scoring'; viral?: number | null };
														};
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenlistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
												| {
														__typename: 'Season';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														content: {
															__typename?: 'SeasonContent';
															seasonNumber: number;
															title: string;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															isReleased: boolean;
															upcomingReleases: Array<{
																__typename?: 'UpcomingRelease';
																releaseDate?: any | null;
															}>;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															scoring: { __typename?: 'Scoring'; viral?: number | null };
														};
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														show: {
															__typename: 'Show';
															id: string;
															objectType: Types.ObjectType;
															objectId: number;
															content: { __typename?: 'ShowContent'; title: string };
															watchlistEntryV2?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															likelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															dislikelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
														};
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
												| {
														__typename: 'Show';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														content: {
															__typename?: 'ShowContent';
															title: string;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															isReleased: boolean;
															upcomingReleases: Array<{
																__typename?: 'UpcomingRelease';
																releaseDate?: any | null;
															}>;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															scoring: { __typename?: 'Scoring'; viral?: number | null };
														};
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														watchNextEpisode?: {
															__typename?: 'Episode';
															id: string;
															objectId: number;
															objectType: Types.ObjectType;
															offerCount: number;
															season: {
																__typename?: 'Season';
																id: string;
																content: {
																	__typename?: 'SeasonContent';
																	fullPath: string;
																	posterUrl?: string | null;
																};
																seenState: {
																	__typename?: 'ShowSeenState';
																	releasedEpisodeCount: number;
																	seenEpisodeCount: number;
																	progress: number;
																};
															};
															content: {
																__typename?: 'EpisodeContent';
																title: string;
																episodeNumber: number;
																seasonNumber: number;
																upcomingReleases?: Array<{
																	__typename?: 'UpcomingRelease';
																	releaseDate?: any | null;
																	label: Types.UpcomingReleaseLabel;
																}>;
															};
															watchNowOffer?: {
																__typename: 'Offer';
																id: string;
																standardWebURL?: string | null;
																preAffiliatedStandardWebURL?: string | null;
																streamUrl?: string | null;
																streamUrlExternalPlayer?: string | null;
																retailPrice?: string | null;
																retailPriceValue?: number | null;
																lastChangeRetailPriceValue?: number | null;
																currency?: string | null;
																presentationType: Types.PresentationType;
																monetizationType: Types.MonetizationType;
																availableTo?: any | null;
																dateCreated?: any | null;
																newElementCount?: number | null;
																package: {
																	__typename?: 'Package';
																	id: string;
																	icon: string;
																	packageId: number;
																	clearName: string;
																	shortName: string;
																	technicalName: string;
																	iconWide: string;
																	hasRectangularIcon: boolean;
																};
															} | null;
															show: { __typename?: 'Show'; id: string };
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
											>;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| {
											__typename: 'HMSpotlightTrendingToday';
											moduleID: number;
											type: string;
											category: string;
											titles: Array<
												| {
														__typename: 'Movie';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenlistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														content: {
															__typename?: 'MovieContent';
															title: string;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															scoring: { __typename?: 'Scoring'; viral?: number | null };
														};
												  }
												| {
														__typename: 'Season';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														content: {
															__typename?: 'SeasonContent';
															seasonNumber: number;
															title: string;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															scoring: { __typename?: 'Scoring'; viral?: number | null };
														};
														show: {
															__typename: 'Show';
															id: string;
															objectType: Types.ObjectType;
															objectId: number;
															content: { __typename?: 'ShowContent'; title: string };
															watchlistEntryV2?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															likelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
															dislikelistEntry?: {
																__typename?: 'TitleListEntry';
																createdAt: any;
															} | null;
														};
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
												  }
												| {
														__typename: 'Show';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														customlistEntries: Array<{
															__typename?: 'TitleListEntry';
															createdAt: any;
														}>;
														seenState: {
															__typename?: 'ShowSeenState';
															seenEpisodeCount: number;
															releasedEpisodeCount: number;
															progress: number;
															caughtUp: boolean;
															lastSeenEpisodeNumber?: number | null;
															lastSeenSeasonNumber?: number | null;
														};
														watchNextEpisode?: {
															__typename?: 'Episode';
															id: string;
															objectId: number;
															objectType: Types.ObjectType;
															offerCount: number;
															season: {
																__typename?: 'Season';
																id: string;
																content: {
																	__typename?: 'SeasonContent';
																	fullPath: string;
																	posterUrl?: string | null;
																};
																seenState: {
																	__typename?: 'ShowSeenState';
																	releasedEpisodeCount: number;
																	seenEpisodeCount: number;
																	progress: number;
																};
															};
															content: {
																__typename?: 'EpisodeContent';
																title: string;
																episodeNumber: number;
																seasonNumber: number;
																upcomingReleases?: Array<{
																	__typename?: 'UpcomingRelease';
																	releaseDate?: any | null;
																	label: Types.UpcomingReleaseLabel;
																}>;
															};
															watchNowOffer?: {
																__typename: 'Offer';
																id: string;
																standardWebURL?: string | null;
																preAffiliatedStandardWebURL?: string | null;
																streamUrl?: string | null;
																streamUrlExternalPlayer?: string | null;
																retailPrice?: string | null;
																retailPriceValue?: number | null;
																lastChangeRetailPriceValue?: number | null;
																currency?: string | null;
																presentationType: Types.PresentationType;
																monetizationType: Types.MonetizationType;
																availableTo?: any | null;
																dateCreated?: any | null;
																newElementCount?: number | null;
																package: {
																	__typename?: 'Package';
																	id: string;
																	icon: string;
																	packageId: number;
																	clearName: string;
																	shortName: string;
																	technicalName: string;
																	iconWide: string;
																	hasRectangularIcon: boolean;
																};
															} | null;
															show: { __typename?: 'Show'; id: string };
														} | null;
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														content: {
															__typename?: 'ShowContent';
															title: string;
															originalReleaseYear?: number | null;
															runtime?: number | null;
															fullPath: string;
															posterUrl?: string | null;
															backdrops: Array<{
																__typename?: 'Backdrop';
																backdropUrl: string;
															}>;
															scoring: { __typename?: 'Scoring'; viral?: number | null };
														};
												  }
											>;
											translatables: {
												__typename?: 'ModuleTranslatables';
												title: string;
												badge: string;
											};
									  }
									| { __typename?: 'HMTVOD' }
									| { __typename?: 'HMTextRecommendation' }
									| { __typename?: 'HMTop3PerPackageToday' }
									| { __typename?: 'HMTop10InYourCountry' }
									| { __typename?: 'HMTopGenre' }
									| { __typename?: 'HMTopHighlightArticle' }
									| { __typename?: 'HMWatchedBySimilarUsers' }
									| null
								>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMSpotlightContinueWatching';
								moduleID: number;
								type: string;
								category: string;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMSpotlightGoingViral';
								moduleID: number;
								type: string;
								category: string;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMSpotlightNewOnYourWatchlist';
								moduleID: number;
								type: string;
								category: string;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMSpotlightNewSimilarToLikedTitle';
								moduleID: number;
								type: string;
								category: string;
								likedTitle:
									| {
											__typename?: 'Movie';
											id: string;
											content: {
												__typename?: 'MovieContent';
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											};
									  }
									| {
											__typename?: 'Season';
											id: string;
											content: {
												__typename?: 'SeasonContent';
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											};
									  }
									| {
											__typename?: 'Show';
											id: string;
											content: {
												__typename?: 'ShowContent';
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											};
									  };
								titles: Array<
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
									  }
									| {
											__typename: 'Season';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											content: {
												__typename?: 'SeasonContent';
												seasonNumber: number;
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
											show: {
												__typename: 'Show';
												id: string;
												objectType: Types.ObjectType;
												objectId: number;
												content: { __typename?: 'ShowContent'; title: string };
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											watchNextEpisode?: {
												__typename?: 'Episode';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												season: {
													__typename?: 'Season';
													id: string;
													content: {
														__typename?: 'SeasonContent';
														fullPath: string;
														posterUrl?: string | null;
													};
													seenState: {
														__typename?: 'ShowSeenState';
														releasedEpisodeCount: number;
														seenEpisodeCount: number;
														progress: number;
													};
												};
												content: {
													__typename?: 'EpisodeContent';
													title: string;
													episodeNumber: number;
													seasonNumber: number;
													upcomingReleases?: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														label: Types.UpcomingReleaseLabel;
													}>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												show: { __typename?: 'Show'; id: string };
											} | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'ShowContent';
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
									  }
								>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMSpotlightNewWithHighRatings';
								moduleID: number;
								type: string;
								category: string;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMSpotlightTrendingToday';
								moduleID: number;
								type: string;
								category: string;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMTVOD';
								moduleID: number;
								type: string;
								category: string;
								titles: Array<
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
									  }
									| {
											__typename: 'Season';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											content: {
												__typename?: 'SeasonContent';
												seasonNumber: number;
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
											show: {
												__typename: 'Show';
												id: string;
												objectType: Types.ObjectType;
												objectId: number;
												content: { __typename?: 'ShowContent'; title: string };
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											watchNextEpisode?: {
												__typename?: 'Episode';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												season: {
													__typename?: 'Season';
													id: string;
													content: {
														__typename?: 'SeasonContent';
														fullPath: string;
														posterUrl?: string | null;
													};
													seenState: {
														__typename?: 'ShowSeenState';
														releasedEpisodeCount: number;
														seenEpisodeCount: number;
														progress: number;
													};
												};
												content: {
													__typename?: 'EpisodeContent';
													title: string;
													episodeNumber: number;
													seasonNumber: number;
													upcomingReleases?: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														label: Types.UpcomingReleaseLabel;
													}>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												show: { __typename?: 'Show'; id: string };
											} | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'ShowContent';
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
									  }
								>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMTextRecommendation';
								moduleID: number;
								type: string;
								category: string;
								textRecommendation: {
									__typename: 'TextRecommendation';
									id: string;
									headline?: string | null;
									body: string;
									bodyHTML: string;
									originalHeadline?: string | null;
									originalBody?: string | null;
									originalBodyHTML?: string | null;
									watchIf?: Array<string> | null;
									skipIf?: Array<string> | null;
									customProfileType?: string | null;
									watchedAt: any;
									likeCount: number;
									likedByUser: boolean;
									ownedByUser: boolean;
									updatedAt: any;
									tags?: Array<{
										__typename?: 'Tag';
										technicalName: string;
										translatedName: string;
									}> | null;
									watchedOn?: {
										__typename?: 'Package';
										clearName: string;
										id: string;
										shortName: string;
										technicalName: string;
										packageId: number;
										selected: boolean;
										monetizationTypes: Array<Types.MonetizationType>;
										icon: string;
										isVisibleFilterBar: boolean;
										addonParent?: { __typename?: 'Package'; id: string } | null;
									} | null;
									profile: {
										__typename: 'Profile';
										displayName: string;
										firstName: string;
										lastName: string;
										location?: string | null;
										country: any;
										bio?: string | null;
										avatarUrl?: string | null;
										isComplete: boolean;
										ownedByUser: boolean;
										profileUrl: string;
										profileType: Types.ProfileType;
										contentPersonId?: string | null;
										textRecommendationsCount: number;
										id: string;
										externalUrls?: Array<{
											__typename?: 'ProfileSpecificLink';
											type: Types.ProfileSpecificLinkType;
											name?: string | null;
											url: string;
										}> | null;
									};
									title?:
										| {
												__typename: 'Movie';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												content: {
													__typename?: 'MovieContent';
													title: string;
													posterUrl?: string | null;
													fullPath: string;
													upcomingReleases: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														releaseCountDown?: number | null;
													}>;
													scoring: {
														__typename?: 'Scoring';
														imdbScore?: number | null;
														imdbVotes?: number | null;
														tmdbPopularity?: number | null;
														tmdbScore?: number | null;
														jwRating?: number | null;
														tomatoMeter?: number | null;
														certifiedFresh?: boolean | null;
													};
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												availableTo: Array<{
													__typename?: 'AvailableTo';
													availableToDate: any;
													availableCountDown: number;
												}>;
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												customlistEntries: Array<{
													__typename?: 'TitleListEntry';
													createdAt: any;
												}>;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
										  }
										| {
												__typename: 'Season';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												content: {
													__typename?: 'SeasonContent';
													seasonNumber: number;
													title: string;
													posterUrl?: string | null;
													fullPath: string;
													upcomingReleases: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														releaseCountDown?: number | null;
													}>;
													scoring: {
														__typename?: 'Scoring';
														imdbScore?: number | null;
														imdbVotes?: number | null;
														tmdbPopularity?: number | null;
														tmdbScore?: number | null;
														jwRating?: number | null;
														tomatoMeter?: number | null;
														certifiedFresh?: boolean | null;
													};
												};
												show: {
													__typename: 'Show';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													content: {
														__typename?: 'ShowContent';
														title: string;
														fullPath: string;
													};
													watchNowOffer?: {
														__typename: 'Offer';
														id: string;
														standardWebURL?: string | null;
														preAffiliatedStandardWebURL?: string | null;
														streamUrl?: string | null;
														streamUrlExternalPlayer?: string | null;
														retailPrice?: string | null;
														retailPriceValue?: number | null;
														lastChangeRetailPriceValue?: number | null;
														currency?: string | null;
														presentationType: Types.PresentationType;
														monetizationType: Types.MonetizationType;
														availableTo?: any | null;
														dateCreated?: any | null;
														newElementCount?: number | null;
														package: {
															__typename?: 'Package';
															id: string;
															icon: string;
															packageId: number;
															clearName: string;
															shortName: string;
															technicalName: string;
															iconWide: string;
															hasRectangularIcon: boolean;
														};
													} | null;
													watchlistEntryV2?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													seenState: { __typename?: 'ShowSeenState'; progress: number };
													tvShowTrackingEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													customlistEntries: Array<{
														__typename?: 'TitleListEntry';
														createdAt: any;
													}>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												availableTo: Array<{
													__typename?: 'AvailableTo';
													availableToDate: any;
													availableCountDown: number;
												}>;
												seenState: { __typename?: 'ShowSeenState'; progress: number };
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
										  }
										| {
												__typename: 'Show';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												content: {
													__typename?: 'ShowContent';
													title: string;
													posterUrl?: string | null;
													fullPath: string;
													upcomingReleases: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														releaseCountDown?: number | null;
													}>;
													scoring: {
														__typename?: 'Scoring';
														imdbScore?: number | null;
														imdbVotes?: number | null;
														tmdbPopularity?: number | null;
														tmdbScore?: number | null;
														jwRating?: number | null;
														tomatoMeter?: number | null;
														certifiedFresh?: boolean | null;
													};
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												availableTo: Array<{
													__typename?: 'AvailableTo';
													availableToDate: any;
													availableCountDown: number;
												}>;
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												customlistEntries: Array<{
													__typename?: 'TitleListEntry';
													createdAt: any;
												}>;
												seenState: { __typename?: 'ShowSeenState'; progress: number };
												tvShowTrackingEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
										  };
									video?: {
										__typename?: 'Clip';
										externalId: string;
										name: string;
										provider: Types.ClipProvider;
										publishedAt: any;
										sourceUrl: string;
										streamUrl?: string | null;
									} | null;
								};
								title:
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
									  }
									| {
											__typename: 'Season';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											content: {
												__typename?: 'SeasonContent';
												seasonNumber: number;
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
											show: {
												__typename: 'Show';
												id: string;
												objectType: Types.ObjectType;
												objectId: number;
												content: { __typename?: 'ShowContent'; title: string };
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											watchNextEpisode?: {
												__typename?: 'Episode';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												season: {
													__typename?: 'Season';
													id: string;
													content: {
														__typename?: 'SeasonContent';
														fullPath: string;
														posterUrl?: string | null;
													};
													seenState: {
														__typename?: 'ShowSeenState';
														releasedEpisodeCount: number;
														seenEpisodeCount: number;
														progress: number;
													};
												};
												content: {
													__typename?: 'EpisodeContent';
													title: string;
													episodeNumber: number;
													seasonNumber: number;
													upcomingReleases?: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														label: Types.UpcomingReleaseLabel;
													}>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												show: { __typename?: 'Show'; id: string };
											} | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'ShowContent';
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
									  };
								authorProfile: {
									__typename: 'ProfileV2';
									id: string;
									content: {
										__typename?: 'ProfileContent';
										displayName: string;
										location?: string | null;
										bio?: string | null;
										avatarUrl?: string | null;
										ownedByUser: boolean;
										profileUrl: string;
										profileType: Types.ProfileType;
										externalUrls?: Array<{
											__typename?: 'ProfileSpecificLink';
											type: Types.ProfileSpecificLinkType;
											name?: string | null;
											url: string;
										}> | null;
									};
								};
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMTop3PerPackageToday';
								moduleID: number;
								type: string;
								category: string;
								packagesWithTitles: Array<{
									__typename?: 'PackageTitles';
									package: {
										__typename?: 'Package';
										id: string;
										clearName: string;
										shortName: string;
										packageId: number;
									};
									titlesWithTrend: Array<{
										__typename?: 'TitleWithTrend';
										trend: Types.TitleTrend;
										title:
											| {
													__typename: 'Movie';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													offerCount: number;
													watchlistEntryV2?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													likelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													dislikelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													customlistEntries: Array<{
														__typename?: 'TitleListEntry';
														createdAt: any;
													}>;
													seenlistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													watchNowOffer?: {
														__typename: 'Offer';
														id: string;
														standardWebURL?: string | null;
														preAffiliatedStandardWebURL?: string | null;
														streamUrl?: string | null;
														streamUrlExternalPlayer?: string | null;
														retailPrice?: string | null;
														retailPriceValue?: number | null;
														lastChangeRetailPriceValue?: number | null;
														currency?: string | null;
														presentationType: Types.PresentationType;
														monetizationType: Types.MonetizationType;
														availableTo?: any | null;
														dateCreated?: any | null;
														newElementCount?: number | null;
														package: {
															__typename?: 'Package';
															id: string;
															icon: string;
															packageId: number;
															clearName: string;
															shortName: string;
															technicalName: string;
															iconWide: string;
															hasRectangularIcon: boolean;
														};
													} | null;
													content: {
														__typename?: 'MovieContent';
														title: string;
														originalReleaseYear?: number | null;
														runtime?: number | null;
														fullPath: string;
														posterUrl?: string | null;
														backdrops: Array<{
															__typename?: 'Backdrop';
															backdropUrl: string;
														}>;
														scoring: { __typename?: 'Scoring'; viral?: number | null };
													};
											  }
											| {
													__typename: 'Season';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													offerCount: number;
													seenState: {
														__typename?: 'ShowSeenState';
														seenEpisodeCount: number;
														releasedEpisodeCount: number;
														progress: number;
														caughtUp: boolean;
														lastSeenEpisodeNumber?: number | null;
														lastSeenSeasonNumber?: number | null;
													};
													content: {
														__typename?: 'SeasonContent';
														seasonNumber: number;
														title: string;
														originalReleaseYear?: number | null;
														runtime?: number | null;
														fullPath: string;
														posterUrl?: string | null;
														backdrops: Array<{
															__typename?: 'Backdrop';
															backdropUrl: string;
														}>;
														scoring: { __typename?: 'Scoring'; viral?: number | null };
													};
													show: {
														__typename: 'Show';
														id: string;
														objectType: Types.ObjectType;
														objectId: number;
														content: { __typename?: 'ShowContent'; title: string };
														watchlistEntryV2?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														likelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
														dislikelistEntry?: {
															__typename?: 'TitleListEntry';
															createdAt: any;
														} | null;
													};
													watchNowOffer?: {
														__typename: 'Offer';
														id: string;
														standardWebURL?: string | null;
														preAffiliatedStandardWebURL?: string | null;
														streamUrl?: string | null;
														streamUrlExternalPlayer?: string | null;
														retailPrice?: string | null;
														retailPriceValue?: number | null;
														lastChangeRetailPriceValue?: number | null;
														currency?: string | null;
														presentationType: Types.PresentationType;
														monetizationType: Types.MonetizationType;
														availableTo?: any | null;
														dateCreated?: any | null;
														newElementCount?: number | null;
														package: {
															__typename?: 'Package';
															id: string;
															icon: string;
															packageId: number;
															clearName: string;
															shortName: string;
															technicalName: string;
															iconWide: string;
															hasRectangularIcon: boolean;
														};
													} | null;
											  }
											| {
													__typename: 'Show';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													offerCount: number;
													watchlistEntryV2?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													likelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													dislikelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													customlistEntries: Array<{
														__typename?: 'TitleListEntry';
														createdAt: any;
													}>;
													seenState: {
														__typename?: 'ShowSeenState';
														seenEpisodeCount: number;
														releasedEpisodeCount: number;
														progress: number;
														caughtUp: boolean;
														lastSeenEpisodeNumber?: number | null;
														lastSeenSeasonNumber?: number | null;
													};
													watchNextEpisode?: {
														__typename?: 'Episode';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														offerCount: number;
														season: {
															__typename?: 'Season';
															id: string;
															content: {
																__typename?: 'SeasonContent';
																fullPath: string;
																posterUrl?: string | null;
															};
															seenState: {
																__typename?: 'ShowSeenState';
																releasedEpisodeCount: number;
																seenEpisodeCount: number;
																progress: number;
															};
														};
														content: {
															__typename?: 'EpisodeContent';
															title: string;
															episodeNumber: number;
															seasonNumber: number;
															upcomingReleases?: Array<{
																__typename?: 'UpcomingRelease';
																releaseDate?: any | null;
																label: Types.UpcomingReleaseLabel;
															}>;
														};
														watchNowOffer?: {
															__typename: 'Offer';
															id: string;
															standardWebURL?: string | null;
															preAffiliatedStandardWebURL?: string | null;
															streamUrl?: string | null;
															streamUrlExternalPlayer?: string | null;
															retailPrice?: string | null;
															retailPriceValue?: number | null;
															lastChangeRetailPriceValue?: number | null;
															currency?: string | null;
															presentationType: Types.PresentationType;
															monetizationType: Types.MonetizationType;
															availableTo?: any | null;
															dateCreated?: any | null;
															newElementCount?: number | null;
															package: {
																__typename?: 'Package';
																id: string;
																icon: string;
																packageId: number;
																clearName: string;
																shortName: string;
																technicalName: string;
																iconWide: string;
																hasRectangularIcon: boolean;
															};
														} | null;
														show: { __typename?: 'Show'; id: string };
													} | null;
													watchNowOffer?: {
														__typename: 'Offer';
														id: string;
														standardWebURL?: string | null;
														preAffiliatedStandardWebURL?: string | null;
														streamUrl?: string | null;
														streamUrlExternalPlayer?: string | null;
														retailPrice?: string | null;
														retailPriceValue?: number | null;
														lastChangeRetailPriceValue?: number | null;
														currency?: string | null;
														presentationType: Types.PresentationType;
														monetizationType: Types.MonetizationType;
														availableTo?: any | null;
														dateCreated?: any | null;
														newElementCount?: number | null;
														package: {
															__typename?: 'Package';
															id: string;
															icon: string;
															packageId: number;
															clearName: string;
															shortName: string;
															technicalName: string;
															iconWide: string;
															hasRectangularIcon: boolean;
														};
													} | null;
													content: {
														__typename?: 'ShowContent';
														title: string;
														originalReleaseYear?: number | null;
														runtime?: number | null;
														fullPath: string;
														posterUrl?: string | null;
														backdrops: Array<{
															__typename?: 'Backdrop';
															backdropUrl: string;
														}>;
														scoring: { __typename?: 'Scoring'; viral?: number | null };
													};
											  };
									}>;
								}>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMTop10InYourCountry';
								moduleID: number;
								type: string;
								category: string;
								titles: Array<
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
									  }
									| {
											__typename: 'Season';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											content: {
												__typename?: 'SeasonContent';
												seasonNumber: number;
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
											show: {
												__typename: 'Show';
												id: string;
												objectType: Types.ObjectType;
												objectId: number;
												content: { __typename?: 'ShowContent'; title: string };
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											watchNextEpisode?: {
												__typename?: 'Episode';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												season: {
													__typename?: 'Season';
													id: string;
													content: {
														__typename?: 'SeasonContent';
														fullPath: string;
														posterUrl?: string | null;
													};
													seenState: {
														__typename?: 'ShowSeenState';
														releasedEpisodeCount: number;
														seenEpisodeCount: number;
														progress: number;
													};
												};
												content: {
													__typename?: 'EpisodeContent';
													title: string;
													episodeNumber: number;
													seasonNumber: number;
													upcomingReleases?: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														label: Types.UpcomingReleaseLabel;
													}>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												show: { __typename?: 'Show'; id: string };
											} | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'ShowContent';
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
									  }
								>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMTopGenre';
								category: string;
								moduleID: number;
								type: string;
								titles: Array<
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
									  }
									| {
											__typename: 'Season';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											content: {
												__typename?: 'SeasonContent';
												seasonNumber: number;
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
											show: {
												__typename: 'Show';
												id: string;
												objectType: Types.ObjectType;
												objectId: number;
												content: { __typename?: 'ShowContent'; title: string };
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											watchNextEpisode?: {
												__typename?: 'Episode';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												season: {
													__typename?: 'Season';
													id: string;
													content: {
														__typename?: 'SeasonContent';
														fullPath: string;
														posterUrl?: string | null;
													};
													seenState: {
														__typename?: 'ShowSeenState';
														releasedEpisodeCount: number;
														seenEpisodeCount: number;
														progress: number;
													};
												};
												content: {
													__typename?: 'EpisodeContent';
													title: string;
													episodeNumber: number;
													seasonNumber: number;
													upcomingReleases?: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														label: Types.UpcomingReleaseLabel;
													}>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												show: { __typename?: 'Show'; id: string };
											} | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'ShowContent';
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
									  }
								>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMTopHighlightArticle';
								moduleID: number;
								type: string;
								category: string;
								titles: Array<
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											appleTVPlusOffers: Array<{
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											}>;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
									  }
									| {
											__typename: 'Season';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											appleTVPlusOffers: Array<{
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											}>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											content: {
												__typename?: 'SeasonContent';
												seasonNumber: number;
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
											show: {
												__typename: 'Show';
												id: string;
												objectType: Types.ObjectType;
												objectId: number;
												content: { __typename?: 'ShowContent'; title: string };
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											appleTVPlusOffers: Array<{
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											}>;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											watchNextEpisode?: {
												__typename?: 'Episode';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												season: {
													__typename?: 'Season';
													id: string;
													content: {
														__typename?: 'SeasonContent';
														fullPath: string;
														posterUrl?: string | null;
													};
													seenState: {
														__typename?: 'ShowSeenState';
														releasedEpisodeCount: number;
														seenEpisodeCount: number;
														progress: number;
													};
												};
												content: {
													__typename?: 'EpisodeContent';
													title: string;
													episodeNumber: number;
													seasonNumber: number;
													upcomingReleases?: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														label: Types.UpcomingReleaseLabel;
													}>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												show: { __typename?: 'Show'; id: string };
											} | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'ShowContent';
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
									  }
								>;
								article: {
									__typename?: 'Article';
									id: string;
									author: {
										__typename?: 'Author';
										id: string;
										content: {
											__typename?: 'AuthorContent';
											bio: string;
											clearName: string;
											imageUrl?: string | null;
											fullPath: string;
											alumniOf: Array<string>;
											brand: string;
											languagesSpoken: Array<any>;
											occupation: Array<string>;
											publications?: Array<{
												__typename?: 'AuthorSpecificLink';
												name: string;
												url: string;
											}> | null;
											socialHandles?: Array<{
												__typename?: 'AuthorSpecificLink';
												name: string;
												url: string;
											}> | null;
										};
									};
									content: {
										__typename: 'ArticleContent';
										id: number;
										title?: string | null;
										fullPath: string;
										highlightLabel?: string | null;
										highlightTitle?: string | null;
									};
									linkedObjects: Array<{
										__typename?: 'ArticleLinkedObject';
										node:
											| { __typename?: 'Article' }
											| { __typename?: 'Author' }
											| { __typename?: 'Bundle' }
											| { __typename?: 'Device' }
											| { __typename?: 'Episode' }
											| {
													__typename?: 'GenericTitleList';
													id: string;
													followedlistEntry?: {
														__typename?: 'FollowedListEntry';
														createdAt: any;
														name: string;
													} | null;
											  }
											| { __typename?: 'Genre' }
											| { __typename?: 'HomePage' }
											| { __typename?: 'Movie' }
											| { __typename?: 'MultiStepSportEvent' }
											| { __typename?: 'Offer' }
											| { __typename?: 'OfferHistory' }
											| { __typename?: 'Package' }
											| { __typename?: 'Page' }
											| { __typename?: 'Person' }
											| { __typename?: 'ProfileV2' }
											| { __typename?: 'Season' }
											| { __typename?: 'Show' }
											| { __typename?: 'SingleStepSportEvent' }
											| { __typename?: 'SportCompetitionV2' }
											| { __typename?: 'SportCompetitorV2' }
											| { __typename?: 'SportMatch' }
											| { __typename?: 'Url' };
									}>;
								};
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| {
								__typename: 'HMWatchedBySimilarUsers';
								moduleID: number;
								type: string;
								category: string;
								titles: Array<
									| {
											__typename: 'Movie';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'MovieContent';
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
									  }
									| {
											__typename: 'Season';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											content: {
												__typename?: 'SeasonContent';
												seasonNumber: number;
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
											show: {
												__typename: 'Show';
												id: string;
												objectType: Types.ObjectType;
												objectId: number;
												content: { __typename?: 'ShowContent'; title: string };
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												likelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												dislikelistEntry?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
									  }
									| {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
											seenState: {
												__typename?: 'ShowSeenState';
												seenEpisodeCount: number;
												releasedEpisodeCount: number;
												progress: number;
												caughtUp: boolean;
												lastSeenEpisodeNumber?: number | null;
												lastSeenSeasonNumber?: number | null;
											};
											watchNextEpisode?: {
												__typename?: 'Episode';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												offerCount: number;
												season: {
													__typename?: 'Season';
													id: string;
													content: {
														__typename?: 'SeasonContent';
														fullPath: string;
														posterUrl?: string | null;
													};
													seenState: {
														__typename?: 'ShowSeenState';
														releasedEpisodeCount: number;
														seenEpisodeCount: number;
														progress: number;
													};
												};
												content: {
													__typename?: 'EpisodeContent';
													title: string;
													episodeNumber: number;
													seasonNumber: number;
													upcomingReleases?: Array<{
														__typename?: 'UpcomingRelease';
														releaseDate?: any | null;
														label: Types.UpcomingReleaseLabel;
													}>;
												};
												watchNowOffer?: {
													__typename: 'Offer';
													id: string;
													standardWebURL?: string | null;
													preAffiliatedStandardWebURL?: string | null;
													streamUrl?: string | null;
													streamUrlExternalPlayer?: string | null;
													retailPrice?: string | null;
													retailPriceValue?: number | null;
													lastChangeRetailPriceValue?: number | null;
													currency?: string | null;
													presentationType: Types.PresentationType;
													monetizationType: Types.MonetizationType;
													availableTo?: any | null;
													dateCreated?: any | null;
													newElementCount?: number | null;
													package: {
														__typename?: 'Package';
														id: string;
														icon: string;
														packageId: number;
														clearName: string;
														shortName: string;
														technicalName: string;
														iconWide: string;
														hasRectangularIcon: boolean;
													};
												} | null;
												show: { __typename?: 'Show'; id: string };
											} | null;
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											content: {
												__typename?: 'ShowContent';
												title: string;
												originalReleaseYear?: number | null;
												runtime?: number | null;
												fullPath: string;
												posterUrl?: string | null;
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												scoring: { __typename?: 'Scoring'; viral?: number | null };
											};
									  }
								>;
								translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
						  }
						| null
					>;
			  }
			| { __typename?: 'Movie' }
			| { __typename?: 'MultiStepSportEvent' }
			| { __typename?: 'Offer' }
			| { __typename?: 'OfferHistory' }
			| { __typename?: 'Package' }
			| { __typename?: 'Page' }
			| { __typename?: 'Person' }
			| { __typename?: 'ProfileV2' }
			| { __typename?: 'Season' }
			| { __typename?: 'Show' }
			| { __typename?: 'SingleStepSportEvent' }
			| { __typename?: 'SportCompetitionV2' }
			| { __typename?: 'SportCompetitorV2' }
			| { __typename?: 'SportMatch' }
			| { __typename?: 'Url' };
	};
};

export type HomeModulesFragment = {
	__typename: 'HomePage';
	id: string;
	modules: Array<
		| {
				__typename: 'HMAVOD';
				moduleID: number;
				type: string;
				category: string;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMBecauseYouLikedTitle';
				moduleID: number;
				type: string;
				category: string;
				likedTitle:
					| {
							__typename?: 'Movie';
							id: string;
							content: {
								__typename?: 'MovieContent';
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							};
					  }
					| {
							__typename?: 'Season';
							id: string;
							content: {
								__typename?: 'SeasonContent';
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							};
					  }
					| {
							__typename?: 'Show';
							id: string;
							content: {
								__typename?: 'ShowContent';
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							};
					  };
				titles: Array<
					| {
							__typename: 'Movie';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							content: {
								__typename?: 'MovieContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
					  }
					| {
							__typename: 'Season';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							content: {
								__typename?: 'SeasonContent';
								seasonNumber: number;
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
							show: {
								__typename: 'Show';
								id: string;
								objectType: Types.ObjectType;
								objectId: number;
								content: { __typename?: 'ShowContent'; title: string };
								watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							};
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
					  }
					| {
							__typename: 'Show';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							watchNextEpisode?: {
								__typename?: 'Episode';
								id: string;
								objectId: number;
								objectType: Types.ObjectType;
								offerCount: number;
								season: {
									__typename?: 'Season';
									id: string;
									content: {
										__typename?: 'SeasonContent';
										fullPath: string;
										posterUrl?: string | null;
									};
									seenState: {
										__typename?: 'ShowSeenState';
										releasedEpisodeCount: number;
										seenEpisodeCount: number;
										progress: number;
									};
								};
								content: {
									__typename?: 'EpisodeContent';
									title: string;
									episodeNumber: number;
									seasonNumber: number;
									upcomingReleases?: Array<{
										__typename?: 'UpcomingRelease';
										releaseDate?: any | null;
										label: Types.UpcomingReleaseLabel;
									}>;
								};
								watchNowOffer?: {
									__typename: 'Offer';
									id: string;
									standardWebURL?: string | null;
									preAffiliatedStandardWebURL?: string | null;
									streamUrl?: string | null;
									streamUrlExternalPlayer?: string | null;
									retailPrice?: string | null;
									retailPriceValue?: number | null;
									lastChangeRetailPriceValue?: number | null;
									currency?: string | null;
									presentationType: Types.PresentationType;
									monetizationType: Types.MonetizationType;
									availableTo?: any | null;
									dateCreated?: any | null;
									newElementCount?: number | null;
									package: {
										__typename?: 'Package';
										id: string;
										icon: string;
										packageId: number;
										clearName: string;
										shortName: string;
										technicalName: string;
										iconWide: string;
										hasRectangularIcon: boolean;
									};
								} | null;
								show: { __typename?: 'Show'; id: string };
							} | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							content: {
								__typename?: 'ShowContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
					  }
				>;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMContinueWatchingJWTV';
				moduleID: number;
				type: string;
				category: string;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMFeatureRotator';
				moduleID: number;
				type: string;
				category: string;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMHighlightArticle';
				moduleID: number;
				type: string;
				category: string;
				titles: Array<
					| {
							__typename: 'Movie';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							appleTVPlusOffers: Array<{
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							}>;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							content: {
								__typename?: 'MovieContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
					  }
					| {
							__typename: 'Season';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							appleTVPlusOffers: Array<{
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							}>;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							content: {
								__typename?: 'SeasonContent';
								seasonNumber: number;
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
							show: {
								__typename: 'Show';
								id: string;
								objectType: Types.ObjectType;
								objectId: number;
								content: { __typename?: 'ShowContent'; title: string };
								watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							};
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
					  }
					| {
							__typename: 'Show';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							appleTVPlusOffers: Array<{
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							}>;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							watchNextEpisode?: {
								__typename?: 'Episode';
								id: string;
								objectId: number;
								objectType: Types.ObjectType;
								offerCount: number;
								season: {
									__typename?: 'Season';
									id: string;
									content: {
										__typename?: 'SeasonContent';
										fullPath: string;
										posterUrl?: string | null;
									};
									seenState: {
										__typename?: 'ShowSeenState';
										releasedEpisodeCount: number;
										seenEpisodeCount: number;
										progress: number;
									};
								};
								content: {
									__typename?: 'EpisodeContent';
									title: string;
									episodeNumber: number;
									seasonNumber: number;
									upcomingReleases?: Array<{
										__typename?: 'UpcomingRelease';
										releaseDate?: any | null;
										label: Types.UpcomingReleaseLabel;
									}>;
								};
								watchNowOffer?: {
									__typename: 'Offer';
									id: string;
									standardWebURL?: string | null;
									preAffiliatedStandardWebURL?: string | null;
									streamUrl?: string | null;
									streamUrlExternalPlayer?: string | null;
									retailPrice?: string | null;
									retailPriceValue?: number | null;
									lastChangeRetailPriceValue?: number | null;
									currency?: string | null;
									presentationType: Types.PresentationType;
									monetizationType: Types.MonetizationType;
									availableTo?: any | null;
									dateCreated?: any | null;
									newElementCount?: number | null;
									package: {
										__typename?: 'Package';
										id: string;
										icon: string;
										packageId: number;
										clearName: string;
										shortName: string;
										technicalName: string;
										iconWide: string;
										hasRectangularIcon: boolean;
									};
								} | null;
								show: { __typename?: 'Show'; id: string };
							} | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							content: {
								__typename?: 'ShowContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
					  }
				>;
				article: {
					__typename?: 'Article';
					id: string;
					author: {
						__typename?: 'Author';
						id: string;
						content: {
							__typename?: 'AuthorContent';
							bio: string;
							clearName: string;
							imageUrl?: string | null;
							fullPath: string;
							alumniOf: Array<string>;
							brand: string;
							languagesSpoken: Array<any>;
							occupation: Array<string>;
							publications?: Array<{
								__typename?: 'AuthorSpecificLink';
								name: string;
								url: string;
							}> | null;
							socialHandles?: Array<{
								__typename?: 'AuthorSpecificLink';
								name: string;
								url: string;
							}> | null;
						};
					};
					content: {
						__typename: 'ArticleContent';
						id: number;
						title?: string | null;
						fullPath: string;
						highlightLabel?: string | null;
						highlightTitle?: string | null;
					};
					linkedObjects: Array<{
						__typename?: 'ArticleLinkedObject';
						node:
							| { __typename?: 'Article' }
							| { __typename?: 'Author' }
							| { __typename?: 'Bundle' }
							| { __typename?: 'Device' }
							| { __typename?: 'Episode' }
							| {
									__typename?: 'GenericTitleList';
									id: string;
									followedlistEntry?: {
										__typename?: 'FollowedListEntry';
										createdAt: any;
										name: string;
									} | null;
							  }
							| { __typename?: 'Genre' }
							| { __typename?: 'HomePage' }
							| { __typename?: 'Movie' }
							| { __typename?: 'MultiStepSportEvent' }
							| { __typename?: 'Offer' }
							| { __typename?: 'OfferHistory' }
							| { __typename?: 'Package' }
							| { __typename?: 'Page' }
							| { __typename?: 'Person' }
							| { __typename?: 'ProfileV2' }
							| { __typename?: 'Season' }
							| { __typename?: 'Show' }
							| { __typename?: 'SingleStepSportEvent' }
							| { __typename?: 'SportCompetitionV2' }
							| { __typename?: 'SportCompetitorV2' }
							| { __typename?: 'SportMatch' }
							| { __typename?: 'Url' };
					}>;
				};
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMNewPerPackageToday';
				moduleID: number;
				type: string;
				category: string;
				packagesWithTitles: Array<{
					__typename?: 'PackageTitles';
					package: {
						__typename?: 'Package';
						id: string;
						clearName: string;
						shortName: string;
						packageId: number;
					};
					titlesWithTrend: Array<{
						__typename?: 'TitleWithTrend';
						trend: Types.TitleTrend;
						title:
							| {
									__typename: 'Movie';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									offerCount: number;
									watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
									seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									watchNowOffer?: {
										__typename: 'Offer';
										id: string;
										standardWebURL?: string | null;
										preAffiliatedStandardWebURL?: string | null;
										streamUrl?: string | null;
										streamUrlExternalPlayer?: string | null;
										retailPrice?: string | null;
										retailPriceValue?: number | null;
										lastChangeRetailPriceValue?: number | null;
										currency?: string | null;
										presentationType: Types.PresentationType;
										monetizationType: Types.MonetizationType;
										availableTo?: any | null;
										dateCreated?: any | null;
										newElementCount?: number | null;
										package: {
											__typename?: 'Package';
											id: string;
											icon: string;
											packageId: number;
											clearName: string;
											shortName: string;
											technicalName: string;
											iconWide: string;
											hasRectangularIcon: boolean;
										};
									} | null;
									content: {
										__typename?: 'MovieContent';
										title: string;
										originalReleaseYear?: number | null;
										runtime?: number | null;
										fullPath: string;
										posterUrl?: string | null;
										backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
										scoring: { __typename?: 'Scoring'; viral?: number | null };
									};
							  }
							| {
									__typename: 'Season';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									offerCount: number;
									seenState: {
										__typename?: 'ShowSeenState';
										seenEpisodeCount: number;
										releasedEpisodeCount: number;
										progress: number;
										caughtUp: boolean;
										lastSeenEpisodeNumber?: number | null;
										lastSeenSeasonNumber?: number | null;
									};
									content: {
										__typename?: 'SeasonContent';
										seasonNumber: number;
										title: string;
										originalReleaseYear?: number | null;
										runtime?: number | null;
										fullPath: string;
										posterUrl?: string | null;
										backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
										scoring: { __typename?: 'Scoring'; viral?: number | null };
									};
									show: {
										__typename: 'Show';
										id: string;
										objectType: Types.ObjectType;
										objectId: number;
										content: { __typename?: 'ShowContent'; title: string };
										watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									};
									watchNowOffer?: {
										__typename: 'Offer';
										id: string;
										standardWebURL?: string | null;
										preAffiliatedStandardWebURL?: string | null;
										streamUrl?: string | null;
										streamUrlExternalPlayer?: string | null;
										retailPrice?: string | null;
										retailPriceValue?: number | null;
										lastChangeRetailPriceValue?: number | null;
										currency?: string | null;
										presentationType: Types.PresentationType;
										monetizationType: Types.MonetizationType;
										availableTo?: any | null;
										dateCreated?: any | null;
										newElementCount?: number | null;
										package: {
											__typename?: 'Package';
											id: string;
											icon: string;
											packageId: number;
											clearName: string;
											shortName: string;
											technicalName: string;
											iconWide: string;
											hasRectangularIcon: boolean;
										};
									} | null;
							  }
							| {
									__typename: 'Show';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									offerCount: number;
									watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
									seenState: {
										__typename?: 'ShowSeenState';
										seenEpisodeCount: number;
										releasedEpisodeCount: number;
										progress: number;
										caughtUp: boolean;
										lastSeenEpisodeNumber?: number | null;
										lastSeenSeasonNumber?: number | null;
									};
									watchNextEpisode?: {
										__typename?: 'Episode';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										offerCount: number;
										season: {
											__typename?: 'Season';
											id: string;
											content: {
												__typename?: 'SeasonContent';
												fullPath: string;
												posterUrl?: string | null;
											};
											seenState: {
												__typename?: 'ShowSeenState';
												releasedEpisodeCount: number;
												seenEpisodeCount: number;
												progress: number;
											};
										};
										content: {
											__typename?: 'EpisodeContent';
											title: string;
											episodeNumber: number;
											seasonNumber: number;
											upcomingReleases?: Array<{
												__typename?: 'UpcomingRelease';
												releaseDate?: any | null;
												label: Types.UpcomingReleaseLabel;
											}>;
										};
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
										show: { __typename?: 'Show'; id: string };
									} | null;
									watchNowOffer?: {
										__typename: 'Offer';
										id: string;
										standardWebURL?: string | null;
										preAffiliatedStandardWebURL?: string | null;
										streamUrl?: string | null;
										streamUrlExternalPlayer?: string | null;
										retailPrice?: string | null;
										retailPriceValue?: number | null;
										lastChangeRetailPriceValue?: number | null;
										currency?: string | null;
										presentationType: Types.PresentationType;
										monetizationType: Types.MonetizationType;
										availableTo?: any | null;
										dateCreated?: any | null;
										newElementCount?: number | null;
										package: {
											__typename?: 'Package';
											id: string;
											icon: string;
											packageId: number;
											clearName: string;
											shortName: string;
											technicalName: string;
											iconWide: string;
											hasRectangularIcon: boolean;
										};
									} | null;
									content: {
										__typename?: 'ShowContent';
										title: string;
										originalReleaseYear?: number | null;
										runtime?: number | null;
										fullPath: string;
										posterUrl?: string | null;
										backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
										scoring: { __typename?: 'Scoring'; viral?: number | null };
									};
							  };
					}>;
				}>;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMPermanentAudience';
				category: string;
				moduleID: number;
				type: string;
				titles: Array<
					| {
							__typename: 'Movie';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							content: {
								__typename?: 'MovieContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
					  }
					| {
							__typename: 'Season';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							content: {
								__typename?: 'SeasonContent';
								seasonNumber: number;
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
							show: {
								__typename: 'Show';
								id: string;
								objectType: Types.ObjectType;
								objectId: number;
								content: { __typename?: 'ShowContent'; title: string };
								watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							};
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
					  }
					| {
							__typename: 'Show';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							watchNextEpisode?: {
								__typename?: 'Episode';
								id: string;
								objectId: number;
								objectType: Types.ObjectType;
								offerCount: number;
								season: {
									__typename?: 'Season';
									id: string;
									content: {
										__typename?: 'SeasonContent';
										fullPath: string;
										posterUrl?: string | null;
									};
									seenState: {
										__typename?: 'ShowSeenState';
										releasedEpisodeCount: number;
										seenEpisodeCount: number;
										progress: number;
									};
								};
								content: {
									__typename?: 'EpisodeContent';
									title: string;
									episodeNumber: number;
									seasonNumber: number;
									upcomingReleases?: Array<{
										__typename?: 'UpcomingRelease';
										releaseDate?: any | null;
										label: Types.UpcomingReleaseLabel;
									}>;
								};
								watchNowOffer?: {
									__typename: 'Offer';
									id: string;
									standardWebURL?: string | null;
									preAffiliatedStandardWebURL?: string | null;
									streamUrl?: string | null;
									streamUrlExternalPlayer?: string | null;
									retailPrice?: string | null;
									retailPriceValue?: number | null;
									lastChangeRetailPriceValue?: number | null;
									currency?: string | null;
									presentationType: Types.PresentationType;
									monetizationType: Types.MonetizationType;
									availableTo?: any | null;
									dateCreated?: any | null;
									newElementCount?: number | null;
									package: {
										__typename?: 'Package';
										id: string;
										icon: string;
										packageId: number;
										clearName: string;
										shortName: string;
										technicalName: string;
										iconWide: string;
										hasRectangularIcon: boolean;
									};
								} | null;
								show: { __typename?: 'Show'; id: string };
							} | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							content: {
								__typename?: 'ShowContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
					  }
				>;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMSQTV';
				moduleID: number;
				type: string;
				category: string;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMSportsLiveFootball';
				moduleID: number;
				type: string;
				category: string;
				events: Array<
					| { __typename?: 'MultiStepSportEvent' }
					| {
							__typename: 'SingleStepSportEvent';
							id: string;
							sport: Types.SportType;
							objectType: Types.ObjectType;
							objectId: number;
							offerCount: number;
							mysportlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							watchNowOffer?: {
								__typename?: 'SportOffer';
								standardWebURL?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								audioLanguage?: string | null;
								sportObjectType: Types.SportObjectType;
								package: {
									__typename?: 'Package';
									clearName: string;
									icon: string;
									iconBlurHash?: string | null;
									id: string;
									packageId: number;
									technicalName: string;
									shortName: string;
									monetizationTypes: Array<Types.MonetizationType>;
									iconWide: string;
								};
							} | null;
							competition?: {
								__typename?: 'SportCompetitionV2';
								id: string;
								objectId: number;
								objectType: Types.ObjectType;
								sport: Types.SportType;
								content: {
									__typename?: 'SportCompetitionContentV2';
									fullPath: string;
									iconBlurHash?: string | null;
									iconUrl?: string | null;
									name: string;
								};
								activeSeason?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
							} | null;
							content: {
								__typename?: 'SingleStepSportEventContent';
								endAt?: any | null;
								fullPath?: string | null;
								name: string;
								startAt: any;
								status: Types.SportEventStatus;
								competitionStage: {
									__typename?: 'SportCompetitionStageV2';
									name: Types.SportCompetitionStageName;
									number?: number | null;
								};
								season?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
								venue?: { __typename?: 'SportVenue'; venueID: number; name: string } | null;
								pastEvents: Array<{
									__typename?: 'SingleStepSportEvent';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									sport: Types.SportType;
									competition?: {
										__typename?: 'SportCompetitionV2';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										sport: Types.SportType;
										content: {
											__typename?: 'SportCompetitionContentV2';
											fullPath: string;
											name: string;
										};
									} | null;
									competitors: {
										__typename?: 'SingleStepSportCompetitorsV2';
										homeTeam: {
											__typename?: 'SingleStepSportCompetitorV2';
											score?: number | null;
											competitors: Array<{
												__typename?: 'SportCompetitorV2';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												sport: Types.SportType;
												content: {
													__typename?: 'SportCompetitorContentV2';
													firstName: string;
													fullPath?: string | null;
													lastName: string;
													name: string;
													iconUrl?: string | null;
												};
											}>;
										};
										awayTeam: {
											__typename?: 'SingleStepSportCompetitorV2';
											score?: number | null;
											competitors: Array<{
												__typename?: 'SportCompetitorV2';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												sport: Types.SportType;
												content: {
													__typename?: 'SportCompetitorContentV2';
													firstName: string;
													fullPath?: string | null;
													lastName: string;
													name: string;
													iconUrl?: string | null;
												};
											}>;
										};
									};
									content: {
										__typename?: 'SingleStepSportEventContent';
										name: string;
										startAt: any;
										status: Types.SportEventStatus;
										season?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
									};
								}>;
							};
							competitors: {
								__typename?: 'SingleStepSportCompetitorsV2';
								homeTeam: {
									__typename?: 'SingleStepSportCompetitorV2';
									score?: number | null;
									winner: boolean;
									competitors: Array<{
										__typename?: 'SportCompetitorV2';
										id: string;
										objectId: number;
										content: {
											__typename?: 'SportCompetitorContentV2';
											name: string;
											iconUrl?: string | null;
											fullPath?: string | null;
										};
									}>;
								};
								awayTeam: {
									__typename?: 'SingleStepSportCompetitorV2';
									score?: number | null;
									winner: boolean;
									competitors: Array<{
										__typename?: 'SportCompetitorV2';
										id: string;
										objectId: number;
										content: {
											__typename?: 'SportCompetitorContentV2';
											name: string;
											iconUrl?: string | null;
											fullPath?: string | null;
										};
									}>;
								};
							};
							offers: Array<{
								__typename?: 'SportOffer';
								monetizationType: Types.MonetizationType;
								presentationType: Types.PresentationType;
								audioLanguage?: string | null;
								standardWebURL?: string | null;
								sportObjectType: Types.SportObjectType;
								package: {
									__typename?: 'Package';
									id: string;
									packageId: number;
									technicalName: string;
									clearName: string;
									shortName: string;
									monetizationTypes: Array<Types.MonetizationType>;
								};
							}>;
					  }
				>;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMSportsUpcomingFootball';
				moduleID: number;
				type: string;
				category: string;
				events: Array<
					| { __typename?: 'MultiStepSportEvent' }
					| {
							__typename: 'SingleStepSportEvent';
							id: string;
							sport: Types.SportType;
							objectType: Types.ObjectType;
							objectId: number;
							offerCount: number;
							mysportlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							watchNowOffer?: {
								__typename?: 'SportOffer';
								standardWebURL?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								audioLanguage?: string | null;
								sportObjectType: Types.SportObjectType;
								package: {
									__typename?: 'Package';
									clearName: string;
									icon: string;
									iconBlurHash?: string | null;
									id: string;
									packageId: number;
									technicalName: string;
									shortName: string;
									monetizationTypes: Array<Types.MonetizationType>;
									iconWide: string;
								};
							} | null;
							competition?: {
								__typename?: 'SportCompetitionV2';
								id: string;
								objectId: number;
								objectType: Types.ObjectType;
								sport: Types.SportType;
								content: {
									__typename?: 'SportCompetitionContentV2';
									fullPath: string;
									iconBlurHash?: string | null;
									iconUrl?: string | null;
									name: string;
								};
								activeSeason?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
							} | null;
							content: {
								__typename?: 'SingleStepSportEventContent';
								endAt?: any | null;
								fullPath?: string | null;
								name: string;
								startAt: any;
								status: Types.SportEventStatus;
								competitionStage: {
									__typename?: 'SportCompetitionStageV2';
									name: Types.SportCompetitionStageName;
									number?: number | null;
								};
								season?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
								venue?: { __typename?: 'SportVenue'; venueID: number; name: string } | null;
								pastEvents: Array<{
									__typename?: 'SingleStepSportEvent';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									sport: Types.SportType;
									competition?: {
										__typename?: 'SportCompetitionV2';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										sport: Types.SportType;
										content: {
											__typename?: 'SportCompetitionContentV2';
											fullPath: string;
											name: string;
										};
									} | null;
									competitors: {
										__typename?: 'SingleStepSportCompetitorsV2';
										homeTeam: {
											__typename?: 'SingleStepSportCompetitorV2';
											score?: number | null;
											competitors: Array<{
												__typename?: 'SportCompetitorV2';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												sport: Types.SportType;
												content: {
													__typename?: 'SportCompetitorContentV2';
													firstName: string;
													fullPath?: string | null;
													lastName: string;
													name: string;
													iconUrl?: string | null;
												};
											}>;
										};
										awayTeam: {
											__typename?: 'SingleStepSportCompetitorV2';
											score?: number | null;
											competitors: Array<{
												__typename?: 'SportCompetitorV2';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												sport: Types.SportType;
												content: {
													__typename?: 'SportCompetitorContentV2';
													firstName: string;
													fullPath?: string | null;
													lastName: string;
													name: string;
													iconUrl?: string | null;
												};
											}>;
										};
									};
									content: {
										__typename?: 'SingleStepSportEventContent';
										name: string;
										startAt: any;
										status: Types.SportEventStatus;
										season?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
									};
								}>;
							};
							competitors: {
								__typename?: 'SingleStepSportCompetitorsV2';
								homeTeam: {
									__typename?: 'SingleStepSportCompetitorV2';
									score?: number | null;
									winner: boolean;
									competitors: Array<{
										__typename?: 'SportCompetitorV2';
										id: string;
										objectId: number;
										content: {
											__typename?: 'SportCompetitorContentV2';
											name: string;
											iconUrl?: string | null;
											fullPath?: string | null;
										};
									}>;
								};
								awayTeam: {
									__typename?: 'SingleStepSportCompetitorV2';
									score?: number | null;
									winner: boolean;
									competitors: Array<{
										__typename?: 'SportCompetitorV2';
										id: string;
										objectId: number;
										content: {
											__typename?: 'SportCompetitorContentV2';
											name: string;
											iconUrl?: string | null;
											fullPath?: string | null;
										};
									}>;
								};
							};
							offers: Array<{
								__typename?: 'SportOffer';
								monetizationType: Types.MonetizationType;
								presentationType: Types.PresentationType;
								audioLanguage?: string | null;
								standardWebURL?: string | null;
								sportObjectType: Types.SportObjectType;
								package: {
									__typename?: 'Package';
									id: string;
									packageId: number;
									technicalName: string;
									clearName: string;
									shortName: string;
									monetizationTypes: Array<Types.MonetizationType>;
								};
							}>;
					  }
				>;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMSpotlight';
				moduleID: number;
				type: string;
				category: string;
				modules: Array<
					| { __typename?: 'HMAVOD' }
					| { __typename?: 'HMBecauseYouLikedTitle' }
					| { __typename?: 'HMContinueWatchingJWTV' }
					| { __typename?: 'HMFeatureRotator' }
					| { __typename?: 'HMHighlightArticle' }
					| { __typename?: 'HMNewPerPackageToday' }
					| { __typename?: 'HMPermanentAudience' }
					| { __typename?: 'HMSQTV' }
					| { __typename?: 'HMSportsLiveFootball' }
					| { __typename?: 'HMSportsUpcomingFootball' }
					| { __typename?: 'HMSpotlight' }
					| {
							__typename: 'HMSpotlightContinueWatching';
							moduleID: number;
							type: string;
							category: string;
							titles: Array<
								| {
										__typename: 'Movie';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										offerCount: number;
										watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
										seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
										content: {
											__typename?: 'MovieContent';
											title: string;
											originalReleaseYear?: number | null;
											runtime?: number | null;
											fullPath: string;
											posterUrl?: string | null;
											backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											scoring: { __typename?: 'Scoring'; viral?: number | null };
										};
								  }
								| {
										__typename: 'Season';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										offerCount: number;
										seenState: {
											__typename?: 'ShowSeenState';
											seenEpisodeCount: number;
											releasedEpisodeCount: number;
											progress: number;
											caughtUp: boolean;
											lastSeenEpisodeNumber?: number | null;
											lastSeenSeasonNumber?: number | null;
										};
										content: {
											__typename?: 'SeasonContent';
											seasonNumber: number;
											title: string;
											originalReleaseYear?: number | null;
											runtime?: number | null;
											fullPath: string;
											posterUrl?: string | null;
											backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											scoring: { __typename?: 'Scoring'; viral?: number | null };
										};
										show: {
											__typename: 'Show';
											id: string;
											objectType: Types.ObjectType;
											objectId: number;
											content: { __typename?: 'ShowContent'; title: string };
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										};
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
								  }
								| {
										__typename: 'Show';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										offerCount: number;
										watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
										seenState: {
											__typename?: 'ShowSeenState';
											seenEpisodeCount: number;
											releasedEpisodeCount: number;
											progress: number;
											caughtUp: boolean;
											lastSeenEpisodeNumber?: number | null;
											lastSeenSeasonNumber?: number | null;
										};
										watchNextEpisode?: {
											__typename?: 'Episode';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											season: {
												__typename?: 'Season';
												id: string;
												content: {
													__typename?: 'SeasonContent';
													fullPath: string;
													posterUrl?: string | null;
												};
												seenState: {
													__typename?: 'ShowSeenState';
													releasedEpisodeCount: number;
													seenEpisodeCount: number;
													progress: number;
												};
											};
											content: {
												__typename?: 'EpisodeContent';
												title: string;
												episodeNumber: number;
												seasonNumber: number;
												upcomingReleases?: Array<{
													__typename?: 'UpcomingRelease';
													releaseDate?: any | null;
													label: Types.UpcomingReleaseLabel;
												}>;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											show: { __typename?: 'Show'; id: string };
										} | null;
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
										content: {
											__typename?: 'ShowContent';
											title: string;
											originalReleaseYear?: number | null;
											runtime?: number | null;
											fullPath: string;
											posterUrl?: string | null;
											backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											scoring: { __typename?: 'Scoring'; viral?: number | null };
										};
								  }
							>;
							translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
					  }
					| {
							__typename: 'HMSpotlightGoingViral';
							moduleID: number;
							type: string;
							category: string;
							titles: Array<
								| {
										__typename: 'Movie';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										offerCount: number;
										watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
										seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
										content: {
											__typename?: 'MovieContent';
											title: string;
											originalReleaseYear?: number | null;
											runtime?: number | null;
											fullPath: string;
											posterUrl?: string | null;
											backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											scoring: { __typename?: 'Scoring'; viral?: number | null };
										};
								  }
								| {
										__typename: 'Season';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										offerCount: number;
										seenState: {
											__typename?: 'ShowSeenState';
											seenEpisodeCount: number;
											releasedEpisodeCount: number;
											progress: number;
											caughtUp: boolean;
											lastSeenEpisodeNumber?: number | null;
											lastSeenSeasonNumber?: number | null;
										};
										content: {
											__typename?: 'SeasonContent';
											seasonNumber: number;
											title: string;
											originalReleaseYear?: number | null;
											runtime?: number | null;
											fullPath: string;
											posterUrl?: string | null;
											backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											scoring: { __typename?: 'Scoring'; viral?: number | null };
										};
										show: {
											__typename: 'Show';
											id: string;
											objectType: Types.ObjectType;
											objectId: number;
											content: { __typename?: 'ShowContent'; title: string };
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										};
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
								  }
								| {
										__typename: 'Show';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										offerCount: number;
										watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
										seenState: {
											__typename?: 'ShowSeenState';
											seenEpisodeCount: number;
											releasedEpisodeCount: number;
											progress: number;
											caughtUp: boolean;
											lastSeenEpisodeNumber?: number | null;
											lastSeenSeasonNumber?: number | null;
										};
										watchNextEpisode?: {
											__typename?: 'Episode';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											season: {
												__typename?: 'Season';
												id: string;
												content: {
													__typename?: 'SeasonContent';
													fullPath: string;
													posterUrl?: string | null;
												};
												seenState: {
													__typename?: 'ShowSeenState';
													releasedEpisodeCount: number;
													seenEpisodeCount: number;
													progress: number;
												};
											};
											content: {
												__typename?: 'EpisodeContent';
												title: string;
												episodeNumber: number;
												seasonNumber: number;
												upcomingReleases?: Array<{
													__typename?: 'UpcomingRelease';
													releaseDate?: any | null;
													label: Types.UpcomingReleaseLabel;
												}>;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											show: { __typename?: 'Show'; id: string };
										} | null;
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
										content: {
											__typename?: 'ShowContent';
											title: string;
											originalReleaseYear?: number | null;
											runtime?: number | null;
											fullPath: string;
											posterUrl?: string | null;
											backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											scoring: { __typename?: 'Scoring'; viral?: number | null };
										};
								  }
							>;
							translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
					  }
					| {
							__typename: 'HMSpotlightNewOnYourWatchlist';
							moduleID: number;
							type: string;
							category: string;
							titles: Array<
								| {
										__typename: 'Movie';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										offerCount: number;
										content: {
											__typename?: 'MovieContent';
											title: string;
											originalReleaseYear?: number | null;
											runtime?: number | null;
											fullPath: string;
											posterUrl?: string | null;
											isReleased: boolean;
											upcomingReleases: Array<{
												__typename?: 'UpcomingRelease';
												releaseDate?: any | null;
											}>;
											backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											scoring: { __typename?: 'Scoring'; viral?: number | null };
										};
										watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
										seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
								  }
								| {
										__typename: 'Season';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										offerCount: number;
										content: {
											__typename?: 'SeasonContent';
											seasonNumber: number;
											title: string;
											originalReleaseYear?: number | null;
											runtime?: number | null;
											fullPath: string;
											posterUrl?: string | null;
											isReleased: boolean;
											upcomingReleases: Array<{
												__typename?: 'UpcomingRelease';
												releaseDate?: any | null;
											}>;
											backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											scoring: { __typename?: 'Scoring'; viral?: number | null };
										};
										seenState: {
											__typename?: 'ShowSeenState';
											seenEpisodeCount: number;
											releasedEpisodeCount: number;
											progress: number;
											caughtUp: boolean;
											lastSeenEpisodeNumber?: number | null;
											lastSeenSeasonNumber?: number | null;
										};
										show: {
											__typename: 'Show';
											id: string;
											objectType: Types.ObjectType;
											objectId: number;
											content: { __typename?: 'ShowContent'; title: string };
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										};
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
								  }
								| {
										__typename: 'Show';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										offerCount: number;
										content: {
											__typename?: 'ShowContent';
											title: string;
											originalReleaseYear?: number | null;
											runtime?: number | null;
											fullPath: string;
											posterUrl?: string | null;
											isReleased: boolean;
											upcomingReleases: Array<{
												__typename?: 'UpcomingRelease';
												releaseDate?: any | null;
											}>;
											backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											scoring: { __typename?: 'Scoring'; viral?: number | null };
										};
										watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
										seenState: {
											__typename?: 'ShowSeenState';
											seenEpisodeCount: number;
											releasedEpisodeCount: number;
											progress: number;
											caughtUp: boolean;
											lastSeenEpisodeNumber?: number | null;
											lastSeenSeasonNumber?: number | null;
										};
										watchNextEpisode?: {
											__typename?: 'Episode';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											season: {
												__typename?: 'Season';
												id: string;
												content: {
													__typename?: 'SeasonContent';
													fullPath: string;
													posterUrl?: string | null;
												};
												seenState: {
													__typename?: 'ShowSeenState';
													releasedEpisodeCount: number;
													seenEpisodeCount: number;
													progress: number;
												};
											};
											content: {
												__typename?: 'EpisodeContent';
												title: string;
												episodeNumber: number;
												seasonNumber: number;
												upcomingReleases?: Array<{
													__typename?: 'UpcomingRelease';
													releaseDate?: any | null;
													label: Types.UpcomingReleaseLabel;
												}>;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											show: { __typename?: 'Show'; id: string };
										} | null;
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
								  }
							>;
							translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
					  }
					| {
							__typename: 'HMSpotlightNewSimilarToLikedTitle';
							moduleID: number;
							type: string;
							category: string;
							likedTitle:
								| {
										__typename?: 'Movie';
										id: string;
										content: {
											__typename?: 'MovieContent';
											backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
										};
								  }
								| {
										__typename?: 'Season';
										id: string;
										content: {
											__typename?: 'SeasonContent';
											backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
										};
								  }
								| {
										__typename?: 'Show';
										id: string;
										content: {
											__typename?: 'ShowContent';
											backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
										};
								  };
							titles: Array<
								| {
										__typename: 'Movie';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										offerCount: number;
										content: {
											__typename?: 'MovieContent';
											title: string;
											originalReleaseYear?: number | null;
											runtime?: number | null;
											fullPath: string;
											posterUrl?: string | null;
											isReleased: boolean;
											upcomingReleases: Array<{
												__typename?: 'UpcomingRelease';
												releaseDate?: any | null;
											}>;
											backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											scoring: { __typename?: 'Scoring'; viral?: number | null };
										};
										watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
										seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
								  }
								| {
										__typename: 'Season';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										offerCount: number;
										content: {
											__typename?: 'SeasonContent';
											seasonNumber: number;
											title: string;
											originalReleaseYear?: number | null;
											runtime?: number | null;
											fullPath: string;
											posterUrl?: string | null;
											isReleased: boolean;
											upcomingReleases: Array<{
												__typename?: 'UpcomingRelease';
												releaseDate?: any | null;
											}>;
											backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											scoring: { __typename?: 'Scoring'; viral?: number | null };
										};
										seenState: {
											__typename?: 'ShowSeenState';
											seenEpisodeCount: number;
											releasedEpisodeCount: number;
											progress: number;
											caughtUp: boolean;
											lastSeenEpisodeNumber?: number | null;
											lastSeenSeasonNumber?: number | null;
										};
										show: {
											__typename: 'Show';
											id: string;
											objectType: Types.ObjectType;
											objectId: number;
											content: { __typename?: 'ShowContent'; title: string };
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										};
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
								  }
								| {
										__typename: 'Show';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										offerCount: number;
										content: {
											__typename?: 'ShowContent';
											title: string;
											originalReleaseYear?: number | null;
											runtime?: number | null;
											fullPath: string;
											posterUrl?: string | null;
											isReleased: boolean;
											upcomingReleases: Array<{
												__typename?: 'UpcomingRelease';
												releaseDate?: any | null;
											}>;
											backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											scoring: { __typename?: 'Scoring'; viral?: number | null };
										};
										watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
										seenState: {
											__typename?: 'ShowSeenState';
											seenEpisodeCount: number;
											releasedEpisodeCount: number;
											progress: number;
											caughtUp: boolean;
											lastSeenEpisodeNumber?: number | null;
											lastSeenSeasonNumber?: number | null;
										};
										watchNextEpisode?: {
											__typename?: 'Episode';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											season: {
												__typename?: 'Season';
												id: string;
												content: {
													__typename?: 'SeasonContent';
													fullPath: string;
													posterUrl?: string | null;
												};
												seenState: {
													__typename?: 'ShowSeenState';
													releasedEpisodeCount: number;
													seenEpisodeCount: number;
													progress: number;
												};
											};
											content: {
												__typename?: 'EpisodeContent';
												title: string;
												episodeNumber: number;
												seasonNumber: number;
												upcomingReleases?: Array<{
													__typename?: 'UpcomingRelease';
													releaseDate?: any | null;
													label: Types.UpcomingReleaseLabel;
												}>;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											show: { __typename?: 'Show'; id: string };
										} | null;
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
								  }
							>;
							translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
					  }
					| {
							__typename: 'HMSpotlightNewWithHighRatings';
							moduleID: number;
							type: string;
							category: string;
							titles: Array<
								| {
										__typename: 'Movie';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										offerCount: number;
										content: {
											__typename?: 'MovieContent';
											title: string;
											originalReleaseYear?: number | null;
											runtime?: number | null;
											fullPath: string;
											posterUrl?: string | null;
											isReleased: boolean;
											upcomingReleases: Array<{
												__typename?: 'UpcomingRelease';
												releaseDate?: any | null;
											}>;
											backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											scoring: { __typename?: 'Scoring'; viral?: number | null };
										};
										watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
										seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
								  }
								| {
										__typename: 'Season';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										offerCount: number;
										content: {
											__typename?: 'SeasonContent';
											seasonNumber: number;
											title: string;
											originalReleaseYear?: number | null;
											runtime?: number | null;
											fullPath: string;
											posterUrl?: string | null;
											isReleased: boolean;
											upcomingReleases: Array<{
												__typename?: 'UpcomingRelease';
												releaseDate?: any | null;
											}>;
											backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											scoring: { __typename?: 'Scoring'; viral?: number | null };
										};
										seenState: {
											__typename?: 'ShowSeenState';
											seenEpisodeCount: number;
											releasedEpisodeCount: number;
											progress: number;
											caughtUp: boolean;
											lastSeenEpisodeNumber?: number | null;
											lastSeenSeasonNumber?: number | null;
										};
										show: {
											__typename: 'Show';
											id: string;
											objectType: Types.ObjectType;
											objectId: number;
											content: { __typename?: 'ShowContent'; title: string };
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										};
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
								  }
								| {
										__typename: 'Show';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										offerCount: number;
										content: {
											__typename?: 'ShowContent';
											title: string;
											originalReleaseYear?: number | null;
											runtime?: number | null;
											fullPath: string;
											posterUrl?: string | null;
											isReleased: boolean;
											upcomingReleases: Array<{
												__typename?: 'UpcomingRelease';
												releaseDate?: any | null;
											}>;
											backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											scoring: { __typename?: 'Scoring'; viral?: number | null };
										};
										watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
										seenState: {
											__typename?: 'ShowSeenState';
											seenEpisodeCount: number;
											releasedEpisodeCount: number;
											progress: number;
											caughtUp: boolean;
											lastSeenEpisodeNumber?: number | null;
											lastSeenSeasonNumber?: number | null;
										};
										watchNextEpisode?: {
											__typename?: 'Episode';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											season: {
												__typename?: 'Season';
												id: string;
												content: {
													__typename?: 'SeasonContent';
													fullPath: string;
													posterUrl?: string | null;
												};
												seenState: {
													__typename?: 'ShowSeenState';
													releasedEpisodeCount: number;
													seenEpisodeCount: number;
													progress: number;
												};
											};
											content: {
												__typename?: 'EpisodeContent';
												title: string;
												episodeNumber: number;
												seasonNumber: number;
												upcomingReleases?: Array<{
													__typename?: 'UpcomingRelease';
													releaseDate?: any | null;
													label: Types.UpcomingReleaseLabel;
												}>;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											show: { __typename?: 'Show'; id: string };
										} | null;
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
								  }
							>;
							translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
					  }
					| {
							__typename: 'HMSpotlightTrendingToday';
							moduleID: number;
							type: string;
							category: string;
							titles: Array<
								| {
										__typename: 'Movie';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										offerCount: number;
										watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
										seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
										content: {
											__typename?: 'MovieContent';
											title: string;
											originalReleaseYear?: number | null;
											runtime?: number | null;
											fullPath: string;
											posterUrl?: string | null;
											backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											scoring: { __typename?: 'Scoring'; viral?: number | null };
										};
								  }
								| {
										__typename: 'Season';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										offerCount: number;
										seenState: {
											__typename?: 'ShowSeenState';
											seenEpisodeCount: number;
											releasedEpisodeCount: number;
											progress: number;
											caughtUp: boolean;
											lastSeenEpisodeNumber?: number | null;
											lastSeenSeasonNumber?: number | null;
										};
										content: {
											__typename?: 'SeasonContent';
											seasonNumber: number;
											title: string;
											originalReleaseYear?: number | null;
											runtime?: number | null;
											fullPath: string;
											posterUrl?: string | null;
											backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											scoring: { __typename?: 'Scoring'; viral?: number | null };
										};
										show: {
											__typename: 'Show';
											id: string;
											objectType: Types.ObjectType;
											objectId: number;
											content: { __typename?: 'ShowContent'; title: string };
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										};
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
								  }
								| {
										__typename: 'Show';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										offerCount: number;
										watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
										seenState: {
											__typename?: 'ShowSeenState';
											seenEpisodeCount: number;
											releasedEpisodeCount: number;
											progress: number;
											caughtUp: boolean;
											lastSeenEpisodeNumber?: number | null;
											lastSeenSeasonNumber?: number | null;
										};
										watchNextEpisode?: {
											__typename?: 'Episode';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											offerCount: number;
											season: {
												__typename?: 'Season';
												id: string;
												content: {
													__typename?: 'SeasonContent';
													fullPath: string;
													posterUrl?: string | null;
												};
												seenState: {
													__typename?: 'ShowSeenState';
													releasedEpisodeCount: number;
													seenEpisodeCount: number;
													progress: number;
												};
											};
											content: {
												__typename?: 'EpisodeContent';
												title: string;
												episodeNumber: number;
												seasonNumber: number;
												upcomingReleases?: Array<{
													__typename?: 'UpcomingRelease';
													releaseDate?: any | null;
													label: Types.UpcomingReleaseLabel;
												}>;
											};
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											show: { __typename?: 'Show'; id: string };
										} | null;
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
										content: {
											__typename?: 'ShowContent';
											title: string;
											originalReleaseYear?: number | null;
											runtime?: number | null;
											fullPath: string;
											posterUrl?: string | null;
											backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											scoring: { __typename?: 'Scoring'; viral?: number | null };
										};
								  }
							>;
							translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
					  }
					| { __typename?: 'HMTVOD' }
					| { __typename?: 'HMTextRecommendation' }
					| { __typename?: 'HMTop3PerPackageToday' }
					| { __typename?: 'HMTop10InYourCountry' }
					| { __typename?: 'HMTopGenre' }
					| { __typename?: 'HMTopHighlightArticle' }
					| { __typename?: 'HMWatchedBySimilarUsers' }
					| null
				>;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMSpotlightContinueWatching';
				moduleID: number;
				type: string;
				category: string;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMSpotlightGoingViral';
				moduleID: number;
				type: string;
				category: string;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMSpotlightNewOnYourWatchlist';
				moduleID: number;
				type: string;
				category: string;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMSpotlightNewSimilarToLikedTitle';
				moduleID: number;
				type: string;
				category: string;
				likedTitle:
					| {
							__typename?: 'Movie';
							id: string;
							content: {
								__typename?: 'MovieContent';
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							};
					  }
					| {
							__typename?: 'Season';
							id: string;
							content: {
								__typename?: 'SeasonContent';
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							};
					  }
					| {
							__typename?: 'Show';
							id: string;
							content: {
								__typename?: 'ShowContent';
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							};
					  };
				titles: Array<
					| {
							__typename: 'Movie';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							content: {
								__typename?: 'MovieContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
					  }
					| {
							__typename: 'Season';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							content: {
								__typename?: 'SeasonContent';
								seasonNumber: number;
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
							show: {
								__typename: 'Show';
								id: string;
								objectType: Types.ObjectType;
								objectId: number;
								content: { __typename?: 'ShowContent'; title: string };
								watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							};
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
					  }
					| {
							__typename: 'Show';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							watchNextEpisode?: {
								__typename?: 'Episode';
								id: string;
								objectId: number;
								objectType: Types.ObjectType;
								offerCount: number;
								season: {
									__typename?: 'Season';
									id: string;
									content: {
										__typename?: 'SeasonContent';
										fullPath: string;
										posterUrl?: string | null;
									};
									seenState: {
										__typename?: 'ShowSeenState';
										releasedEpisodeCount: number;
										seenEpisodeCount: number;
										progress: number;
									};
								};
								content: {
									__typename?: 'EpisodeContent';
									title: string;
									episodeNumber: number;
									seasonNumber: number;
									upcomingReleases?: Array<{
										__typename?: 'UpcomingRelease';
										releaseDate?: any | null;
										label: Types.UpcomingReleaseLabel;
									}>;
								};
								watchNowOffer?: {
									__typename: 'Offer';
									id: string;
									standardWebURL?: string | null;
									preAffiliatedStandardWebURL?: string | null;
									streamUrl?: string | null;
									streamUrlExternalPlayer?: string | null;
									retailPrice?: string | null;
									retailPriceValue?: number | null;
									lastChangeRetailPriceValue?: number | null;
									currency?: string | null;
									presentationType: Types.PresentationType;
									monetizationType: Types.MonetizationType;
									availableTo?: any | null;
									dateCreated?: any | null;
									newElementCount?: number | null;
									package: {
										__typename?: 'Package';
										id: string;
										icon: string;
										packageId: number;
										clearName: string;
										shortName: string;
										technicalName: string;
										iconWide: string;
										hasRectangularIcon: boolean;
									};
								} | null;
								show: { __typename?: 'Show'; id: string };
							} | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							content: {
								__typename?: 'ShowContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
					  }
				>;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMSpotlightNewWithHighRatings';
				moduleID: number;
				type: string;
				category: string;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMSpotlightTrendingToday';
				moduleID: number;
				type: string;
				category: string;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMTVOD';
				moduleID: number;
				type: string;
				category: string;
				titles: Array<
					| {
							__typename: 'Movie';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							content: {
								__typename?: 'MovieContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
					  }
					| {
							__typename: 'Season';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							content: {
								__typename?: 'SeasonContent';
								seasonNumber: number;
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
							show: {
								__typename: 'Show';
								id: string;
								objectType: Types.ObjectType;
								objectId: number;
								content: { __typename?: 'ShowContent'; title: string };
								watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							};
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
					  }
					| {
							__typename: 'Show';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							watchNextEpisode?: {
								__typename?: 'Episode';
								id: string;
								objectId: number;
								objectType: Types.ObjectType;
								offerCount: number;
								season: {
									__typename?: 'Season';
									id: string;
									content: {
										__typename?: 'SeasonContent';
										fullPath: string;
										posterUrl?: string | null;
									};
									seenState: {
										__typename?: 'ShowSeenState';
										releasedEpisodeCount: number;
										seenEpisodeCount: number;
										progress: number;
									};
								};
								content: {
									__typename?: 'EpisodeContent';
									title: string;
									episodeNumber: number;
									seasonNumber: number;
									upcomingReleases?: Array<{
										__typename?: 'UpcomingRelease';
										releaseDate?: any | null;
										label: Types.UpcomingReleaseLabel;
									}>;
								};
								watchNowOffer?: {
									__typename: 'Offer';
									id: string;
									standardWebURL?: string | null;
									preAffiliatedStandardWebURL?: string | null;
									streamUrl?: string | null;
									streamUrlExternalPlayer?: string | null;
									retailPrice?: string | null;
									retailPriceValue?: number | null;
									lastChangeRetailPriceValue?: number | null;
									currency?: string | null;
									presentationType: Types.PresentationType;
									monetizationType: Types.MonetizationType;
									availableTo?: any | null;
									dateCreated?: any | null;
									newElementCount?: number | null;
									package: {
										__typename?: 'Package';
										id: string;
										icon: string;
										packageId: number;
										clearName: string;
										shortName: string;
										technicalName: string;
										iconWide: string;
										hasRectangularIcon: boolean;
									};
								} | null;
								show: { __typename?: 'Show'; id: string };
							} | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							content: {
								__typename?: 'ShowContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
					  }
				>;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMTextRecommendation';
				moduleID: number;
				type: string;
				category: string;
				textRecommendation: {
					__typename: 'TextRecommendation';
					id: string;
					headline?: string | null;
					body: string;
					bodyHTML: string;
					originalHeadline?: string | null;
					originalBody?: string | null;
					originalBodyHTML?: string | null;
					watchIf?: Array<string> | null;
					skipIf?: Array<string> | null;
					customProfileType?: string | null;
					watchedAt: any;
					likeCount: number;
					likedByUser: boolean;
					ownedByUser: boolean;
					updatedAt: any;
					tags?: Array<{ __typename?: 'Tag'; technicalName: string; translatedName: string }> | null;
					watchedOn?: {
						__typename?: 'Package';
						clearName: string;
						id: string;
						shortName: string;
						technicalName: string;
						packageId: number;
						selected: boolean;
						monetizationTypes: Array<Types.MonetizationType>;
						icon: string;
						isVisibleFilterBar: boolean;
						addonParent?: { __typename?: 'Package'; id: string } | null;
					} | null;
					profile: {
						__typename: 'Profile';
						displayName: string;
						firstName: string;
						lastName: string;
						location?: string | null;
						country: any;
						bio?: string | null;
						avatarUrl?: string | null;
						isComplete: boolean;
						ownedByUser: boolean;
						profileUrl: string;
						profileType: Types.ProfileType;
						contentPersonId?: string | null;
						textRecommendationsCount: number;
						id: string;
						externalUrls?: Array<{
							__typename?: 'ProfileSpecificLink';
							type: Types.ProfileSpecificLinkType;
							name?: string | null;
							url: string;
						}> | null;
					};
					title?:
						| {
								__typename: 'Movie';
								id: string;
								objectId: number;
								objectType: Types.ObjectType;
								content: {
									__typename?: 'MovieContent';
									title: string;
									posterUrl?: string | null;
									fullPath: string;
									upcomingReleases: Array<{
										__typename?: 'UpcomingRelease';
										releaseDate?: any | null;
										releaseCountDown?: number | null;
									}>;
									scoring: {
										__typename?: 'Scoring';
										imdbScore?: number | null;
										imdbVotes?: number | null;
										tmdbPopularity?: number | null;
										tmdbScore?: number | null;
										jwRating?: number | null;
										tomatoMeter?: number | null;
										certifiedFresh?: boolean | null;
									};
								};
								watchNowOffer?: {
									__typename: 'Offer';
									id: string;
									standardWebURL?: string | null;
									preAffiliatedStandardWebURL?: string | null;
									streamUrl?: string | null;
									streamUrlExternalPlayer?: string | null;
									retailPrice?: string | null;
									retailPriceValue?: number | null;
									lastChangeRetailPriceValue?: number | null;
									currency?: string | null;
									presentationType: Types.PresentationType;
									monetizationType: Types.MonetizationType;
									availableTo?: any | null;
									dateCreated?: any | null;
									newElementCount?: number | null;
									package: {
										__typename?: 'Package';
										id: string;
										icon: string;
										packageId: number;
										clearName: string;
										shortName: string;
										technicalName: string;
										iconWide: string;
										hasRectangularIcon: boolean;
									};
								} | null;
								availableTo: Array<{
									__typename?: 'AvailableTo';
									availableToDate: any;
									availableCountDown: number;
								}>;
								watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
								dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						  }
						| {
								__typename: 'Season';
								id: string;
								objectId: number;
								objectType: Types.ObjectType;
								content: {
									__typename?: 'SeasonContent';
									seasonNumber: number;
									title: string;
									posterUrl?: string | null;
									fullPath: string;
									upcomingReleases: Array<{
										__typename?: 'UpcomingRelease';
										releaseDate?: any | null;
										releaseCountDown?: number | null;
									}>;
									scoring: {
										__typename?: 'Scoring';
										imdbScore?: number | null;
										imdbVotes?: number | null;
										tmdbPopularity?: number | null;
										tmdbScore?: number | null;
										jwRating?: number | null;
										tomatoMeter?: number | null;
										certifiedFresh?: boolean | null;
									};
								};
								show: {
									__typename: 'Show';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									content: { __typename?: 'ShowContent'; title: string; fullPath: string };
									watchNowOffer?: {
										__typename: 'Offer';
										id: string;
										standardWebURL?: string | null;
										preAffiliatedStandardWebURL?: string | null;
										streamUrl?: string | null;
										streamUrlExternalPlayer?: string | null;
										retailPrice?: string | null;
										retailPriceValue?: number | null;
										lastChangeRetailPriceValue?: number | null;
										currency?: string | null;
										presentationType: Types.PresentationType;
										monetizationType: Types.MonetizationType;
										availableTo?: any | null;
										dateCreated?: any | null;
										newElementCount?: number | null;
										package: {
											__typename?: 'Package';
											id: string;
											icon: string;
											packageId: number;
											clearName: string;
											shortName: string;
											technicalName: string;
											iconWide: string;
											hasRectangularIcon: boolean;
										};
									} | null;
									watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									seenState: { __typename?: 'ShowSeenState'; progress: number };
									tvShowTrackingEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
								};
								watchNowOffer?: {
									__typename: 'Offer';
									id: string;
									standardWebURL?: string | null;
									preAffiliatedStandardWebURL?: string | null;
									streamUrl?: string | null;
									streamUrlExternalPlayer?: string | null;
									retailPrice?: string | null;
									retailPriceValue?: number | null;
									lastChangeRetailPriceValue?: number | null;
									currency?: string | null;
									presentationType: Types.PresentationType;
									monetizationType: Types.MonetizationType;
									availableTo?: any | null;
									dateCreated?: any | null;
									newElementCount?: number | null;
									package: {
										__typename?: 'Package';
										id: string;
										icon: string;
										packageId: number;
										clearName: string;
										shortName: string;
										technicalName: string;
										iconWide: string;
										hasRectangularIcon: boolean;
									};
								} | null;
								availableTo: Array<{
									__typename?: 'AvailableTo';
									availableToDate: any;
									availableCountDown: number;
								}>;
								seenState: { __typename?: 'ShowSeenState'; progress: number };
								dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						  }
						| {
								__typename: 'Show';
								id: string;
								objectId: number;
								objectType: Types.ObjectType;
								content: {
									__typename?: 'ShowContent';
									title: string;
									posterUrl?: string | null;
									fullPath: string;
									upcomingReleases: Array<{
										__typename?: 'UpcomingRelease';
										releaseDate?: any | null;
										releaseCountDown?: number | null;
									}>;
									scoring: {
										__typename?: 'Scoring';
										imdbScore?: number | null;
										imdbVotes?: number | null;
										tmdbPopularity?: number | null;
										tmdbScore?: number | null;
										jwRating?: number | null;
										tomatoMeter?: number | null;
										certifiedFresh?: boolean | null;
									};
								};
								watchNowOffer?: {
									__typename: 'Offer';
									id: string;
									standardWebURL?: string | null;
									preAffiliatedStandardWebURL?: string | null;
									streamUrl?: string | null;
									streamUrlExternalPlayer?: string | null;
									retailPrice?: string | null;
									retailPriceValue?: number | null;
									lastChangeRetailPriceValue?: number | null;
									currency?: string | null;
									presentationType: Types.PresentationType;
									monetizationType: Types.MonetizationType;
									availableTo?: any | null;
									dateCreated?: any | null;
									newElementCount?: number | null;
									package: {
										__typename?: 'Package';
										id: string;
										icon: string;
										packageId: number;
										clearName: string;
										shortName: string;
										technicalName: string;
										iconWide: string;
										hasRectangularIcon: boolean;
									};
								} | null;
								availableTo: Array<{
									__typename?: 'AvailableTo';
									availableToDate: any;
									availableCountDown: number;
								}>;
								watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
								seenState: { __typename?: 'ShowSeenState'; progress: number };
								tvShowTrackingEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						  };
					video?: {
						__typename?: 'Clip';
						externalId: string;
						name: string;
						provider: Types.ClipProvider;
						publishedAt: any;
						sourceUrl: string;
						streamUrl?: string | null;
					} | null;
				};
				title:
					| {
							__typename: 'Movie';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							content: {
								__typename?: 'MovieContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
					  }
					| {
							__typename: 'Season';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							content: {
								__typename?: 'SeasonContent';
								seasonNumber: number;
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
							show: {
								__typename: 'Show';
								id: string;
								objectType: Types.ObjectType;
								objectId: number;
								content: { __typename?: 'ShowContent'; title: string };
								watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							};
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
					  }
					| {
							__typename: 'Show';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							watchNextEpisode?: {
								__typename?: 'Episode';
								id: string;
								objectId: number;
								objectType: Types.ObjectType;
								offerCount: number;
								season: {
									__typename?: 'Season';
									id: string;
									content: {
										__typename?: 'SeasonContent';
										fullPath: string;
										posterUrl?: string | null;
									};
									seenState: {
										__typename?: 'ShowSeenState';
										releasedEpisodeCount: number;
										seenEpisodeCount: number;
										progress: number;
									};
								};
								content: {
									__typename?: 'EpisodeContent';
									title: string;
									episodeNumber: number;
									seasonNumber: number;
									upcomingReleases?: Array<{
										__typename?: 'UpcomingRelease';
										releaseDate?: any | null;
										label: Types.UpcomingReleaseLabel;
									}>;
								};
								watchNowOffer?: {
									__typename: 'Offer';
									id: string;
									standardWebURL?: string | null;
									preAffiliatedStandardWebURL?: string | null;
									streamUrl?: string | null;
									streamUrlExternalPlayer?: string | null;
									retailPrice?: string | null;
									retailPriceValue?: number | null;
									lastChangeRetailPriceValue?: number | null;
									currency?: string | null;
									presentationType: Types.PresentationType;
									monetizationType: Types.MonetizationType;
									availableTo?: any | null;
									dateCreated?: any | null;
									newElementCount?: number | null;
									package: {
										__typename?: 'Package';
										id: string;
										icon: string;
										packageId: number;
										clearName: string;
										shortName: string;
										technicalName: string;
										iconWide: string;
										hasRectangularIcon: boolean;
									};
								} | null;
								show: { __typename?: 'Show'; id: string };
							} | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							content: {
								__typename?: 'ShowContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
					  };
				authorProfile: {
					__typename: 'ProfileV2';
					id: string;
					content: {
						__typename?: 'ProfileContent';
						displayName: string;
						location?: string | null;
						bio?: string | null;
						avatarUrl?: string | null;
						ownedByUser: boolean;
						profileUrl: string;
						profileType: Types.ProfileType;
						externalUrls?: Array<{
							__typename?: 'ProfileSpecificLink';
							type: Types.ProfileSpecificLinkType;
							name?: string | null;
							url: string;
						}> | null;
					};
				};
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMTop3PerPackageToday';
				moduleID: number;
				type: string;
				category: string;
				packagesWithTitles: Array<{
					__typename?: 'PackageTitles';
					package: {
						__typename?: 'Package';
						id: string;
						clearName: string;
						shortName: string;
						packageId: number;
					};
					titlesWithTrend: Array<{
						__typename?: 'TitleWithTrend';
						trend: Types.TitleTrend;
						title:
							| {
									__typename: 'Movie';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									offerCount: number;
									watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
									seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									watchNowOffer?: {
										__typename: 'Offer';
										id: string;
										standardWebURL?: string | null;
										preAffiliatedStandardWebURL?: string | null;
										streamUrl?: string | null;
										streamUrlExternalPlayer?: string | null;
										retailPrice?: string | null;
										retailPriceValue?: number | null;
										lastChangeRetailPriceValue?: number | null;
										currency?: string | null;
										presentationType: Types.PresentationType;
										monetizationType: Types.MonetizationType;
										availableTo?: any | null;
										dateCreated?: any | null;
										newElementCount?: number | null;
										package: {
											__typename?: 'Package';
											id: string;
											icon: string;
											packageId: number;
											clearName: string;
											shortName: string;
											technicalName: string;
											iconWide: string;
											hasRectangularIcon: boolean;
										};
									} | null;
									content: {
										__typename?: 'MovieContent';
										title: string;
										originalReleaseYear?: number | null;
										runtime?: number | null;
										fullPath: string;
										posterUrl?: string | null;
										backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
										scoring: { __typename?: 'Scoring'; viral?: number | null };
									};
							  }
							| {
									__typename: 'Season';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									offerCount: number;
									seenState: {
										__typename?: 'ShowSeenState';
										seenEpisodeCount: number;
										releasedEpisodeCount: number;
										progress: number;
										caughtUp: boolean;
										lastSeenEpisodeNumber?: number | null;
										lastSeenSeasonNumber?: number | null;
									};
									content: {
										__typename?: 'SeasonContent';
										seasonNumber: number;
										title: string;
										originalReleaseYear?: number | null;
										runtime?: number | null;
										fullPath: string;
										posterUrl?: string | null;
										backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
										scoring: { __typename?: 'Scoring'; viral?: number | null };
									};
									show: {
										__typename: 'Show';
										id: string;
										objectType: Types.ObjectType;
										objectId: number;
										content: { __typename?: 'ShowContent'; title: string };
										watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									};
									watchNowOffer?: {
										__typename: 'Offer';
										id: string;
										standardWebURL?: string | null;
										preAffiliatedStandardWebURL?: string | null;
										streamUrl?: string | null;
										streamUrlExternalPlayer?: string | null;
										retailPrice?: string | null;
										retailPriceValue?: number | null;
										lastChangeRetailPriceValue?: number | null;
										currency?: string | null;
										presentationType: Types.PresentationType;
										monetizationType: Types.MonetizationType;
										availableTo?: any | null;
										dateCreated?: any | null;
										newElementCount?: number | null;
										package: {
											__typename?: 'Package';
											id: string;
											icon: string;
											packageId: number;
											clearName: string;
											shortName: string;
											technicalName: string;
											iconWide: string;
											hasRectangularIcon: boolean;
										};
									} | null;
							  }
							| {
									__typename: 'Show';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									offerCount: number;
									watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
									seenState: {
										__typename?: 'ShowSeenState';
										seenEpisodeCount: number;
										releasedEpisodeCount: number;
										progress: number;
										caughtUp: boolean;
										lastSeenEpisodeNumber?: number | null;
										lastSeenSeasonNumber?: number | null;
									};
									watchNextEpisode?: {
										__typename?: 'Episode';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										offerCount: number;
										season: {
											__typename?: 'Season';
											id: string;
											content: {
												__typename?: 'SeasonContent';
												fullPath: string;
												posterUrl?: string | null;
											};
											seenState: {
												__typename?: 'ShowSeenState';
												releasedEpisodeCount: number;
												seenEpisodeCount: number;
												progress: number;
											};
										};
										content: {
											__typename?: 'EpisodeContent';
											title: string;
											episodeNumber: number;
											seasonNumber: number;
											upcomingReleases?: Array<{
												__typename?: 'UpcomingRelease';
												releaseDate?: any | null;
												label: Types.UpcomingReleaseLabel;
											}>;
										};
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
										show: { __typename?: 'Show'; id: string };
									} | null;
									watchNowOffer?: {
										__typename: 'Offer';
										id: string;
										standardWebURL?: string | null;
										preAffiliatedStandardWebURL?: string | null;
										streamUrl?: string | null;
										streamUrlExternalPlayer?: string | null;
										retailPrice?: string | null;
										retailPriceValue?: number | null;
										lastChangeRetailPriceValue?: number | null;
										currency?: string | null;
										presentationType: Types.PresentationType;
										monetizationType: Types.MonetizationType;
										availableTo?: any | null;
										dateCreated?: any | null;
										newElementCount?: number | null;
										package: {
											__typename?: 'Package';
											id: string;
											icon: string;
											packageId: number;
											clearName: string;
											shortName: string;
											technicalName: string;
											iconWide: string;
											hasRectangularIcon: boolean;
										};
									} | null;
									content: {
										__typename?: 'ShowContent';
										title: string;
										originalReleaseYear?: number | null;
										runtime?: number | null;
										fullPath: string;
										posterUrl?: string | null;
										backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
										scoring: { __typename?: 'Scoring'; viral?: number | null };
									};
							  };
					}>;
				}>;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMTop10InYourCountry';
				moduleID: number;
				type: string;
				category: string;
				titles: Array<
					| {
							__typename: 'Movie';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							content: {
								__typename?: 'MovieContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
					  }
					| {
							__typename: 'Season';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							content: {
								__typename?: 'SeasonContent';
								seasonNumber: number;
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
							show: {
								__typename: 'Show';
								id: string;
								objectType: Types.ObjectType;
								objectId: number;
								content: { __typename?: 'ShowContent'; title: string };
								watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							};
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
					  }
					| {
							__typename: 'Show';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							watchNextEpisode?: {
								__typename?: 'Episode';
								id: string;
								objectId: number;
								objectType: Types.ObjectType;
								offerCount: number;
								season: {
									__typename?: 'Season';
									id: string;
									content: {
										__typename?: 'SeasonContent';
										fullPath: string;
										posterUrl?: string | null;
									};
									seenState: {
										__typename?: 'ShowSeenState';
										releasedEpisodeCount: number;
										seenEpisodeCount: number;
										progress: number;
									};
								};
								content: {
									__typename?: 'EpisodeContent';
									title: string;
									episodeNumber: number;
									seasonNumber: number;
									upcomingReleases?: Array<{
										__typename?: 'UpcomingRelease';
										releaseDate?: any | null;
										label: Types.UpcomingReleaseLabel;
									}>;
								};
								watchNowOffer?: {
									__typename: 'Offer';
									id: string;
									standardWebURL?: string | null;
									preAffiliatedStandardWebURL?: string | null;
									streamUrl?: string | null;
									streamUrlExternalPlayer?: string | null;
									retailPrice?: string | null;
									retailPriceValue?: number | null;
									lastChangeRetailPriceValue?: number | null;
									currency?: string | null;
									presentationType: Types.PresentationType;
									monetizationType: Types.MonetizationType;
									availableTo?: any | null;
									dateCreated?: any | null;
									newElementCount?: number | null;
									package: {
										__typename?: 'Package';
										id: string;
										icon: string;
										packageId: number;
										clearName: string;
										shortName: string;
										technicalName: string;
										iconWide: string;
										hasRectangularIcon: boolean;
									};
								} | null;
								show: { __typename?: 'Show'; id: string };
							} | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							content: {
								__typename?: 'ShowContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
					  }
				>;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMTopGenre';
				category: string;
				moduleID: number;
				type: string;
				titles: Array<
					| {
							__typename: 'Movie';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							content: {
								__typename?: 'MovieContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
					  }
					| {
							__typename: 'Season';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							content: {
								__typename?: 'SeasonContent';
								seasonNumber: number;
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
							show: {
								__typename: 'Show';
								id: string;
								objectType: Types.ObjectType;
								objectId: number;
								content: { __typename?: 'ShowContent'; title: string };
								watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							};
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
					  }
					| {
							__typename: 'Show';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							watchNextEpisode?: {
								__typename?: 'Episode';
								id: string;
								objectId: number;
								objectType: Types.ObjectType;
								offerCount: number;
								season: {
									__typename?: 'Season';
									id: string;
									content: {
										__typename?: 'SeasonContent';
										fullPath: string;
										posterUrl?: string | null;
									};
									seenState: {
										__typename?: 'ShowSeenState';
										releasedEpisodeCount: number;
										seenEpisodeCount: number;
										progress: number;
									};
								};
								content: {
									__typename?: 'EpisodeContent';
									title: string;
									episodeNumber: number;
									seasonNumber: number;
									upcomingReleases?: Array<{
										__typename?: 'UpcomingRelease';
										releaseDate?: any | null;
										label: Types.UpcomingReleaseLabel;
									}>;
								};
								watchNowOffer?: {
									__typename: 'Offer';
									id: string;
									standardWebURL?: string | null;
									preAffiliatedStandardWebURL?: string | null;
									streamUrl?: string | null;
									streamUrlExternalPlayer?: string | null;
									retailPrice?: string | null;
									retailPriceValue?: number | null;
									lastChangeRetailPriceValue?: number | null;
									currency?: string | null;
									presentationType: Types.PresentationType;
									monetizationType: Types.MonetizationType;
									availableTo?: any | null;
									dateCreated?: any | null;
									newElementCount?: number | null;
									package: {
										__typename?: 'Package';
										id: string;
										icon: string;
										packageId: number;
										clearName: string;
										shortName: string;
										technicalName: string;
										iconWide: string;
										hasRectangularIcon: boolean;
									};
								} | null;
								show: { __typename?: 'Show'; id: string };
							} | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							content: {
								__typename?: 'ShowContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
					  }
				>;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMTopHighlightArticle';
				moduleID: number;
				type: string;
				category: string;
				titles: Array<
					| {
							__typename: 'Movie';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							appleTVPlusOffers: Array<{
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							}>;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							content: {
								__typename?: 'MovieContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
					  }
					| {
							__typename: 'Season';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							appleTVPlusOffers: Array<{
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							}>;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							content: {
								__typename?: 'SeasonContent';
								seasonNumber: number;
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
							show: {
								__typename: 'Show';
								id: string;
								objectType: Types.ObjectType;
								objectId: number;
								content: { __typename?: 'ShowContent'; title: string };
								watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							};
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
					  }
					| {
							__typename: 'Show';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							appleTVPlusOffers: Array<{
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							}>;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							watchNextEpisode?: {
								__typename?: 'Episode';
								id: string;
								objectId: number;
								objectType: Types.ObjectType;
								offerCount: number;
								season: {
									__typename?: 'Season';
									id: string;
									content: {
										__typename?: 'SeasonContent';
										fullPath: string;
										posterUrl?: string | null;
									};
									seenState: {
										__typename?: 'ShowSeenState';
										releasedEpisodeCount: number;
										seenEpisodeCount: number;
										progress: number;
									};
								};
								content: {
									__typename?: 'EpisodeContent';
									title: string;
									episodeNumber: number;
									seasonNumber: number;
									upcomingReleases?: Array<{
										__typename?: 'UpcomingRelease';
										releaseDate?: any | null;
										label: Types.UpcomingReleaseLabel;
									}>;
								};
								watchNowOffer?: {
									__typename: 'Offer';
									id: string;
									standardWebURL?: string | null;
									preAffiliatedStandardWebURL?: string | null;
									streamUrl?: string | null;
									streamUrlExternalPlayer?: string | null;
									retailPrice?: string | null;
									retailPriceValue?: number | null;
									lastChangeRetailPriceValue?: number | null;
									currency?: string | null;
									presentationType: Types.PresentationType;
									monetizationType: Types.MonetizationType;
									availableTo?: any | null;
									dateCreated?: any | null;
									newElementCount?: number | null;
									package: {
										__typename?: 'Package';
										id: string;
										icon: string;
										packageId: number;
										clearName: string;
										shortName: string;
										technicalName: string;
										iconWide: string;
										hasRectangularIcon: boolean;
									};
								} | null;
								show: { __typename?: 'Show'; id: string };
							} | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							content: {
								__typename?: 'ShowContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
					  }
				>;
				article: {
					__typename?: 'Article';
					id: string;
					author: {
						__typename?: 'Author';
						id: string;
						content: {
							__typename?: 'AuthorContent';
							bio: string;
							clearName: string;
							imageUrl?: string | null;
							fullPath: string;
							alumniOf: Array<string>;
							brand: string;
							languagesSpoken: Array<any>;
							occupation: Array<string>;
							publications?: Array<{
								__typename?: 'AuthorSpecificLink';
								name: string;
								url: string;
							}> | null;
							socialHandles?: Array<{
								__typename?: 'AuthorSpecificLink';
								name: string;
								url: string;
							}> | null;
						};
					};
					content: {
						__typename: 'ArticleContent';
						id: number;
						title?: string | null;
						fullPath: string;
						highlightLabel?: string | null;
						highlightTitle?: string | null;
					};
					linkedObjects: Array<{
						__typename?: 'ArticleLinkedObject';
						node:
							| { __typename?: 'Article' }
							| { __typename?: 'Author' }
							| { __typename?: 'Bundle' }
							| { __typename?: 'Device' }
							| { __typename?: 'Episode' }
							| {
									__typename?: 'GenericTitleList';
									id: string;
									followedlistEntry?: {
										__typename?: 'FollowedListEntry';
										createdAt: any;
										name: string;
									} | null;
							  }
							| { __typename?: 'Genre' }
							| { __typename?: 'HomePage' }
							| { __typename?: 'Movie' }
							| { __typename?: 'MultiStepSportEvent' }
							| { __typename?: 'Offer' }
							| { __typename?: 'OfferHistory' }
							| { __typename?: 'Package' }
							| { __typename?: 'Page' }
							| { __typename?: 'Person' }
							| { __typename?: 'ProfileV2' }
							| { __typename?: 'Season' }
							| { __typename?: 'Show' }
							| { __typename?: 'SingleStepSportEvent' }
							| { __typename?: 'SportCompetitionV2' }
							| { __typename?: 'SportCompetitorV2' }
							| { __typename?: 'SportMatch' }
							| { __typename?: 'Url' };
					}>;
				};
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMWatchedBySimilarUsers';
				moduleID: number;
				type: string;
				category: string;
				titles: Array<
					| {
							__typename: 'Movie';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							content: {
								__typename?: 'MovieContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
					  }
					| {
							__typename: 'Season';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							content: {
								__typename?: 'SeasonContent';
								seasonNumber: number;
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
							show: {
								__typename: 'Show';
								id: string;
								objectType: Types.ObjectType;
								objectId: number;
								content: { __typename?: 'ShowContent'; title: string };
								watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							};
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
					  }
					| {
							__typename: 'Show';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							watchNextEpisode?: {
								__typename?: 'Episode';
								id: string;
								objectId: number;
								objectType: Types.ObjectType;
								offerCount: number;
								season: {
									__typename?: 'Season';
									id: string;
									content: {
										__typename?: 'SeasonContent';
										fullPath: string;
										posterUrl?: string | null;
									};
									seenState: {
										__typename?: 'ShowSeenState';
										releasedEpisodeCount: number;
										seenEpisodeCount: number;
										progress: number;
									};
								};
								content: {
									__typename?: 'EpisodeContent';
									title: string;
									episodeNumber: number;
									seasonNumber: number;
									upcomingReleases?: Array<{
										__typename?: 'UpcomingRelease';
										releaseDate?: any | null;
										label: Types.UpcomingReleaseLabel;
									}>;
								};
								watchNowOffer?: {
									__typename: 'Offer';
									id: string;
									standardWebURL?: string | null;
									preAffiliatedStandardWebURL?: string | null;
									streamUrl?: string | null;
									streamUrlExternalPlayer?: string | null;
									retailPrice?: string | null;
									retailPriceValue?: number | null;
									lastChangeRetailPriceValue?: number | null;
									currency?: string | null;
									presentationType: Types.PresentationType;
									monetizationType: Types.MonetizationType;
									availableTo?: any | null;
									dateCreated?: any | null;
									newElementCount?: number | null;
									package: {
										__typename?: 'Package';
										id: string;
										icon: string;
										packageId: number;
										clearName: string;
										shortName: string;
										technicalName: string;
										iconWide: string;
										hasRectangularIcon: boolean;
									};
								} | null;
								show: { __typename?: 'Show'; id: string };
							} | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							content: {
								__typename?: 'ShowContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
					  }
				>;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| null
	>;
};

export type ModuleInfo_Hmavod_Fragment = {
	__typename: 'HMAVOD';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type ModuleInfo_HmBecauseYouLikedTitle_Fragment = {
	__typename: 'HMBecauseYouLikedTitle';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type ModuleInfo_HmContinueWatchingJwtv_Fragment = {
	__typename: 'HMContinueWatchingJWTV';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type ModuleInfo_HmFeatureRotator_Fragment = {
	__typename: 'HMFeatureRotator';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type ModuleInfo_HmHighlightArticle_Fragment = {
	__typename: 'HMHighlightArticle';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type ModuleInfo_HmNewPerPackageToday_Fragment = {
	__typename: 'HMNewPerPackageToday';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type ModuleInfo_HmPermanentAudience_Fragment = {
	__typename: 'HMPermanentAudience';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type ModuleInfo_Hmsqtv_Fragment = {
	__typename: 'HMSQTV';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type ModuleInfo_HmSportsLiveFootball_Fragment = {
	__typename: 'HMSportsLiveFootball';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type ModuleInfo_HmSportsUpcomingFootball_Fragment = {
	__typename: 'HMSportsUpcomingFootball';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type ModuleInfo_HmSpotlight_Fragment = {
	__typename: 'HMSpotlight';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type ModuleInfo_HmSpotlightContinueWatching_Fragment = {
	__typename: 'HMSpotlightContinueWatching';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type ModuleInfo_HmSpotlightGoingViral_Fragment = {
	__typename: 'HMSpotlightGoingViral';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type ModuleInfo_HmSpotlightNewOnYourWatchlist_Fragment = {
	__typename: 'HMSpotlightNewOnYourWatchlist';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type ModuleInfo_HmSpotlightNewSimilarToLikedTitle_Fragment = {
	__typename: 'HMSpotlightNewSimilarToLikedTitle';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type ModuleInfo_HmSpotlightNewWithHighRatings_Fragment = {
	__typename: 'HMSpotlightNewWithHighRatings';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type ModuleInfo_HmSpotlightTrendingToday_Fragment = {
	__typename: 'HMSpotlightTrendingToday';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type ModuleInfo_Hmtvod_Fragment = {
	__typename: 'HMTVOD';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type ModuleInfo_HmTextRecommendation_Fragment = {
	__typename: 'HMTextRecommendation';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type ModuleInfo_HmTop3PerPackageToday_Fragment = {
	__typename: 'HMTop3PerPackageToday';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type ModuleInfo_HmTop10InYourCountry_Fragment = {
	__typename: 'HMTop10InYourCountry';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type ModuleInfo_HmTopGenre_Fragment = {
	__typename: 'HMTopGenre';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type ModuleInfo_HmTopHighlightArticle_Fragment = {
	__typename: 'HMTopHighlightArticle';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type ModuleInfo_HmWatchedBySimilarUsers_Fragment = {
	__typename: 'HMWatchedBySimilarUsers';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type ModuleInfoFragment =
	| ModuleInfo_Hmavod_Fragment
	| ModuleInfo_HmBecauseYouLikedTitle_Fragment
	| ModuleInfo_HmContinueWatchingJwtv_Fragment
	| ModuleInfo_HmFeatureRotator_Fragment
	| ModuleInfo_HmHighlightArticle_Fragment
	| ModuleInfo_HmNewPerPackageToday_Fragment
	| ModuleInfo_HmPermanentAudience_Fragment
	| ModuleInfo_Hmsqtv_Fragment
	| ModuleInfo_HmSportsLiveFootball_Fragment
	| ModuleInfo_HmSportsUpcomingFootball_Fragment
	| ModuleInfo_HmSpotlight_Fragment
	| ModuleInfo_HmSpotlightContinueWatching_Fragment
	| ModuleInfo_HmSpotlightGoingViral_Fragment
	| ModuleInfo_HmSpotlightNewOnYourWatchlist_Fragment
	| ModuleInfo_HmSpotlightNewSimilarToLikedTitle_Fragment
	| ModuleInfo_HmSpotlightNewWithHighRatings_Fragment
	| ModuleInfo_HmSpotlightTrendingToday_Fragment
	| ModuleInfo_Hmtvod_Fragment
	| ModuleInfo_HmTextRecommendation_Fragment
	| ModuleInfo_HmTop3PerPackageToday_Fragment
	| ModuleInfo_HmTop10InYourCountry_Fragment
	| ModuleInfo_HmTopGenre_Fragment
	| ModuleInfo_HmTopHighlightArticle_Fragment
	| ModuleInfo_HmWatchedBySimilarUsers_Fragment;

export type FeatureRotatorContainer_Hmavod_Fragment = {
	__typename: 'HMAVOD';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type FeatureRotatorContainer_HmBecauseYouLikedTitle_Fragment = {
	__typename: 'HMBecauseYouLikedTitle';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type FeatureRotatorContainer_HmContinueWatchingJwtv_Fragment = {
	__typename: 'HMContinueWatchingJWTV';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type FeatureRotatorContainer_HmFeatureRotator_Fragment = {
	__typename: 'HMFeatureRotator';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type FeatureRotatorContainer_HmHighlightArticle_Fragment = {
	__typename: 'HMHighlightArticle';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type FeatureRotatorContainer_HmNewPerPackageToday_Fragment = {
	__typename: 'HMNewPerPackageToday';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type FeatureRotatorContainer_HmPermanentAudience_Fragment = {
	__typename: 'HMPermanentAudience';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type FeatureRotatorContainer_Hmsqtv_Fragment = {
	__typename: 'HMSQTV';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type FeatureRotatorContainer_HmSportsLiveFootball_Fragment = {
	__typename: 'HMSportsLiveFootball';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type FeatureRotatorContainer_HmSportsUpcomingFootball_Fragment = {
	__typename: 'HMSportsUpcomingFootball';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type FeatureRotatorContainer_HmSpotlight_Fragment = {
	__typename: 'HMSpotlight';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type FeatureRotatorContainer_HmSpotlightContinueWatching_Fragment = {
	__typename: 'HMSpotlightContinueWatching';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type FeatureRotatorContainer_HmSpotlightGoingViral_Fragment = {
	__typename: 'HMSpotlightGoingViral';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type FeatureRotatorContainer_HmSpotlightNewOnYourWatchlist_Fragment = {
	__typename: 'HMSpotlightNewOnYourWatchlist';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type FeatureRotatorContainer_HmSpotlightNewSimilarToLikedTitle_Fragment = {
	__typename: 'HMSpotlightNewSimilarToLikedTitle';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type FeatureRotatorContainer_HmSpotlightNewWithHighRatings_Fragment = {
	__typename: 'HMSpotlightNewWithHighRatings';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type FeatureRotatorContainer_HmSpotlightTrendingToday_Fragment = {
	__typename: 'HMSpotlightTrendingToday';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type FeatureRotatorContainer_Hmtvod_Fragment = {
	__typename: 'HMTVOD';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type FeatureRotatorContainer_HmTextRecommendation_Fragment = {
	__typename: 'HMTextRecommendation';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type FeatureRotatorContainer_HmTop3PerPackageToday_Fragment = {
	__typename: 'HMTop3PerPackageToday';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type FeatureRotatorContainer_HmTop10InYourCountry_Fragment = {
	__typename: 'HMTop10InYourCountry';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type FeatureRotatorContainer_HmTopGenre_Fragment = {
	__typename: 'HMTopGenre';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type FeatureRotatorContainer_HmTopHighlightArticle_Fragment = {
	__typename: 'HMTopHighlightArticle';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type FeatureRotatorContainer_HmWatchedBySimilarUsers_Fragment = {
	__typename: 'HMWatchedBySimilarUsers';
	moduleID: number;
	type: string;
	category: string;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type FeatureRotatorContainerFragment =
	| FeatureRotatorContainer_Hmavod_Fragment
	| FeatureRotatorContainer_HmBecauseYouLikedTitle_Fragment
	| FeatureRotatorContainer_HmContinueWatchingJwtv_Fragment
	| FeatureRotatorContainer_HmFeatureRotator_Fragment
	| FeatureRotatorContainer_HmHighlightArticle_Fragment
	| FeatureRotatorContainer_HmNewPerPackageToday_Fragment
	| FeatureRotatorContainer_HmPermanentAudience_Fragment
	| FeatureRotatorContainer_Hmsqtv_Fragment
	| FeatureRotatorContainer_HmSportsLiveFootball_Fragment
	| FeatureRotatorContainer_HmSportsUpcomingFootball_Fragment
	| FeatureRotatorContainer_HmSpotlight_Fragment
	| FeatureRotatorContainer_HmSpotlightContinueWatching_Fragment
	| FeatureRotatorContainer_HmSpotlightGoingViral_Fragment
	| FeatureRotatorContainer_HmSpotlightNewOnYourWatchlist_Fragment
	| FeatureRotatorContainer_HmSpotlightNewSimilarToLikedTitle_Fragment
	| FeatureRotatorContainer_HmSpotlightNewWithHighRatings_Fragment
	| FeatureRotatorContainer_HmSpotlightTrendingToday_Fragment
	| FeatureRotatorContainer_Hmtvod_Fragment
	| FeatureRotatorContainer_HmTextRecommendation_Fragment
	| FeatureRotatorContainer_HmTop3PerPackageToday_Fragment
	| FeatureRotatorContainer_HmTop10InYourCountry_Fragment
	| FeatureRotatorContainer_HmTopGenre_Fragment
	| FeatureRotatorContainer_HmTopHighlightArticle_Fragment
	| FeatureRotatorContainer_HmWatchedBySimilarUsers_Fragment;

export type TvodModuleContainerFragment = {
	__typename: 'HMTVOD';
	moduleID: number;
	type: string;
	category: string;
	titles: Array<
		| {
				__typename: 'Movie';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'MovieContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
		| {
				__typename: 'Season';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				content: {
					__typename?: 'SeasonContent';
					seasonNumber: number;
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
				show: {
					__typename: 'Show';
					id: string;
					objectType: Types.ObjectType;
					objectId: number;
					content: { __typename?: 'ShowContent'; title: string };
					watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				};
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
		  }
		| {
				__typename: 'Show';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				watchNextEpisode?: {
					__typename?: 'Episode';
					id: string;
					objectId: number;
					objectType: Types.ObjectType;
					offerCount: number;
					season: {
						__typename?: 'Season';
						id: string;
						content: { __typename?: 'SeasonContent'; fullPath: string; posterUrl?: string | null };
						seenState: {
							__typename?: 'ShowSeenState';
							releasedEpisodeCount: number;
							seenEpisodeCount: number;
							progress: number;
						};
					};
					content: {
						__typename?: 'EpisodeContent';
						title: string;
						episodeNumber: number;
						seasonNumber: number;
						upcomingReleases?: Array<{
							__typename?: 'UpcomingRelease';
							releaseDate?: any | null;
							label: Types.UpcomingReleaseLabel;
						}>;
					};
					watchNowOffer?: {
						__typename: 'Offer';
						id: string;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						lastChangeRetailPriceValue?: number | null;
						currency?: string | null;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						availableTo?: any | null;
						dateCreated?: any | null;
						newElementCount?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							icon: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							iconWide: string;
							hasRectangularIcon: boolean;
						};
					} | null;
					show: { __typename?: 'Show'; id: string };
				} | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'ShowContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
	>;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type AvodModuleContainerFragment = {
	__typename: 'HMAVOD';
	moduleID: number;
	type: string;
	category: string;
	titles: Array<
		| {
				__typename: 'Movie';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'MovieContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
		| {
				__typename: 'Season';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				content: {
					__typename?: 'SeasonContent';
					seasonNumber: number;
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
				show: {
					__typename: 'Show';
					id: string;
					objectType: Types.ObjectType;
					objectId: number;
					content: { __typename?: 'ShowContent'; title: string };
					watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				};
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
		  }
		| {
				__typename: 'Show';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				watchNextEpisode?: {
					__typename?: 'Episode';
					id: string;
					objectId: number;
					objectType: Types.ObjectType;
					offerCount: number;
					season: {
						__typename?: 'Season';
						id: string;
						content: { __typename?: 'SeasonContent'; fullPath: string; posterUrl?: string | null };
						seenState: {
							__typename?: 'ShowSeenState';
							releasedEpisodeCount: number;
							seenEpisodeCount: number;
							progress: number;
						};
					};
					content: {
						__typename?: 'EpisodeContent';
						title: string;
						episodeNumber: number;
						seasonNumber: number;
						upcomingReleases?: Array<{
							__typename?: 'UpcomingRelease';
							releaseDate?: any | null;
							label: Types.UpcomingReleaseLabel;
						}>;
					};
					watchNowOffer?: {
						__typename: 'Offer';
						id: string;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						lastChangeRetailPriceValue?: number | null;
						currency?: string | null;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						availableTo?: any | null;
						dateCreated?: any | null;
						newElementCount?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							icon: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							iconWide: string;
							hasRectangularIcon: boolean;
						};
					} | null;
					show: { __typename?: 'Show'; id: string };
				} | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'ShowContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
	>;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type SpotlightModuleContainerFragment = {
	__typename: 'HMSpotlight';
	moduleID: number;
	type: string;
	category: string;
	modules: Array<
		| { __typename?: 'HMAVOD' }
		| { __typename?: 'HMBecauseYouLikedTitle' }
		| { __typename?: 'HMContinueWatchingJWTV' }
		| { __typename?: 'HMFeatureRotator' }
		| { __typename?: 'HMHighlightArticle' }
		| { __typename?: 'HMNewPerPackageToday' }
		| { __typename?: 'HMPermanentAudience' }
		| { __typename?: 'HMSQTV' }
		| { __typename?: 'HMSportsLiveFootball' }
		| { __typename?: 'HMSportsUpcomingFootball' }
		| { __typename?: 'HMSpotlight' }
		| {
				__typename: 'HMSpotlightContinueWatching';
				moduleID: number;
				type: string;
				category: string;
				titles: Array<
					| {
							__typename: 'Movie';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							content: {
								__typename?: 'MovieContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
					  }
					| {
							__typename: 'Season';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							content: {
								__typename?: 'SeasonContent';
								seasonNumber: number;
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
							show: {
								__typename: 'Show';
								id: string;
								objectType: Types.ObjectType;
								objectId: number;
								content: { __typename?: 'ShowContent'; title: string };
								watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							};
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
					  }
					| {
							__typename: 'Show';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							watchNextEpisode?: {
								__typename?: 'Episode';
								id: string;
								objectId: number;
								objectType: Types.ObjectType;
								offerCount: number;
								season: {
									__typename?: 'Season';
									id: string;
									content: {
										__typename?: 'SeasonContent';
										fullPath: string;
										posterUrl?: string | null;
									};
									seenState: {
										__typename?: 'ShowSeenState';
										releasedEpisodeCount: number;
										seenEpisodeCount: number;
										progress: number;
									};
								};
								content: {
									__typename?: 'EpisodeContent';
									title: string;
									episodeNumber: number;
									seasonNumber: number;
									upcomingReleases?: Array<{
										__typename?: 'UpcomingRelease';
										releaseDate?: any | null;
										label: Types.UpcomingReleaseLabel;
									}>;
								};
								watchNowOffer?: {
									__typename: 'Offer';
									id: string;
									standardWebURL?: string | null;
									preAffiliatedStandardWebURL?: string | null;
									streamUrl?: string | null;
									streamUrlExternalPlayer?: string | null;
									retailPrice?: string | null;
									retailPriceValue?: number | null;
									lastChangeRetailPriceValue?: number | null;
									currency?: string | null;
									presentationType: Types.PresentationType;
									monetizationType: Types.MonetizationType;
									availableTo?: any | null;
									dateCreated?: any | null;
									newElementCount?: number | null;
									package: {
										__typename?: 'Package';
										id: string;
										icon: string;
										packageId: number;
										clearName: string;
										shortName: string;
										technicalName: string;
										iconWide: string;
										hasRectangularIcon: boolean;
									};
								} | null;
								show: { __typename?: 'Show'; id: string };
							} | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							content: {
								__typename?: 'ShowContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
					  }
				>;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMSpotlightGoingViral';
				moduleID: number;
				type: string;
				category: string;
				titles: Array<
					| {
							__typename: 'Movie';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							content: {
								__typename?: 'MovieContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
					  }
					| {
							__typename: 'Season';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							content: {
								__typename?: 'SeasonContent';
								seasonNumber: number;
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
							show: {
								__typename: 'Show';
								id: string;
								objectType: Types.ObjectType;
								objectId: number;
								content: { __typename?: 'ShowContent'; title: string };
								watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							};
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
					  }
					| {
							__typename: 'Show';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							watchNextEpisode?: {
								__typename?: 'Episode';
								id: string;
								objectId: number;
								objectType: Types.ObjectType;
								offerCount: number;
								season: {
									__typename?: 'Season';
									id: string;
									content: {
										__typename?: 'SeasonContent';
										fullPath: string;
										posterUrl?: string | null;
									};
									seenState: {
										__typename?: 'ShowSeenState';
										releasedEpisodeCount: number;
										seenEpisodeCount: number;
										progress: number;
									};
								};
								content: {
									__typename?: 'EpisodeContent';
									title: string;
									episodeNumber: number;
									seasonNumber: number;
									upcomingReleases?: Array<{
										__typename?: 'UpcomingRelease';
										releaseDate?: any | null;
										label: Types.UpcomingReleaseLabel;
									}>;
								};
								watchNowOffer?: {
									__typename: 'Offer';
									id: string;
									standardWebURL?: string | null;
									preAffiliatedStandardWebURL?: string | null;
									streamUrl?: string | null;
									streamUrlExternalPlayer?: string | null;
									retailPrice?: string | null;
									retailPriceValue?: number | null;
									lastChangeRetailPriceValue?: number | null;
									currency?: string | null;
									presentationType: Types.PresentationType;
									monetizationType: Types.MonetizationType;
									availableTo?: any | null;
									dateCreated?: any | null;
									newElementCount?: number | null;
									package: {
										__typename?: 'Package';
										id: string;
										icon: string;
										packageId: number;
										clearName: string;
										shortName: string;
										technicalName: string;
										iconWide: string;
										hasRectangularIcon: boolean;
									};
								} | null;
								show: { __typename?: 'Show'; id: string };
							} | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							content: {
								__typename?: 'ShowContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
					  }
				>;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMSpotlightNewOnYourWatchlist';
				moduleID: number;
				type: string;
				category: string;
				titles: Array<
					| {
							__typename: 'Movie';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							content: {
								__typename?: 'MovieContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								isReleased: boolean;
								upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
					  }
					| {
							__typename: 'Season';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							content: {
								__typename?: 'SeasonContent';
								seasonNumber: number;
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								isReleased: boolean;
								upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							show: {
								__typename: 'Show';
								id: string;
								objectType: Types.ObjectType;
								objectId: number;
								content: { __typename?: 'ShowContent'; title: string };
								watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							};
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
					  }
					| {
							__typename: 'Show';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							content: {
								__typename?: 'ShowContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								isReleased: boolean;
								upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							watchNextEpisode?: {
								__typename?: 'Episode';
								id: string;
								objectId: number;
								objectType: Types.ObjectType;
								offerCount: number;
								season: {
									__typename?: 'Season';
									id: string;
									content: {
										__typename?: 'SeasonContent';
										fullPath: string;
										posterUrl?: string | null;
									};
									seenState: {
										__typename?: 'ShowSeenState';
										releasedEpisodeCount: number;
										seenEpisodeCount: number;
										progress: number;
									};
								};
								content: {
									__typename?: 'EpisodeContent';
									title: string;
									episodeNumber: number;
									seasonNumber: number;
									upcomingReleases?: Array<{
										__typename?: 'UpcomingRelease';
										releaseDate?: any | null;
										label: Types.UpcomingReleaseLabel;
									}>;
								};
								watchNowOffer?: {
									__typename: 'Offer';
									id: string;
									standardWebURL?: string | null;
									preAffiliatedStandardWebURL?: string | null;
									streamUrl?: string | null;
									streamUrlExternalPlayer?: string | null;
									retailPrice?: string | null;
									retailPriceValue?: number | null;
									lastChangeRetailPriceValue?: number | null;
									currency?: string | null;
									presentationType: Types.PresentationType;
									monetizationType: Types.MonetizationType;
									availableTo?: any | null;
									dateCreated?: any | null;
									newElementCount?: number | null;
									package: {
										__typename?: 'Package';
										id: string;
										icon: string;
										packageId: number;
										clearName: string;
										shortName: string;
										technicalName: string;
										iconWide: string;
										hasRectangularIcon: boolean;
									};
								} | null;
								show: { __typename?: 'Show'; id: string };
							} | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
					  }
				>;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMSpotlightNewSimilarToLikedTitle';
				moduleID: number;
				type: string;
				category: string;
				likedTitle:
					| {
							__typename?: 'Movie';
							id: string;
							content: {
								__typename?: 'MovieContent';
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							};
					  }
					| {
							__typename?: 'Season';
							id: string;
							content: {
								__typename?: 'SeasonContent';
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							};
					  }
					| {
							__typename?: 'Show';
							id: string;
							content: {
								__typename?: 'ShowContent';
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							};
					  };
				titles: Array<
					| {
							__typename: 'Movie';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							content: {
								__typename?: 'MovieContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								isReleased: boolean;
								upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
					  }
					| {
							__typename: 'Season';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							content: {
								__typename?: 'SeasonContent';
								seasonNumber: number;
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								isReleased: boolean;
								upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							show: {
								__typename: 'Show';
								id: string;
								objectType: Types.ObjectType;
								objectId: number;
								content: { __typename?: 'ShowContent'; title: string };
								watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							};
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
					  }
					| {
							__typename: 'Show';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							content: {
								__typename?: 'ShowContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								isReleased: boolean;
								upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							watchNextEpisode?: {
								__typename?: 'Episode';
								id: string;
								objectId: number;
								objectType: Types.ObjectType;
								offerCount: number;
								season: {
									__typename?: 'Season';
									id: string;
									content: {
										__typename?: 'SeasonContent';
										fullPath: string;
										posterUrl?: string | null;
									};
									seenState: {
										__typename?: 'ShowSeenState';
										releasedEpisodeCount: number;
										seenEpisodeCount: number;
										progress: number;
									};
								};
								content: {
									__typename?: 'EpisodeContent';
									title: string;
									episodeNumber: number;
									seasonNumber: number;
									upcomingReleases?: Array<{
										__typename?: 'UpcomingRelease';
										releaseDate?: any | null;
										label: Types.UpcomingReleaseLabel;
									}>;
								};
								watchNowOffer?: {
									__typename: 'Offer';
									id: string;
									standardWebURL?: string | null;
									preAffiliatedStandardWebURL?: string | null;
									streamUrl?: string | null;
									streamUrlExternalPlayer?: string | null;
									retailPrice?: string | null;
									retailPriceValue?: number | null;
									lastChangeRetailPriceValue?: number | null;
									currency?: string | null;
									presentationType: Types.PresentationType;
									monetizationType: Types.MonetizationType;
									availableTo?: any | null;
									dateCreated?: any | null;
									newElementCount?: number | null;
									package: {
										__typename?: 'Package';
										id: string;
										icon: string;
										packageId: number;
										clearName: string;
										shortName: string;
										technicalName: string;
										iconWide: string;
										hasRectangularIcon: boolean;
									};
								} | null;
								show: { __typename?: 'Show'; id: string };
							} | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
					  }
				>;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMSpotlightNewWithHighRatings';
				moduleID: number;
				type: string;
				category: string;
				titles: Array<
					| {
							__typename: 'Movie';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							content: {
								__typename?: 'MovieContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								isReleased: boolean;
								upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
					  }
					| {
							__typename: 'Season';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							content: {
								__typename?: 'SeasonContent';
								seasonNumber: number;
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								isReleased: boolean;
								upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							show: {
								__typename: 'Show';
								id: string;
								objectType: Types.ObjectType;
								objectId: number;
								content: { __typename?: 'ShowContent'; title: string };
								watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							};
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
					  }
					| {
							__typename: 'Show';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							content: {
								__typename?: 'ShowContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								isReleased: boolean;
								upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							watchNextEpisode?: {
								__typename?: 'Episode';
								id: string;
								objectId: number;
								objectType: Types.ObjectType;
								offerCount: number;
								season: {
									__typename?: 'Season';
									id: string;
									content: {
										__typename?: 'SeasonContent';
										fullPath: string;
										posterUrl?: string | null;
									};
									seenState: {
										__typename?: 'ShowSeenState';
										releasedEpisodeCount: number;
										seenEpisodeCount: number;
										progress: number;
									};
								};
								content: {
									__typename?: 'EpisodeContent';
									title: string;
									episodeNumber: number;
									seasonNumber: number;
									upcomingReleases?: Array<{
										__typename?: 'UpcomingRelease';
										releaseDate?: any | null;
										label: Types.UpcomingReleaseLabel;
									}>;
								};
								watchNowOffer?: {
									__typename: 'Offer';
									id: string;
									standardWebURL?: string | null;
									preAffiliatedStandardWebURL?: string | null;
									streamUrl?: string | null;
									streamUrlExternalPlayer?: string | null;
									retailPrice?: string | null;
									retailPriceValue?: number | null;
									lastChangeRetailPriceValue?: number | null;
									currency?: string | null;
									presentationType: Types.PresentationType;
									monetizationType: Types.MonetizationType;
									availableTo?: any | null;
									dateCreated?: any | null;
									newElementCount?: number | null;
									package: {
										__typename?: 'Package';
										id: string;
										icon: string;
										packageId: number;
										clearName: string;
										shortName: string;
										technicalName: string;
										iconWide: string;
										hasRectangularIcon: boolean;
									};
								} | null;
								show: { __typename?: 'Show'; id: string };
							} | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
					  }
				>;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| {
				__typename: 'HMSpotlightTrendingToday';
				moduleID: number;
				type: string;
				category: string;
				titles: Array<
					| {
							__typename: 'Movie';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							content: {
								__typename?: 'MovieContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
					  }
					| {
							__typename: 'Season';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							content: {
								__typename?: 'SeasonContent';
								seasonNumber: number;
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
							show: {
								__typename: 'Show';
								id: string;
								objectType: Types.ObjectType;
								objectId: number;
								content: { __typename?: 'ShowContent'; title: string };
								watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							};
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
					  }
					| {
							__typename: 'Show';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
							seenState: {
								__typename?: 'ShowSeenState';
								seenEpisodeCount: number;
								releasedEpisodeCount: number;
								progress: number;
								caughtUp: boolean;
								lastSeenEpisodeNumber?: number | null;
								lastSeenSeasonNumber?: number | null;
							};
							watchNextEpisode?: {
								__typename?: 'Episode';
								id: string;
								objectId: number;
								objectType: Types.ObjectType;
								offerCount: number;
								season: {
									__typename?: 'Season';
									id: string;
									content: {
										__typename?: 'SeasonContent';
										fullPath: string;
										posterUrl?: string | null;
									};
									seenState: {
										__typename?: 'ShowSeenState';
										releasedEpisodeCount: number;
										seenEpisodeCount: number;
										progress: number;
									};
								};
								content: {
									__typename?: 'EpisodeContent';
									title: string;
									episodeNumber: number;
									seasonNumber: number;
									upcomingReleases?: Array<{
										__typename?: 'UpcomingRelease';
										releaseDate?: any | null;
										label: Types.UpcomingReleaseLabel;
									}>;
								};
								watchNowOffer?: {
									__typename: 'Offer';
									id: string;
									standardWebURL?: string | null;
									preAffiliatedStandardWebURL?: string | null;
									streamUrl?: string | null;
									streamUrlExternalPlayer?: string | null;
									retailPrice?: string | null;
									retailPriceValue?: number | null;
									lastChangeRetailPriceValue?: number | null;
									currency?: string | null;
									presentationType: Types.PresentationType;
									monetizationType: Types.MonetizationType;
									availableTo?: any | null;
									dateCreated?: any | null;
									newElementCount?: number | null;
									package: {
										__typename?: 'Package';
										id: string;
										icon: string;
										packageId: number;
										clearName: string;
										shortName: string;
										technicalName: string;
										iconWide: string;
										hasRectangularIcon: boolean;
									};
								} | null;
								show: { __typename?: 'Show'; id: string };
							} | null;
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							content: {
								__typename?: 'ShowContent';
								title: string;
								originalReleaseYear?: number | null;
								runtime?: number | null;
								fullPath: string;
								posterUrl?: string | null;
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
								scoring: { __typename?: 'Scoring'; viral?: number | null };
							};
					  }
				>;
				translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
		  }
		| { __typename?: 'HMTVOD' }
		| { __typename?: 'HMTextRecommendation' }
		| { __typename?: 'HMTop3PerPackageToday' }
		| { __typename?: 'HMTop10InYourCountry' }
		| { __typename?: 'HMTopGenre' }
		| { __typename?: 'HMTopHighlightArticle' }
		| { __typename?: 'HMWatchedBySimilarUsers' }
		| null
	>;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type SpotlightModuleFields_Hmavod_Fragment = { __typename?: 'HMAVOD' };

export type SpotlightModuleFields_HmBecauseYouLikedTitle_Fragment = { __typename?: 'HMBecauseYouLikedTitle' };

export type SpotlightModuleFields_HmContinueWatchingJwtv_Fragment = { __typename?: 'HMContinueWatchingJWTV' };

export type SpotlightModuleFields_HmFeatureRotator_Fragment = { __typename?: 'HMFeatureRotator' };

export type SpotlightModuleFields_HmHighlightArticle_Fragment = { __typename?: 'HMHighlightArticle' };

export type SpotlightModuleFields_HmNewPerPackageToday_Fragment = { __typename?: 'HMNewPerPackageToday' };

export type SpotlightModuleFields_HmPermanentAudience_Fragment = { __typename?: 'HMPermanentAudience' };

export type SpotlightModuleFields_Hmsqtv_Fragment = { __typename?: 'HMSQTV' };

export type SpotlightModuleFields_HmSportsLiveFootball_Fragment = { __typename?: 'HMSportsLiveFootball' };

export type SpotlightModuleFields_HmSportsUpcomingFootball_Fragment = { __typename?: 'HMSportsUpcomingFootball' };

export type SpotlightModuleFields_HmSpotlight_Fragment = { __typename?: 'HMSpotlight' };

export type SpotlightModuleFields_HmSpotlightContinueWatching_Fragment = {
	__typename: 'HMSpotlightContinueWatching';
	moduleID: number;
	type: string;
	category: string;
	titles: Array<
		| {
				__typename: 'Movie';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'MovieContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
		| {
				__typename: 'Season';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				content: {
					__typename?: 'SeasonContent';
					seasonNumber: number;
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
				show: {
					__typename: 'Show';
					id: string;
					objectType: Types.ObjectType;
					objectId: number;
					content: { __typename?: 'ShowContent'; title: string };
					watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				};
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
		  }
		| {
				__typename: 'Show';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				watchNextEpisode?: {
					__typename?: 'Episode';
					id: string;
					objectId: number;
					objectType: Types.ObjectType;
					offerCount: number;
					season: {
						__typename?: 'Season';
						id: string;
						content: { __typename?: 'SeasonContent'; fullPath: string; posterUrl?: string | null };
						seenState: {
							__typename?: 'ShowSeenState';
							releasedEpisodeCount: number;
							seenEpisodeCount: number;
							progress: number;
						};
					};
					content: {
						__typename?: 'EpisodeContent';
						title: string;
						episodeNumber: number;
						seasonNumber: number;
						upcomingReleases?: Array<{
							__typename?: 'UpcomingRelease';
							releaseDate?: any | null;
							label: Types.UpcomingReleaseLabel;
						}>;
					};
					watchNowOffer?: {
						__typename: 'Offer';
						id: string;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						lastChangeRetailPriceValue?: number | null;
						currency?: string | null;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						availableTo?: any | null;
						dateCreated?: any | null;
						newElementCount?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							icon: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							iconWide: string;
							hasRectangularIcon: boolean;
						};
					} | null;
					show: { __typename?: 'Show'; id: string };
				} | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'ShowContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
	>;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type SpotlightModuleFields_HmSpotlightGoingViral_Fragment = {
	__typename: 'HMSpotlightGoingViral';
	moduleID: number;
	type: string;
	category: string;
	titles: Array<
		| {
				__typename: 'Movie';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'MovieContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
		| {
				__typename: 'Season';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				content: {
					__typename?: 'SeasonContent';
					seasonNumber: number;
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
				show: {
					__typename: 'Show';
					id: string;
					objectType: Types.ObjectType;
					objectId: number;
					content: { __typename?: 'ShowContent'; title: string };
					watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				};
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
		  }
		| {
				__typename: 'Show';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				watchNextEpisode?: {
					__typename?: 'Episode';
					id: string;
					objectId: number;
					objectType: Types.ObjectType;
					offerCount: number;
					season: {
						__typename?: 'Season';
						id: string;
						content: { __typename?: 'SeasonContent'; fullPath: string; posterUrl?: string | null };
						seenState: {
							__typename?: 'ShowSeenState';
							releasedEpisodeCount: number;
							seenEpisodeCount: number;
							progress: number;
						};
					};
					content: {
						__typename?: 'EpisodeContent';
						title: string;
						episodeNumber: number;
						seasonNumber: number;
						upcomingReleases?: Array<{
							__typename?: 'UpcomingRelease';
							releaseDate?: any | null;
							label: Types.UpcomingReleaseLabel;
						}>;
					};
					watchNowOffer?: {
						__typename: 'Offer';
						id: string;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						lastChangeRetailPriceValue?: number | null;
						currency?: string | null;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						availableTo?: any | null;
						dateCreated?: any | null;
						newElementCount?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							icon: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							iconWide: string;
							hasRectangularIcon: boolean;
						};
					} | null;
					show: { __typename?: 'Show'; id: string };
				} | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'ShowContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
	>;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type SpotlightModuleFields_HmSpotlightNewOnYourWatchlist_Fragment = {
	__typename: 'HMSpotlightNewOnYourWatchlist';
	moduleID: number;
	type: string;
	category: string;
	titles: Array<
		| {
				__typename: 'Movie';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				content: {
					__typename?: 'MovieContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					isReleased: boolean;
					upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
		  }
		| {
				__typename: 'Season';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				content: {
					__typename?: 'SeasonContent';
					seasonNumber: number;
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					isReleased: boolean;
					upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				show: {
					__typename: 'Show';
					id: string;
					objectType: Types.ObjectType;
					objectId: number;
					content: { __typename?: 'ShowContent'; title: string };
					watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				};
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
		  }
		| {
				__typename: 'Show';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				content: {
					__typename?: 'ShowContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					isReleased: boolean;
					upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				watchNextEpisode?: {
					__typename?: 'Episode';
					id: string;
					objectId: number;
					objectType: Types.ObjectType;
					offerCount: number;
					season: {
						__typename?: 'Season';
						id: string;
						content: { __typename?: 'SeasonContent'; fullPath: string; posterUrl?: string | null };
						seenState: {
							__typename?: 'ShowSeenState';
							releasedEpisodeCount: number;
							seenEpisodeCount: number;
							progress: number;
						};
					};
					content: {
						__typename?: 'EpisodeContent';
						title: string;
						episodeNumber: number;
						seasonNumber: number;
						upcomingReleases?: Array<{
							__typename?: 'UpcomingRelease';
							releaseDate?: any | null;
							label: Types.UpcomingReleaseLabel;
						}>;
					};
					watchNowOffer?: {
						__typename: 'Offer';
						id: string;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						lastChangeRetailPriceValue?: number | null;
						currency?: string | null;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						availableTo?: any | null;
						dateCreated?: any | null;
						newElementCount?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							icon: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							iconWide: string;
							hasRectangularIcon: boolean;
						};
					} | null;
					show: { __typename?: 'Show'; id: string };
				} | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
		  }
	>;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type SpotlightModuleFields_HmSpotlightNewSimilarToLikedTitle_Fragment = {
	__typename: 'HMSpotlightNewSimilarToLikedTitle';
	moduleID: number;
	type: string;
	category: string;
	likedTitle:
		| {
				__typename?: 'Movie';
				id: string;
				content: {
					__typename?: 'MovieContent';
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
				};
		  }
		| {
				__typename?: 'Season';
				id: string;
				content: {
					__typename?: 'SeasonContent';
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
				};
		  }
		| {
				__typename?: 'Show';
				id: string;
				content: {
					__typename?: 'ShowContent';
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
				};
		  };
	titles: Array<
		| {
				__typename: 'Movie';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				content: {
					__typename?: 'MovieContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					isReleased: boolean;
					upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
		  }
		| {
				__typename: 'Season';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				content: {
					__typename?: 'SeasonContent';
					seasonNumber: number;
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					isReleased: boolean;
					upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				show: {
					__typename: 'Show';
					id: string;
					objectType: Types.ObjectType;
					objectId: number;
					content: { __typename?: 'ShowContent'; title: string };
					watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				};
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
		  }
		| {
				__typename: 'Show';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				content: {
					__typename?: 'ShowContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					isReleased: boolean;
					upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				watchNextEpisode?: {
					__typename?: 'Episode';
					id: string;
					objectId: number;
					objectType: Types.ObjectType;
					offerCount: number;
					season: {
						__typename?: 'Season';
						id: string;
						content: { __typename?: 'SeasonContent'; fullPath: string; posterUrl?: string | null };
						seenState: {
							__typename?: 'ShowSeenState';
							releasedEpisodeCount: number;
							seenEpisodeCount: number;
							progress: number;
						};
					};
					content: {
						__typename?: 'EpisodeContent';
						title: string;
						episodeNumber: number;
						seasonNumber: number;
						upcomingReleases?: Array<{
							__typename?: 'UpcomingRelease';
							releaseDate?: any | null;
							label: Types.UpcomingReleaseLabel;
						}>;
					};
					watchNowOffer?: {
						__typename: 'Offer';
						id: string;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						lastChangeRetailPriceValue?: number | null;
						currency?: string | null;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						availableTo?: any | null;
						dateCreated?: any | null;
						newElementCount?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							icon: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							iconWide: string;
							hasRectangularIcon: boolean;
						};
					} | null;
					show: { __typename?: 'Show'; id: string };
				} | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
		  }
	>;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type SpotlightModuleFields_HmSpotlightNewWithHighRatings_Fragment = {
	__typename: 'HMSpotlightNewWithHighRatings';
	moduleID: number;
	type: string;
	category: string;
	titles: Array<
		| {
				__typename: 'Movie';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				content: {
					__typename?: 'MovieContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					isReleased: boolean;
					upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
		  }
		| {
				__typename: 'Season';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				content: {
					__typename?: 'SeasonContent';
					seasonNumber: number;
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					isReleased: boolean;
					upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				show: {
					__typename: 'Show';
					id: string;
					objectType: Types.ObjectType;
					objectId: number;
					content: { __typename?: 'ShowContent'; title: string };
					watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				};
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
		  }
		| {
				__typename: 'Show';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				content: {
					__typename?: 'ShowContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					isReleased: boolean;
					upcomingReleases: Array<{ __typename?: 'UpcomingRelease'; releaseDate?: any | null }>;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				watchNextEpisode?: {
					__typename?: 'Episode';
					id: string;
					objectId: number;
					objectType: Types.ObjectType;
					offerCount: number;
					season: {
						__typename?: 'Season';
						id: string;
						content: { __typename?: 'SeasonContent'; fullPath: string; posterUrl?: string | null };
						seenState: {
							__typename?: 'ShowSeenState';
							releasedEpisodeCount: number;
							seenEpisodeCount: number;
							progress: number;
						};
					};
					content: {
						__typename?: 'EpisodeContent';
						title: string;
						episodeNumber: number;
						seasonNumber: number;
						upcomingReleases?: Array<{
							__typename?: 'UpcomingRelease';
							releaseDate?: any | null;
							label: Types.UpcomingReleaseLabel;
						}>;
					};
					watchNowOffer?: {
						__typename: 'Offer';
						id: string;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						lastChangeRetailPriceValue?: number | null;
						currency?: string | null;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						availableTo?: any | null;
						dateCreated?: any | null;
						newElementCount?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							icon: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							iconWide: string;
							hasRectangularIcon: boolean;
						};
					} | null;
					show: { __typename?: 'Show'; id: string };
				} | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
		  }
	>;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type SpotlightModuleFields_HmSpotlightTrendingToday_Fragment = {
	__typename: 'HMSpotlightTrendingToday';
	moduleID: number;
	type: string;
	category: string;
	titles: Array<
		| {
				__typename: 'Movie';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'MovieContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
		| {
				__typename: 'Season';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				content: {
					__typename?: 'SeasonContent';
					seasonNumber: number;
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
				show: {
					__typename: 'Show';
					id: string;
					objectType: Types.ObjectType;
					objectId: number;
					content: { __typename?: 'ShowContent'; title: string };
					watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				};
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
		  }
		| {
				__typename: 'Show';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				watchNextEpisode?: {
					__typename?: 'Episode';
					id: string;
					objectId: number;
					objectType: Types.ObjectType;
					offerCount: number;
					season: {
						__typename?: 'Season';
						id: string;
						content: { __typename?: 'SeasonContent'; fullPath: string; posterUrl?: string | null };
						seenState: {
							__typename?: 'ShowSeenState';
							releasedEpisodeCount: number;
							seenEpisodeCount: number;
							progress: number;
						};
					};
					content: {
						__typename?: 'EpisodeContent';
						title: string;
						episodeNumber: number;
						seasonNumber: number;
						upcomingReleases?: Array<{
							__typename?: 'UpcomingRelease';
							releaseDate?: any | null;
							label: Types.UpcomingReleaseLabel;
						}>;
					};
					watchNowOffer?: {
						__typename: 'Offer';
						id: string;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						lastChangeRetailPriceValue?: number | null;
						currency?: string | null;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						availableTo?: any | null;
						dateCreated?: any | null;
						newElementCount?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							icon: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							iconWide: string;
							hasRectangularIcon: boolean;
						};
					} | null;
					show: { __typename?: 'Show'; id: string };
				} | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'ShowContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
	>;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type SpotlightModuleFields_Hmtvod_Fragment = { __typename?: 'HMTVOD' };

export type SpotlightModuleFields_HmTextRecommendation_Fragment = { __typename?: 'HMTextRecommendation' };

export type SpotlightModuleFields_HmTop3PerPackageToday_Fragment = { __typename?: 'HMTop3PerPackageToday' };

export type SpotlightModuleFields_HmTop10InYourCountry_Fragment = { __typename?: 'HMTop10InYourCountry' };

export type SpotlightModuleFields_HmTopGenre_Fragment = { __typename?: 'HMTopGenre' };

export type SpotlightModuleFields_HmTopHighlightArticle_Fragment = { __typename?: 'HMTopHighlightArticle' };

export type SpotlightModuleFields_HmWatchedBySimilarUsers_Fragment = { __typename?: 'HMWatchedBySimilarUsers' };

export type SpotlightModuleFieldsFragment =
	| SpotlightModuleFields_Hmavod_Fragment
	| SpotlightModuleFields_HmBecauseYouLikedTitle_Fragment
	| SpotlightModuleFields_HmContinueWatchingJwtv_Fragment
	| SpotlightModuleFields_HmFeatureRotator_Fragment
	| SpotlightModuleFields_HmHighlightArticle_Fragment
	| SpotlightModuleFields_HmNewPerPackageToday_Fragment
	| SpotlightModuleFields_HmPermanentAudience_Fragment
	| SpotlightModuleFields_Hmsqtv_Fragment
	| SpotlightModuleFields_HmSportsLiveFootball_Fragment
	| SpotlightModuleFields_HmSportsUpcomingFootball_Fragment
	| SpotlightModuleFields_HmSpotlight_Fragment
	| SpotlightModuleFields_HmSpotlightContinueWatching_Fragment
	| SpotlightModuleFields_HmSpotlightGoingViral_Fragment
	| SpotlightModuleFields_HmSpotlightNewOnYourWatchlist_Fragment
	| SpotlightModuleFields_HmSpotlightNewSimilarToLikedTitle_Fragment
	| SpotlightModuleFields_HmSpotlightNewWithHighRatings_Fragment
	| SpotlightModuleFields_HmSpotlightTrendingToday_Fragment
	| SpotlightModuleFields_Hmtvod_Fragment
	| SpotlightModuleFields_HmTextRecommendation_Fragment
	| SpotlightModuleFields_HmTop3PerPackageToday_Fragment
	| SpotlightModuleFields_HmTop10InYourCountry_Fragment
	| SpotlightModuleFields_HmTopGenre_Fragment
	| SpotlightModuleFields_HmTopHighlightArticle_Fragment
	| SpotlightModuleFields_HmWatchedBySimilarUsers_Fragment;

export type TitleListModuleFields_Hmavod_Fragment = { __typename?: 'HMAVOD' };

export type TitleListModuleFields_HmBecauseYouLikedTitle_Fragment = { __typename?: 'HMBecauseYouLikedTitle' };

export type TitleListModuleFields_HmContinueWatchingJwtv_Fragment = { __typename?: 'HMContinueWatchingJWTV' };

export type TitleListModuleFields_HmFeatureRotator_Fragment = { __typename?: 'HMFeatureRotator' };

export type TitleListModuleFields_HmHighlightArticle_Fragment = { __typename?: 'HMHighlightArticle' };

export type TitleListModuleFields_HmNewPerPackageToday_Fragment = { __typename?: 'HMNewPerPackageToday' };

export type TitleListModuleFields_HmPermanentAudience_Fragment = {
	__typename: 'HMPermanentAudience';
	category: string;
	moduleID: number;
	type: string;
	titles: Array<
		| {
				__typename: 'Movie';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'MovieContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
		| {
				__typename: 'Season';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				content: {
					__typename?: 'SeasonContent';
					seasonNumber: number;
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
				show: {
					__typename: 'Show';
					id: string;
					objectType: Types.ObjectType;
					objectId: number;
					content: { __typename?: 'ShowContent'; title: string };
					watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				};
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
		  }
		| {
				__typename: 'Show';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				watchNextEpisode?: {
					__typename?: 'Episode';
					id: string;
					objectId: number;
					objectType: Types.ObjectType;
					offerCount: number;
					season: {
						__typename?: 'Season';
						id: string;
						content: { __typename?: 'SeasonContent'; fullPath: string; posterUrl?: string | null };
						seenState: {
							__typename?: 'ShowSeenState';
							releasedEpisodeCount: number;
							seenEpisodeCount: number;
							progress: number;
						};
					};
					content: {
						__typename?: 'EpisodeContent';
						title: string;
						episodeNumber: number;
						seasonNumber: number;
						upcomingReleases?: Array<{
							__typename?: 'UpcomingRelease';
							releaseDate?: any | null;
							label: Types.UpcomingReleaseLabel;
						}>;
					};
					watchNowOffer?: {
						__typename: 'Offer';
						id: string;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						lastChangeRetailPriceValue?: number | null;
						currency?: string | null;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						availableTo?: any | null;
						dateCreated?: any | null;
						newElementCount?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							icon: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							iconWide: string;
							hasRectangularIcon: boolean;
						};
					} | null;
					show: { __typename?: 'Show'; id: string };
				} | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'ShowContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
	>;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type TitleListModuleFields_Hmsqtv_Fragment = { __typename?: 'HMSQTV' };

export type TitleListModuleFields_HmSportsLiveFootball_Fragment = { __typename?: 'HMSportsLiveFootball' };

export type TitleListModuleFields_HmSportsUpcomingFootball_Fragment = { __typename?: 'HMSportsUpcomingFootball' };

export type TitleListModuleFields_HmSpotlight_Fragment = { __typename?: 'HMSpotlight' };

export type TitleListModuleFields_HmSpotlightContinueWatching_Fragment = { __typename?: 'HMSpotlightContinueWatching' };

export type TitleListModuleFields_HmSpotlightGoingViral_Fragment = { __typename?: 'HMSpotlightGoingViral' };

export type TitleListModuleFields_HmSpotlightNewOnYourWatchlist_Fragment = {
	__typename?: 'HMSpotlightNewOnYourWatchlist';
};

export type TitleListModuleFields_HmSpotlightNewSimilarToLikedTitle_Fragment = {
	__typename?: 'HMSpotlightNewSimilarToLikedTitle';
};

export type TitleListModuleFields_HmSpotlightNewWithHighRatings_Fragment = {
	__typename?: 'HMSpotlightNewWithHighRatings';
};

export type TitleListModuleFields_HmSpotlightTrendingToday_Fragment = { __typename?: 'HMSpotlightTrendingToday' };

export type TitleListModuleFields_Hmtvod_Fragment = { __typename?: 'HMTVOD' };

export type TitleListModuleFields_HmTextRecommendation_Fragment = { __typename?: 'HMTextRecommendation' };

export type TitleListModuleFields_HmTop3PerPackageToday_Fragment = { __typename?: 'HMTop3PerPackageToday' };

export type TitleListModuleFields_HmTop10InYourCountry_Fragment = {
	__typename: 'HMTop10InYourCountry';
	moduleID: number;
	type: string;
	category: string;
	titles: Array<
		| {
				__typename: 'Movie';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'MovieContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
		| {
				__typename: 'Season';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				content: {
					__typename?: 'SeasonContent';
					seasonNumber: number;
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
				show: {
					__typename: 'Show';
					id: string;
					objectType: Types.ObjectType;
					objectId: number;
					content: { __typename?: 'ShowContent'; title: string };
					watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				};
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
		  }
		| {
				__typename: 'Show';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				watchNextEpisode?: {
					__typename?: 'Episode';
					id: string;
					objectId: number;
					objectType: Types.ObjectType;
					offerCount: number;
					season: {
						__typename?: 'Season';
						id: string;
						content: { __typename?: 'SeasonContent'; fullPath: string; posterUrl?: string | null };
						seenState: {
							__typename?: 'ShowSeenState';
							releasedEpisodeCount: number;
							seenEpisodeCount: number;
							progress: number;
						};
					};
					content: {
						__typename?: 'EpisodeContent';
						title: string;
						episodeNumber: number;
						seasonNumber: number;
						upcomingReleases?: Array<{
							__typename?: 'UpcomingRelease';
							releaseDate?: any | null;
							label: Types.UpcomingReleaseLabel;
						}>;
					};
					watchNowOffer?: {
						__typename: 'Offer';
						id: string;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						lastChangeRetailPriceValue?: number | null;
						currency?: string | null;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						availableTo?: any | null;
						dateCreated?: any | null;
						newElementCount?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							icon: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							iconWide: string;
							hasRectangularIcon: boolean;
						};
					} | null;
					show: { __typename?: 'Show'; id: string };
				} | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'ShowContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
	>;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type TitleListModuleFields_HmTopGenre_Fragment = {
	__typename: 'HMTopGenre';
	category: string;
	moduleID: number;
	type: string;
	titles: Array<
		| {
				__typename: 'Movie';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'MovieContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
		| {
				__typename: 'Season';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				content: {
					__typename?: 'SeasonContent';
					seasonNumber: number;
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
				show: {
					__typename: 'Show';
					id: string;
					objectType: Types.ObjectType;
					objectId: number;
					content: { __typename?: 'ShowContent'; title: string };
					watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				};
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
		  }
		| {
				__typename: 'Show';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				watchNextEpisode?: {
					__typename?: 'Episode';
					id: string;
					objectId: number;
					objectType: Types.ObjectType;
					offerCount: number;
					season: {
						__typename?: 'Season';
						id: string;
						content: { __typename?: 'SeasonContent'; fullPath: string; posterUrl?: string | null };
						seenState: {
							__typename?: 'ShowSeenState';
							releasedEpisodeCount: number;
							seenEpisodeCount: number;
							progress: number;
						};
					};
					content: {
						__typename?: 'EpisodeContent';
						title: string;
						episodeNumber: number;
						seasonNumber: number;
						upcomingReleases?: Array<{
							__typename?: 'UpcomingRelease';
							releaseDate?: any | null;
							label: Types.UpcomingReleaseLabel;
						}>;
					};
					watchNowOffer?: {
						__typename: 'Offer';
						id: string;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						lastChangeRetailPriceValue?: number | null;
						currency?: string | null;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						availableTo?: any | null;
						dateCreated?: any | null;
						newElementCount?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							icon: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							iconWide: string;
							hasRectangularIcon: boolean;
						};
					} | null;
					show: { __typename?: 'Show'; id: string };
				} | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'ShowContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
	>;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type TitleListModuleFields_HmTopHighlightArticle_Fragment = { __typename?: 'HMTopHighlightArticle' };

export type TitleListModuleFields_HmWatchedBySimilarUsers_Fragment = {
	__typename: 'HMWatchedBySimilarUsers';
	moduleID: number;
	type: string;
	category: string;
	titles: Array<
		| {
				__typename: 'Movie';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'MovieContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
		| {
				__typename: 'Season';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				content: {
					__typename?: 'SeasonContent';
					seasonNumber: number;
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
				show: {
					__typename: 'Show';
					id: string;
					objectType: Types.ObjectType;
					objectId: number;
					content: { __typename?: 'ShowContent'; title: string };
					watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				};
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
		  }
		| {
				__typename: 'Show';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				watchNextEpisode?: {
					__typename?: 'Episode';
					id: string;
					objectId: number;
					objectType: Types.ObjectType;
					offerCount: number;
					season: {
						__typename?: 'Season';
						id: string;
						content: { __typename?: 'SeasonContent'; fullPath: string; posterUrl?: string | null };
						seenState: {
							__typename?: 'ShowSeenState';
							releasedEpisodeCount: number;
							seenEpisodeCount: number;
							progress: number;
						};
					};
					content: {
						__typename?: 'EpisodeContent';
						title: string;
						episodeNumber: number;
						seasonNumber: number;
						upcomingReleases?: Array<{
							__typename?: 'UpcomingRelease';
							releaseDate?: any | null;
							label: Types.UpcomingReleaseLabel;
						}>;
					};
					watchNowOffer?: {
						__typename: 'Offer';
						id: string;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						lastChangeRetailPriceValue?: number | null;
						currency?: string | null;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						availableTo?: any | null;
						dateCreated?: any | null;
						newElementCount?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							icon: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							iconWide: string;
							hasRectangularIcon: boolean;
						};
					} | null;
					show: { __typename?: 'Show'; id: string };
				} | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'ShowContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
	>;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type TitleListModuleFieldsFragment =
	| TitleListModuleFields_Hmavod_Fragment
	| TitleListModuleFields_HmBecauseYouLikedTitle_Fragment
	| TitleListModuleFields_HmContinueWatchingJwtv_Fragment
	| TitleListModuleFields_HmFeatureRotator_Fragment
	| TitleListModuleFields_HmHighlightArticle_Fragment
	| TitleListModuleFields_HmNewPerPackageToday_Fragment
	| TitleListModuleFields_HmPermanentAudience_Fragment
	| TitleListModuleFields_Hmsqtv_Fragment
	| TitleListModuleFields_HmSportsLiveFootball_Fragment
	| TitleListModuleFields_HmSportsUpcomingFootball_Fragment
	| TitleListModuleFields_HmSpotlight_Fragment
	| TitleListModuleFields_HmSpotlightContinueWatching_Fragment
	| TitleListModuleFields_HmSpotlightGoingViral_Fragment
	| TitleListModuleFields_HmSpotlightNewOnYourWatchlist_Fragment
	| TitleListModuleFields_HmSpotlightNewSimilarToLikedTitle_Fragment
	| TitleListModuleFields_HmSpotlightNewWithHighRatings_Fragment
	| TitleListModuleFields_HmSpotlightTrendingToday_Fragment
	| TitleListModuleFields_Hmtvod_Fragment
	| TitleListModuleFields_HmTextRecommendation_Fragment
	| TitleListModuleFields_HmTop3PerPackageToday_Fragment
	| TitleListModuleFields_HmTop10InYourCountry_Fragment
	| TitleListModuleFields_HmTopGenre_Fragment
	| TitleListModuleFields_HmTopHighlightArticle_Fragment
	| TitleListModuleFields_HmWatchedBySimilarUsers_Fragment;

export type PackageTitlesModuleFields_Hmavod_Fragment = { __typename?: 'HMAVOD' };

export type PackageTitlesModuleFields_HmBecauseYouLikedTitle_Fragment = { __typename?: 'HMBecauseYouLikedTitle' };

export type PackageTitlesModuleFields_HmContinueWatchingJwtv_Fragment = { __typename?: 'HMContinueWatchingJWTV' };

export type PackageTitlesModuleFields_HmFeatureRotator_Fragment = { __typename?: 'HMFeatureRotator' };

export type PackageTitlesModuleFields_HmHighlightArticle_Fragment = { __typename?: 'HMHighlightArticle' };

export type PackageTitlesModuleFields_HmNewPerPackageToday_Fragment = {
	__typename: 'HMNewPerPackageToday';
	moduleID: number;
	type: string;
	category: string;
	packagesWithTitles: Array<{
		__typename?: 'PackageTitles';
		package: { __typename?: 'Package'; id: string; clearName: string; shortName: string; packageId: number };
		titlesWithTrend: Array<{
			__typename?: 'TitleWithTrend';
			trend: Types.TitleTrend;
			title:
				| {
						__typename: 'Movie';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						offerCount: number;
						watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
						seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						watchNowOffer?: {
							__typename: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							lastChangeRetailPriceValue?: number | null;
							currency?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							availableTo?: any | null;
							dateCreated?: any | null;
							newElementCount?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								icon: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						} | null;
						content: {
							__typename?: 'MovieContent';
							title: string;
							originalReleaseYear?: number | null;
							runtime?: number | null;
							fullPath: string;
							posterUrl?: string | null;
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							scoring: { __typename?: 'Scoring'; viral?: number | null };
						};
				  }
				| {
						__typename: 'Season';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						offerCount: number;
						seenState: {
							__typename?: 'ShowSeenState';
							seenEpisodeCount: number;
							releasedEpisodeCount: number;
							progress: number;
							caughtUp: boolean;
							lastSeenEpisodeNumber?: number | null;
							lastSeenSeasonNumber?: number | null;
						};
						content: {
							__typename?: 'SeasonContent';
							seasonNumber: number;
							title: string;
							originalReleaseYear?: number | null;
							runtime?: number | null;
							fullPath: string;
							posterUrl?: string | null;
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							scoring: { __typename?: 'Scoring'; viral?: number | null };
						};
						show: {
							__typename: 'Show';
							id: string;
							objectType: Types.ObjectType;
							objectId: number;
							content: { __typename?: 'ShowContent'; title: string };
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						};
						watchNowOffer?: {
							__typename: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							lastChangeRetailPriceValue?: number | null;
							currency?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							availableTo?: any | null;
							dateCreated?: any | null;
							newElementCount?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								icon: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						} | null;
				  }
				| {
						__typename: 'Show';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						offerCount: number;
						watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
						seenState: {
							__typename?: 'ShowSeenState';
							seenEpisodeCount: number;
							releasedEpisodeCount: number;
							progress: number;
							caughtUp: boolean;
							lastSeenEpisodeNumber?: number | null;
							lastSeenSeasonNumber?: number | null;
						};
						watchNextEpisode?: {
							__typename?: 'Episode';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							season: {
								__typename?: 'Season';
								id: string;
								content: { __typename?: 'SeasonContent'; fullPath: string; posterUrl?: string | null };
								seenState: {
									__typename?: 'ShowSeenState';
									releasedEpisodeCount: number;
									seenEpisodeCount: number;
									progress: number;
								};
							};
							content: {
								__typename?: 'EpisodeContent';
								title: string;
								episodeNumber: number;
								seasonNumber: number;
								upcomingReleases?: Array<{
									__typename?: 'UpcomingRelease';
									releaseDate?: any | null;
									label: Types.UpcomingReleaseLabel;
								}>;
							};
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							show: { __typename?: 'Show'; id: string };
						} | null;
						watchNowOffer?: {
							__typename: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							lastChangeRetailPriceValue?: number | null;
							currency?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							availableTo?: any | null;
							dateCreated?: any | null;
							newElementCount?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								icon: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						} | null;
						content: {
							__typename?: 'ShowContent';
							title: string;
							originalReleaseYear?: number | null;
							runtime?: number | null;
							fullPath: string;
							posterUrl?: string | null;
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							scoring: { __typename?: 'Scoring'; viral?: number | null };
						};
				  };
		}>;
	}>;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type PackageTitlesModuleFields_HmPermanentAudience_Fragment = { __typename?: 'HMPermanentAudience' };

export type PackageTitlesModuleFields_Hmsqtv_Fragment = { __typename?: 'HMSQTV' };

export type PackageTitlesModuleFields_HmSportsLiveFootball_Fragment = { __typename?: 'HMSportsLiveFootball' };

export type PackageTitlesModuleFields_HmSportsUpcomingFootball_Fragment = { __typename?: 'HMSportsUpcomingFootball' };

export type PackageTitlesModuleFields_HmSpotlight_Fragment = { __typename?: 'HMSpotlight' };

export type PackageTitlesModuleFields_HmSpotlightContinueWatching_Fragment = {
	__typename?: 'HMSpotlightContinueWatching';
};

export type PackageTitlesModuleFields_HmSpotlightGoingViral_Fragment = { __typename?: 'HMSpotlightGoingViral' };

export type PackageTitlesModuleFields_HmSpotlightNewOnYourWatchlist_Fragment = {
	__typename?: 'HMSpotlightNewOnYourWatchlist';
};

export type PackageTitlesModuleFields_HmSpotlightNewSimilarToLikedTitle_Fragment = {
	__typename?: 'HMSpotlightNewSimilarToLikedTitle';
};

export type PackageTitlesModuleFields_HmSpotlightNewWithHighRatings_Fragment = {
	__typename?: 'HMSpotlightNewWithHighRatings';
};

export type PackageTitlesModuleFields_HmSpotlightTrendingToday_Fragment = { __typename?: 'HMSpotlightTrendingToday' };

export type PackageTitlesModuleFields_Hmtvod_Fragment = { __typename?: 'HMTVOD' };

export type PackageTitlesModuleFields_HmTextRecommendation_Fragment = { __typename?: 'HMTextRecommendation' };

export type PackageTitlesModuleFields_HmTop3PerPackageToday_Fragment = {
	__typename: 'HMTop3PerPackageToday';
	moduleID: number;
	type: string;
	category: string;
	packagesWithTitles: Array<{
		__typename?: 'PackageTitles';
		package: { __typename?: 'Package'; id: string; clearName: string; shortName: string; packageId: number };
		titlesWithTrend: Array<{
			__typename?: 'TitleWithTrend';
			trend: Types.TitleTrend;
			title:
				| {
						__typename: 'Movie';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						offerCount: number;
						watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
						seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						watchNowOffer?: {
							__typename: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							lastChangeRetailPriceValue?: number | null;
							currency?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							availableTo?: any | null;
							dateCreated?: any | null;
							newElementCount?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								icon: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						} | null;
						content: {
							__typename?: 'MovieContent';
							title: string;
							originalReleaseYear?: number | null;
							runtime?: number | null;
							fullPath: string;
							posterUrl?: string | null;
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							scoring: { __typename?: 'Scoring'; viral?: number | null };
						};
				  }
				| {
						__typename: 'Season';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						offerCount: number;
						seenState: {
							__typename?: 'ShowSeenState';
							seenEpisodeCount: number;
							releasedEpisodeCount: number;
							progress: number;
							caughtUp: boolean;
							lastSeenEpisodeNumber?: number | null;
							lastSeenSeasonNumber?: number | null;
						};
						content: {
							__typename?: 'SeasonContent';
							seasonNumber: number;
							title: string;
							originalReleaseYear?: number | null;
							runtime?: number | null;
							fullPath: string;
							posterUrl?: string | null;
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							scoring: { __typename?: 'Scoring'; viral?: number | null };
						};
						show: {
							__typename: 'Show';
							id: string;
							objectType: Types.ObjectType;
							objectId: number;
							content: { __typename?: 'ShowContent'; title: string };
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						};
						watchNowOffer?: {
							__typename: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							lastChangeRetailPriceValue?: number | null;
							currency?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							availableTo?: any | null;
							dateCreated?: any | null;
							newElementCount?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								icon: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						} | null;
				  }
				| {
						__typename: 'Show';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						offerCount: number;
						watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
						seenState: {
							__typename?: 'ShowSeenState';
							seenEpisodeCount: number;
							releasedEpisodeCount: number;
							progress: number;
							caughtUp: boolean;
							lastSeenEpisodeNumber?: number | null;
							lastSeenSeasonNumber?: number | null;
						};
						watchNextEpisode?: {
							__typename?: 'Episode';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							offerCount: number;
							season: {
								__typename?: 'Season';
								id: string;
								content: { __typename?: 'SeasonContent'; fullPath: string; posterUrl?: string | null };
								seenState: {
									__typename?: 'ShowSeenState';
									releasedEpisodeCount: number;
									seenEpisodeCount: number;
									progress: number;
								};
							};
							content: {
								__typename?: 'EpisodeContent';
								title: string;
								episodeNumber: number;
								seasonNumber: number;
								upcomingReleases?: Array<{
									__typename?: 'UpcomingRelease';
									releaseDate?: any | null;
									label: Types.UpcomingReleaseLabel;
								}>;
							};
							watchNowOffer?: {
								__typename: 'Offer';
								id: string;
								standardWebURL?: string | null;
								preAffiliatedStandardWebURL?: string | null;
								streamUrl?: string | null;
								streamUrlExternalPlayer?: string | null;
								retailPrice?: string | null;
								retailPriceValue?: number | null;
								lastChangeRetailPriceValue?: number | null;
								currency?: string | null;
								presentationType: Types.PresentationType;
								monetizationType: Types.MonetizationType;
								availableTo?: any | null;
								dateCreated?: any | null;
								newElementCount?: number | null;
								package: {
									__typename?: 'Package';
									id: string;
									icon: string;
									packageId: number;
									clearName: string;
									shortName: string;
									technicalName: string;
									iconWide: string;
									hasRectangularIcon: boolean;
								};
							} | null;
							show: { __typename?: 'Show'; id: string };
						} | null;
						watchNowOffer?: {
							__typename: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							lastChangeRetailPriceValue?: number | null;
							currency?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							availableTo?: any | null;
							dateCreated?: any | null;
							newElementCount?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								icon: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						} | null;
						content: {
							__typename?: 'ShowContent';
							title: string;
							originalReleaseYear?: number | null;
							runtime?: number | null;
							fullPath: string;
							posterUrl?: string | null;
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							scoring: { __typename?: 'Scoring'; viral?: number | null };
						};
				  };
		}>;
	}>;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type PackageTitlesModuleFields_HmTop10InYourCountry_Fragment = { __typename?: 'HMTop10InYourCountry' };

export type PackageTitlesModuleFields_HmTopGenre_Fragment = { __typename?: 'HMTopGenre' };

export type PackageTitlesModuleFields_HmTopHighlightArticle_Fragment = { __typename?: 'HMTopHighlightArticle' };

export type PackageTitlesModuleFields_HmWatchedBySimilarUsers_Fragment = { __typename?: 'HMWatchedBySimilarUsers' };

export type PackageTitlesModuleFieldsFragment =
	| PackageTitlesModuleFields_Hmavod_Fragment
	| PackageTitlesModuleFields_HmBecauseYouLikedTitle_Fragment
	| PackageTitlesModuleFields_HmContinueWatchingJwtv_Fragment
	| PackageTitlesModuleFields_HmFeatureRotator_Fragment
	| PackageTitlesModuleFields_HmHighlightArticle_Fragment
	| PackageTitlesModuleFields_HmNewPerPackageToday_Fragment
	| PackageTitlesModuleFields_HmPermanentAudience_Fragment
	| PackageTitlesModuleFields_Hmsqtv_Fragment
	| PackageTitlesModuleFields_HmSportsLiveFootball_Fragment
	| PackageTitlesModuleFields_HmSportsUpcomingFootball_Fragment
	| PackageTitlesModuleFields_HmSpotlight_Fragment
	| PackageTitlesModuleFields_HmSpotlightContinueWatching_Fragment
	| PackageTitlesModuleFields_HmSpotlightGoingViral_Fragment
	| PackageTitlesModuleFields_HmSpotlightNewOnYourWatchlist_Fragment
	| PackageTitlesModuleFields_HmSpotlightNewSimilarToLikedTitle_Fragment
	| PackageTitlesModuleFields_HmSpotlightNewWithHighRatings_Fragment
	| PackageTitlesModuleFields_HmSpotlightTrendingToday_Fragment
	| PackageTitlesModuleFields_Hmtvod_Fragment
	| PackageTitlesModuleFields_HmTextRecommendation_Fragment
	| PackageTitlesModuleFields_HmTop3PerPackageToday_Fragment
	| PackageTitlesModuleFields_HmTop10InYourCountry_Fragment
	| PackageTitlesModuleFields_HmTopGenre_Fragment
	| PackageTitlesModuleFields_HmTopHighlightArticle_Fragment
	| PackageTitlesModuleFields_HmWatchedBySimilarUsers_Fragment;

export type RelatedTitlesModule_Hmavod_Fragment = { __typename?: 'HMAVOD' };

export type RelatedTitlesModule_HmBecauseYouLikedTitle_Fragment = {
	__typename: 'HMBecauseYouLikedTitle';
	moduleID: number;
	type: string;
	category: string;
	likedTitle:
		| {
				__typename?: 'Movie';
				id: string;
				content: {
					__typename?: 'MovieContent';
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
				};
		  }
		| {
				__typename?: 'Season';
				id: string;
				content: {
					__typename?: 'SeasonContent';
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
				};
		  }
		| {
				__typename?: 'Show';
				id: string;
				content: {
					__typename?: 'ShowContent';
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
				};
		  };
	titles: Array<
		| {
				__typename: 'Movie';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'MovieContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
		| {
				__typename: 'Season';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				content: {
					__typename?: 'SeasonContent';
					seasonNumber: number;
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
				show: {
					__typename: 'Show';
					id: string;
					objectType: Types.ObjectType;
					objectId: number;
					content: { __typename?: 'ShowContent'; title: string };
					watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				};
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
		  }
		| {
				__typename: 'Show';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				watchNextEpisode?: {
					__typename?: 'Episode';
					id: string;
					objectId: number;
					objectType: Types.ObjectType;
					offerCount: number;
					season: {
						__typename?: 'Season';
						id: string;
						content: { __typename?: 'SeasonContent'; fullPath: string; posterUrl?: string | null };
						seenState: {
							__typename?: 'ShowSeenState';
							releasedEpisodeCount: number;
							seenEpisodeCount: number;
							progress: number;
						};
					};
					content: {
						__typename?: 'EpisodeContent';
						title: string;
						episodeNumber: number;
						seasonNumber: number;
						upcomingReleases?: Array<{
							__typename?: 'UpcomingRelease';
							releaseDate?: any | null;
							label: Types.UpcomingReleaseLabel;
						}>;
					};
					watchNowOffer?: {
						__typename: 'Offer';
						id: string;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						lastChangeRetailPriceValue?: number | null;
						currency?: string | null;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						availableTo?: any | null;
						dateCreated?: any | null;
						newElementCount?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							icon: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							iconWide: string;
							hasRectangularIcon: boolean;
						};
					} | null;
					show: { __typename?: 'Show'; id: string };
				} | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'ShowContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
	>;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type RelatedTitlesModule_HmContinueWatchingJwtv_Fragment = { __typename?: 'HMContinueWatchingJWTV' };

export type RelatedTitlesModule_HmFeatureRotator_Fragment = { __typename?: 'HMFeatureRotator' };

export type RelatedTitlesModule_HmHighlightArticle_Fragment = { __typename?: 'HMHighlightArticle' };

export type RelatedTitlesModule_HmNewPerPackageToday_Fragment = { __typename?: 'HMNewPerPackageToday' };

export type RelatedTitlesModule_HmPermanentAudience_Fragment = { __typename?: 'HMPermanentAudience' };

export type RelatedTitlesModule_Hmsqtv_Fragment = { __typename?: 'HMSQTV' };

export type RelatedTitlesModule_HmSportsLiveFootball_Fragment = { __typename?: 'HMSportsLiveFootball' };

export type RelatedTitlesModule_HmSportsUpcomingFootball_Fragment = { __typename?: 'HMSportsUpcomingFootball' };

export type RelatedTitlesModule_HmSpotlight_Fragment = { __typename?: 'HMSpotlight' };

export type RelatedTitlesModule_HmSpotlightContinueWatching_Fragment = { __typename?: 'HMSpotlightContinueWatching' };

export type RelatedTitlesModule_HmSpotlightGoingViral_Fragment = { __typename?: 'HMSpotlightGoingViral' };

export type RelatedTitlesModule_HmSpotlightNewOnYourWatchlist_Fragment = {
	__typename?: 'HMSpotlightNewOnYourWatchlist';
};

export type RelatedTitlesModule_HmSpotlightNewSimilarToLikedTitle_Fragment = {
	__typename: 'HMSpotlightNewSimilarToLikedTitle';
	moduleID: number;
	type: string;
	category: string;
	likedTitle:
		| {
				__typename?: 'Movie';
				id: string;
				content: {
					__typename?: 'MovieContent';
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
				};
		  }
		| {
				__typename?: 'Season';
				id: string;
				content: {
					__typename?: 'SeasonContent';
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
				};
		  }
		| {
				__typename?: 'Show';
				id: string;
				content: {
					__typename?: 'ShowContent';
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
				};
		  };
	titles: Array<
		| {
				__typename: 'Movie';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'MovieContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
		| {
				__typename: 'Season';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				content: {
					__typename?: 'SeasonContent';
					seasonNumber: number;
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
				show: {
					__typename: 'Show';
					id: string;
					objectType: Types.ObjectType;
					objectId: number;
					content: { __typename?: 'ShowContent'; title: string };
					watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				};
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
		  }
		| {
				__typename: 'Show';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				watchNextEpisode?: {
					__typename?: 'Episode';
					id: string;
					objectId: number;
					objectType: Types.ObjectType;
					offerCount: number;
					season: {
						__typename?: 'Season';
						id: string;
						content: { __typename?: 'SeasonContent'; fullPath: string; posterUrl?: string | null };
						seenState: {
							__typename?: 'ShowSeenState';
							releasedEpisodeCount: number;
							seenEpisodeCount: number;
							progress: number;
						};
					};
					content: {
						__typename?: 'EpisodeContent';
						title: string;
						episodeNumber: number;
						seasonNumber: number;
						upcomingReleases?: Array<{
							__typename?: 'UpcomingRelease';
							releaseDate?: any | null;
							label: Types.UpcomingReleaseLabel;
						}>;
					};
					watchNowOffer?: {
						__typename: 'Offer';
						id: string;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						lastChangeRetailPriceValue?: number | null;
						currency?: string | null;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						availableTo?: any | null;
						dateCreated?: any | null;
						newElementCount?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							icon: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							iconWide: string;
							hasRectangularIcon: boolean;
						};
					} | null;
					show: { __typename?: 'Show'; id: string };
				} | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'ShowContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
	>;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type RelatedTitlesModule_HmSpotlightNewWithHighRatings_Fragment = {
	__typename?: 'HMSpotlightNewWithHighRatings';
};

export type RelatedTitlesModule_HmSpotlightTrendingToday_Fragment = { __typename?: 'HMSpotlightTrendingToday' };

export type RelatedTitlesModule_Hmtvod_Fragment = { __typename?: 'HMTVOD' };

export type RelatedTitlesModule_HmTextRecommendation_Fragment = { __typename?: 'HMTextRecommendation' };

export type RelatedTitlesModule_HmTop3PerPackageToday_Fragment = { __typename?: 'HMTop3PerPackageToday' };

export type RelatedTitlesModule_HmTop10InYourCountry_Fragment = { __typename?: 'HMTop10InYourCountry' };

export type RelatedTitlesModule_HmTopGenre_Fragment = { __typename?: 'HMTopGenre' };

export type RelatedTitlesModule_HmTopHighlightArticle_Fragment = { __typename?: 'HMTopHighlightArticle' };

export type RelatedTitlesModule_HmWatchedBySimilarUsers_Fragment = { __typename?: 'HMWatchedBySimilarUsers' };

export type RelatedTitlesModuleFragment =
	| RelatedTitlesModule_Hmavod_Fragment
	| RelatedTitlesModule_HmBecauseYouLikedTitle_Fragment
	| RelatedTitlesModule_HmContinueWatchingJwtv_Fragment
	| RelatedTitlesModule_HmFeatureRotator_Fragment
	| RelatedTitlesModule_HmHighlightArticle_Fragment
	| RelatedTitlesModule_HmNewPerPackageToday_Fragment
	| RelatedTitlesModule_HmPermanentAudience_Fragment
	| RelatedTitlesModule_Hmsqtv_Fragment
	| RelatedTitlesModule_HmSportsLiveFootball_Fragment
	| RelatedTitlesModule_HmSportsUpcomingFootball_Fragment
	| RelatedTitlesModule_HmSpotlight_Fragment
	| RelatedTitlesModule_HmSpotlightContinueWatching_Fragment
	| RelatedTitlesModule_HmSpotlightGoingViral_Fragment
	| RelatedTitlesModule_HmSpotlightNewOnYourWatchlist_Fragment
	| RelatedTitlesModule_HmSpotlightNewSimilarToLikedTitle_Fragment
	| RelatedTitlesModule_HmSpotlightNewWithHighRatings_Fragment
	| RelatedTitlesModule_HmSpotlightTrendingToday_Fragment
	| RelatedTitlesModule_Hmtvod_Fragment
	| RelatedTitlesModule_HmTextRecommendation_Fragment
	| RelatedTitlesModule_HmTop3PerPackageToday_Fragment
	| RelatedTitlesModule_HmTop10InYourCountry_Fragment
	| RelatedTitlesModule_HmTopGenre_Fragment
	| RelatedTitlesModule_HmTopHighlightArticle_Fragment
	| RelatedTitlesModule_HmWatchedBySimilarUsers_Fragment;

export type SportsModuleFields_Hmavod_Fragment = { __typename?: 'HMAVOD' };

export type SportsModuleFields_HmBecauseYouLikedTitle_Fragment = { __typename?: 'HMBecauseYouLikedTitle' };

export type SportsModuleFields_HmContinueWatchingJwtv_Fragment = { __typename?: 'HMContinueWatchingJWTV' };

export type SportsModuleFields_HmFeatureRotator_Fragment = { __typename?: 'HMFeatureRotator' };

export type SportsModuleFields_HmHighlightArticle_Fragment = { __typename?: 'HMHighlightArticle' };

export type SportsModuleFields_HmNewPerPackageToday_Fragment = { __typename?: 'HMNewPerPackageToday' };

export type SportsModuleFields_HmPermanentAudience_Fragment = { __typename?: 'HMPermanentAudience' };

export type SportsModuleFields_Hmsqtv_Fragment = { __typename?: 'HMSQTV' };

export type SportsModuleFields_HmSportsLiveFootball_Fragment = {
	__typename: 'HMSportsLiveFootball';
	moduleID: number;
	type: string;
	category: string;
	events: Array<
		| { __typename?: 'MultiStepSportEvent' }
		| {
				__typename: 'SingleStepSportEvent';
				id: string;
				sport: Types.SportType;
				objectType: Types.ObjectType;
				objectId: number;
				offerCount: number;
				mysportlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				watchNowOffer?: {
					__typename?: 'SportOffer';
					standardWebURL?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					audioLanguage?: string | null;
					sportObjectType: Types.SportObjectType;
					package: {
						__typename?: 'Package';
						clearName: string;
						icon: string;
						iconBlurHash?: string | null;
						id: string;
						packageId: number;
						technicalName: string;
						shortName: string;
						monetizationTypes: Array<Types.MonetizationType>;
						iconWide: string;
					};
				} | null;
				competition?: {
					__typename?: 'SportCompetitionV2';
					id: string;
					objectId: number;
					objectType: Types.ObjectType;
					sport: Types.SportType;
					content: {
						__typename?: 'SportCompetitionContentV2';
						fullPath: string;
						iconBlurHash?: string | null;
						iconUrl?: string | null;
						name: string;
					};
					activeSeason?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
				} | null;
				content: {
					__typename?: 'SingleStepSportEventContent';
					endAt?: any | null;
					fullPath?: string | null;
					name: string;
					startAt: any;
					status: Types.SportEventStatus;
					competitionStage: {
						__typename?: 'SportCompetitionStageV2';
						name: Types.SportCompetitionStageName;
						number?: number | null;
					};
					season?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
					venue?: { __typename?: 'SportVenue'; venueID: number; name: string } | null;
					pastEvents: Array<{
						__typename?: 'SingleStepSportEvent';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						sport: Types.SportType;
						competition?: {
							__typename?: 'SportCompetitionV2';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							sport: Types.SportType;
							content: { __typename?: 'SportCompetitionContentV2'; fullPath: string; name: string };
						} | null;
						competitors: {
							__typename?: 'SingleStepSportCompetitorsV2';
							homeTeam: {
								__typename?: 'SingleStepSportCompetitorV2';
								score?: number | null;
								competitors: Array<{
									__typename?: 'SportCompetitorV2';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									sport: Types.SportType;
									content: {
										__typename?: 'SportCompetitorContentV2';
										firstName: string;
										fullPath?: string | null;
										lastName: string;
										name: string;
										iconUrl?: string | null;
									};
								}>;
							};
							awayTeam: {
								__typename?: 'SingleStepSportCompetitorV2';
								score?: number | null;
								competitors: Array<{
									__typename?: 'SportCompetitorV2';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									sport: Types.SportType;
									content: {
										__typename?: 'SportCompetitorContentV2';
										firstName: string;
										fullPath?: string | null;
										lastName: string;
										name: string;
										iconUrl?: string | null;
									};
								}>;
							};
						};
						content: {
							__typename?: 'SingleStepSportEventContent';
							name: string;
							startAt: any;
							status: Types.SportEventStatus;
							season?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
						};
					}>;
				};
				competitors: {
					__typename?: 'SingleStepSportCompetitorsV2';
					homeTeam: {
						__typename?: 'SingleStepSportCompetitorV2';
						score?: number | null;
						winner: boolean;
						competitors: Array<{
							__typename?: 'SportCompetitorV2';
							id: string;
							objectId: number;
							content: {
								__typename?: 'SportCompetitorContentV2';
								name: string;
								iconUrl?: string | null;
								fullPath?: string | null;
							};
						}>;
					};
					awayTeam: {
						__typename?: 'SingleStepSportCompetitorV2';
						score?: number | null;
						winner: boolean;
						competitors: Array<{
							__typename?: 'SportCompetitorV2';
							id: string;
							objectId: number;
							content: {
								__typename?: 'SportCompetitorContentV2';
								name: string;
								iconUrl?: string | null;
								fullPath?: string | null;
							};
						}>;
					};
				};
				offers: Array<{
					__typename?: 'SportOffer';
					monetizationType: Types.MonetizationType;
					presentationType: Types.PresentationType;
					audioLanguage?: string | null;
					standardWebURL?: string | null;
					sportObjectType: Types.SportObjectType;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						technicalName: string;
						clearName: string;
						shortName: string;
						monetizationTypes: Array<Types.MonetizationType>;
					};
				}>;
		  }
	>;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type SportsModuleFields_HmSportsUpcomingFootball_Fragment = {
	__typename: 'HMSportsUpcomingFootball';
	moduleID: number;
	type: string;
	category: string;
	events: Array<
		| { __typename?: 'MultiStepSportEvent' }
		| {
				__typename: 'SingleStepSportEvent';
				id: string;
				sport: Types.SportType;
				objectType: Types.ObjectType;
				objectId: number;
				offerCount: number;
				mysportlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				watchNowOffer?: {
					__typename?: 'SportOffer';
					standardWebURL?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					audioLanguage?: string | null;
					sportObjectType: Types.SportObjectType;
					package: {
						__typename?: 'Package';
						clearName: string;
						icon: string;
						iconBlurHash?: string | null;
						id: string;
						packageId: number;
						technicalName: string;
						shortName: string;
						monetizationTypes: Array<Types.MonetizationType>;
						iconWide: string;
					};
				} | null;
				competition?: {
					__typename?: 'SportCompetitionV2';
					id: string;
					objectId: number;
					objectType: Types.ObjectType;
					sport: Types.SportType;
					content: {
						__typename?: 'SportCompetitionContentV2';
						fullPath: string;
						iconBlurHash?: string | null;
						iconUrl?: string | null;
						name: string;
					};
					activeSeason?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
				} | null;
				content: {
					__typename?: 'SingleStepSportEventContent';
					endAt?: any | null;
					fullPath?: string | null;
					name: string;
					startAt: any;
					status: Types.SportEventStatus;
					competitionStage: {
						__typename?: 'SportCompetitionStageV2';
						name: Types.SportCompetitionStageName;
						number?: number | null;
					};
					season?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
					venue?: { __typename?: 'SportVenue'; venueID: number; name: string } | null;
					pastEvents: Array<{
						__typename?: 'SingleStepSportEvent';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						sport: Types.SportType;
						competition?: {
							__typename?: 'SportCompetitionV2';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							sport: Types.SportType;
							content: { __typename?: 'SportCompetitionContentV2'; fullPath: string; name: string };
						} | null;
						competitors: {
							__typename?: 'SingleStepSportCompetitorsV2';
							homeTeam: {
								__typename?: 'SingleStepSportCompetitorV2';
								score?: number | null;
								competitors: Array<{
									__typename?: 'SportCompetitorV2';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									sport: Types.SportType;
									content: {
										__typename?: 'SportCompetitorContentV2';
										firstName: string;
										fullPath?: string | null;
										lastName: string;
										name: string;
										iconUrl?: string | null;
									};
								}>;
							};
							awayTeam: {
								__typename?: 'SingleStepSportCompetitorV2';
								score?: number | null;
								competitors: Array<{
									__typename?: 'SportCompetitorV2';
									id: string;
									objectId: number;
									objectType: Types.ObjectType;
									sport: Types.SportType;
									content: {
										__typename?: 'SportCompetitorContentV2';
										firstName: string;
										fullPath?: string | null;
										lastName: string;
										name: string;
										iconUrl?: string | null;
									};
								}>;
							};
						};
						content: {
							__typename?: 'SingleStepSportEventContent';
							name: string;
							startAt: any;
							status: Types.SportEventStatus;
							season?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
						};
					}>;
				};
				competitors: {
					__typename?: 'SingleStepSportCompetitorsV2';
					homeTeam: {
						__typename?: 'SingleStepSportCompetitorV2';
						score?: number | null;
						winner: boolean;
						competitors: Array<{
							__typename?: 'SportCompetitorV2';
							id: string;
							objectId: number;
							content: {
								__typename?: 'SportCompetitorContentV2';
								name: string;
								iconUrl?: string | null;
								fullPath?: string | null;
							};
						}>;
					};
					awayTeam: {
						__typename?: 'SingleStepSportCompetitorV2';
						score?: number | null;
						winner: boolean;
						competitors: Array<{
							__typename?: 'SportCompetitorV2';
							id: string;
							objectId: number;
							content: {
								__typename?: 'SportCompetitorContentV2';
								name: string;
								iconUrl?: string | null;
								fullPath?: string | null;
							};
						}>;
					};
				};
				offers: Array<{
					__typename?: 'SportOffer';
					monetizationType: Types.MonetizationType;
					presentationType: Types.PresentationType;
					audioLanguage?: string | null;
					standardWebURL?: string | null;
					sportObjectType: Types.SportObjectType;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						technicalName: string;
						clearName: string;
						shortName: string;
						monetizationTypes: Array<Types.MonetizationType>;
					};
				}>;
		  }
	>;
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type SportsModuleFields_HmSpotlight_Fragment = { __typename?: 'HMSpotlight' };

export type SportsModuleFields_HmSpotlightContinueWatching_Fragment = { __typename?: 'HMSpotlightContinueWatching' };

export type SportsModuleFields_HmSpotlightGoingViral_Fragment = { __typename?: 'HMSpotlightGoingViral' };

export type SportsModuleFields_HmSpotlightNewOnYourWatchlist_Fragment = {
	__typename?: 'HMSpotlightNewOnYourWatchlist';
};

export type SportsModuleFields_HmSpotlightNewSimilarToLikedTitle_Fragment = {
	__typename?: 'HMSpotlightNewSimilarToLikedTitle';
};

export type SportsModuleFields_HmSpotlightNewWithHighRatings_Fragment = {
	__typename?: 'HMSpotlightNewWithHighRatings';
};

export type SportsModuleFields_HmSpotlightTrendingToday_Fragment = { __typename?: 'HMSpotlightTrendingToday' };

export type SportsModuleFields_Hmtvod_Fragment = { __typename?: 'HMTVOD' };

export type SportsModuleFields_HmTextRecommendation_Fragment = { __typename?: 'HMTextRecommendation' };

export type SportsModuleFields_HmTop3PerPackageToday_Fragment = { __typename?: 'HMTop3PerPackageToday' };

export type SportsModuleFields_HmTop10InYourCountry_Fragment = { __typename?: 'HMTop10InYourCountry' };

export type SportsModuleFields_HmTopGenre_Fragment = { __typename?: 'HMTopGenre' };

export type SportsModuleFields_HmTopHighlightArticle_Fragment = { __typename?: 'HMTopHighlightArticle' };

export type SportsModuleFields_HmWatchedBySimilarUsers_Fragment = { __typename?: 'HMWatchedBySimilarUsers' };

export type SportsModuleFieldsFragment =
	| SportsModuleFields_Hmavod_Fragment
	| SportsModuleFields_HmBecauseYouLikedTitle_Fragment
	| SportsModuleFields_HmContinueWatchingJwtv_Fragment
	| SportsModuleFields_HmFeatureRotator_Fragment
	| SportsModuleFields_HmHighlightArticle_Fragment
	| SportsModuleFields_HmNewPerPackageToday_Fragment
	| SportsModuleFields_HmPermanentAudience_Fragment
	| SportsModuleFields_Hmsqtv_Fragment
	| SportsModuleFields_HmSportsLiveFootball_Fragment
	| SportsModuleFields_HmSportsUpcomingFootball_Fragment
	| SportsModuleFields_HmSpotlight_Fragment
	| SportsModuleFields_HmSpotlightContinueWatching_Fragment
	| SportsModuleFields_HmSpotlightGoingViral_Fragment
	| SportsModuleFields_HmSpotlightNewOnYourWatchlist_Fragment
	| SportsModuleFields_HmSpotlightNewSimilarToLikedTitle_Fragment
	| SportsModuleFields_HmSpotlightNewWithHighRatings_Fragment
	| SportsModuleFields_HmSpotlightTrendingToday_Fragment
	| SportsModuleFields_Hmtvod_Fragment
	| SportsModuleFields_HmTextRecommendation_Fragment
	| SportsModuleFields_HmTop3PerPackageToday_Fragment
	| SportsModuleFields_HmTop10InYourCountry_Fragment
	| SportsModuleFields_HmTopGenre_Fragment
	| SportsModuleFields_HmTopHighlightArticle_Fragment
	| SportsModuleFields_HmWatchedBySimilarUsers_Fragment;

export type EditorialModuleFields_Hmavod_Fragment = { __typename?: 'HMAVOD' };

export type EditorialModuleFields_HmBecauseYouLikedTitle_Fragment = { __typename?: 'HMBecauseYouLikedTitle' };

export type EditorialModuleFields_HmContinueWatchingJwtv_Fragment = { __typename?: 'HMContinueWatchingJWTV' };

export type EditorialModuleFields_HmFeatureRotator_Fragment = { __typename?: 'HMFeatureRotator' };

export type EditorialModuleFields_HmHighlightArticle_Fragment = {
	__typename: 'HMHighlightArticle';
	moduleID: number;
	type: string;
	category: string;
	titles: Array<
		| {
				__typename: 'Movie';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				appleTVPlusOffers: Array<{
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				}>;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'MovieContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
		| {
				__typename: 'Season';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				appleTVPlusOffers: Array<{
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				}>;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				content: {
					__typename?: 'SeasonContent';
					seasonNumber: number;
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
				show: {
					__typename: 'Show';
					id: string;
					objectType: Types.ObjectType;
					objectId: number;
					content: { __typename?: 'ShowContent'; title: string };
					watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				};
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
		  }
		| {
				__typename: 'Show';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				appleTVPlusOffers: Array<{
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				}>;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				watchNextEpisode?: {
					__typename?: 'Episode';
					id: string;
					objectId: number;
					objectType: Types.ObjectType;
					offerCount: number;
					season: {
						__typename?: 'Season';
						id: string;
						content: { __typename?: 'SeasonContent'; fullPath: string; posterUrl?: string | null };
						seenState: {
							__typename?: 'ShowSeenState';
							releasedEpisodeCount: number;
							seenEpisodeCount: number;
							progress: number;
						};
					};
					content: {
						__typename?: 'EpisodeContent';
						title: string;
						episodeNumber: number;
						seasonNumber: number;
						upcomingReleases?: Array<{
							__typename?: 'UpcomingRelease';
							releaseDate?: any | null;
							label: Types.UpcomingReleaseLabel;
						}>;
					};
					watchNowOffer?: {
						__typename: 'Offer';
						id: string;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						lastChangeRetailPriceValue?: number | null;
						currency?: string | null;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						availableTo?: any | null;
						dateCreated?: any | null;
						newElementCount?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							icon: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							iconWide: string;
							hasRectangularIcon: boolean;
						};
					} | null;
					show: { __typename?: 'Show'; id: string };
				} | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'ShowContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
	>;
	article: {
		__typename?: 'Article';
		id: string;
		author: {
			__typename?: 'Author';
			id: string;
			content: {
				__typename?: 'AuthorContent';
				bio: string;
				clearName: string;
				imageUrl?: string | null;
				fullPath: string;
				alumniOf: Array<string>;
				brand: string;
				languagesSpoken: Array<any>;
				occupation: Array<string>;
				publications?: Array<{ __typename?: 'AuthorSpecificLink'; name: string; url: string }> | null;
				socialHandles?: Array<{ __typename?: 'AuthorSpecificLink'; name: string; url: string }> | null;
			};
		};
		content: {
			__typename: 'ArticleContent';
			id: number;
			title?: string | null;
			fullPath: string;
			highlightLabel?: string | null;
			highlightTitle?: string | null;
		};
		linkedObjects: Array<{
			__typename?: 'ArticleLinkedObject';
			node:
				| { __typename?: 'Article' }
				| { __typename?: 'Author' }
				| { __typename?: 'Bundle' }
				| { __typename?: 'Device' }
				| { __typename?: 'Episode' }
				| {
						__typename?: 'GenericTitleList';
						id: string;
						followedlistEntry?: { __typename?: 'FollowedListEntry'; createdAt: any; name: string } | null;
				  }
				| { __typename?: 'Genre' }
				| { __typename?: 'HomePage' }
				| { __typename?: 'Movie' }
				| { __typename?: 'MultiStepSportEvent' }
				| { __typename?: 'Offer' }
				| { __typename?: 'OfferHistory' }
				| { __typename?: 'Package' }
				| { __typename?: 'Page' }
				| { __typename?: 'Person' }
				| { __typename?: 'ProfileV2' }
				| { __typename?: 'Season' }
				| { __typename?: 'Show' }
				| { __typename?: 'SingleStepSportEvent' }
				| { __typename?: 'SportCompetitionV2' }
				| { __typename?: 'SportCompetitorV2' }
				| { __typename?: 'SportMatch' }
				| { __typename?: 'Url' };
		}>;
	};
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type EditorialModuleFields_HmNewPerPackageToday_Fragment = { __typename?: 'HMNewPerPackageToday' };

export type EditorialModuleFields_HmPermanentAudience_Fragment = { __typename?: 'HMPermanentAudience' };

export type EditorialModuleFields_Hmsqtv_Fragment = { __typename?: 'HMSQTV' };

export type EditorialModuleFields_HmSportsLiveFootball_Fragment = { __typename?: 'HMSportsLiveFootball' };

export type EditorialModuleFields_HmSportsUpcomingFootball_Fragment = { __typename?: 'HMSportsUpcomingFootball' };

export type EditorialModuleFields_HmSpotlight_Fragment = { __typename?: 'HMSpotlight' };

export type EditorialModuleFields_HmSpotlightContinueWatching_Fragment = { __typename?: 'HMSpotlightContinueWatching' };

export type EditorialModuleFields_HmSpotlightGoingViral_Fragment = { __typename?: 'HMSpotlightGoingViral' };

export type EditorialModuleFields_HmSpotlightNewOnYourWatchlist_Fragment = {
	__typename?: 'HMSpotlightNewOnYourWatchlist';
};

export type EditorialModuleFields_HmSpotlightNewSimilarToLikedTitle_Fragment = {
	__typename?: 'HMSpotlightNewSimilarToLikedTitle';
};

export type EditorialModuleFields_HmSpotlightNewWithHighRatings_Fragment = {
	__typename?: 'HMSpotlightNewWithHighRatings';
};

export type EditorialModuleFields_HmSpotlightTrendingToday_Fragment = { __typename?: 'HMSpotlightTrendingToday' };

export type EditorialModuleFields_Hmtvod_Fragment = { __typename?: 'HMTVOD' };

export type EditorialModuleFields_HmTextRecommendation_Fragment = { __typename?: 'HMTextRecommendation' };

export type EditorialModuleFields_HmTop3PerPackageToday_Fragment = { __typename?: 'HMTop3PerPackageToday' };

export type EditorialModuleFields_HmTop10InYourCountry_Fragment = { __typename?: 'HMTop10InYourCountry' };

export type EditorialModuleFields_HmTopGenre_Fragment = { __typename?: 'HMTopGenre' };

export type EditorialModuleFields_HmTopHighlightArticle_Fragment = {
	__typename: 'HMTopHighlightArticle';
	moduleID: number;
	type: string;
	category: string;
	titles: Array<
		| {
				__typename: 'Movie';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				appleTVPlusOffers: Array<{
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				}>;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'MovieContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
		| {
				__typename: 'Season';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				appleTVPlusOffers: Array<{
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				}>;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				content: {
					__typename?: 'SeasonContent';
					seasonNumber: number;
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
				show: {
					__typename: 'Show';
					id: string;
					objectType: Types.ObjectType;
					objectId: number;
					content: { __typename?: 'ShowContent'; title: string };
					watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				};
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
		  }
		| {
				__typename: 'Show';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				appleTVPlusOffers: Array<{
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				}>;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				watchNextEpisode?: {
					__typename?: 'Episode';
					id: string;
					objectId: number;
					objectType: Types.ObjectType;
					offerCount: number;
					season: {
						__typename?: 'Season';
						id: string;
						content: { __typename?: 'SeasonContent'; fullPath: string; posterUrl?: string | null };
						seenState: {
							__typename?: 'ShowSeenState';
							releasedEpisodeCount: number;
							seenEpisodeCount: number;
							progress: number;
						};
					};
					content: {
						__typename?: 'EpisodeContent';
						title: string;
						episodeNumber: number;
						seasonNumber: number;
						upcomingReleases?: Array<{
							__typename?: 'UpcomingRelease';
							releaseDate?: any | null;
							label: Types.UpcomingReleaseLabel;
						}>;
					};
					watchNowOffer?: {
						__typename: 'Offer';
						id: string;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						lastChangeRetailPriceValue?: number | null;
						currency?: string | null;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						availableTo?: any | null;
						dateCreated?: any | null;
						newElementCount?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							icon: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							iconWide: string;
							hasRectangularIcon: boolean;
						};
					} | null;
					show: { __typename?: 'Show'; id: string };
				} | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'ShowContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
	>;
	article: {
		__typename?: 'Article';
		id: string;
		author: {
			__typename?: 'Author';
			id: string;
			content: {
				__typename?: 'AuthorContent';
				bio: string;
				clearName: string;
				imageUrl?: string | null;
				fullPath: string;
				alumniOf: Array<string>;
				brand: string;
				languagesSpoken: Array<any>;
				occupation: Array<string>;
				publications?: Array<{ __typename?: 'AuthorSpecificLink'; name: string; url: string }> | null;
				socialHandles?: Array<{ __typename?: 'AuthorSpecificLink'; name: string; url: string }> | null;
			};
		};
		content: {
			__typename: 'ArticleContent';
			id: number;
			title?: string | null;
			fullPath: string;
			highlightLabel?: string | null;
			highlightTitle?: string | null;
		};
		linkedObjects: Array<{
			__typename?: 'ArticleLinkedObject';
			node:
				| { __typename?: 'Article' }
				| { __typename?: 'Author' }
				| { __typename?: 'Bundle' }
				| { __typename?: 'Device' }
				| { __typename?: 'Episode' }
				| {
						__typename?: 'GenericTitleList';
						id: string;
						followedlistEntry?: { __typename?: 'FollowedListEntry'; createdAt: any; name: string } | null;
				  }
				| { __typename?: 'Genre' }
				| { __typename?: 'HomePage' }
				| { __typename?: 'Movie' }
				| { __typename?: 'MultiStepSportEvent' }
				| { __typename?: 'Offer' }
				| { __typename?: 'OfferHistory' }
				| { __typename?: 'Package' }
				| { __typename?: 'Page' }
				| { __typename?: 'Person' }
				| { __typename?: 'ProfileV2' }
				| { __typename?: 'Season' }
				| { __typename?: 'Show' }
				| { __typename?: 'SingleStepSportEvent' }
				| { __typename?: 'SportCompetitionV2' }
				| { __typename?: 'SportCompetitorV2' }
				| { __typename?: 'SportMatch' }
				| { __typename?: 'Url' };
		}>;
	};
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type EditorialModuleFields_HmWatchedBySimilarUsers_Fragment = { __typename?: 'HMWatchedBySimilarUsers' };

export type EditorialModuleFieldsFragment =
	| EditorialModuleFields_Hmavod_Fragment
	| EditorialModuleFields_HmBecauseYouLikedTitle_Fragment
	| EditorialModuleFields_HmContinueWatchingJwtv_Fragment
	| EditorialModuleFields_HmFeatureRotator_Fragment
	| EditorialModuleFields_HmHighlightArticle_Fragment
	| EditorialModuleFields_HmNewPerPackageToday_Fragment
	| EditorialModuleFields_HmPermanentAudience_Fragment
	| EditorialModuleFields_Hmsqtv_Fragment
	| EditorialModuleFields_HmSportsLiveFootball_Fragment
	| EditorialModuleFields_HmSportsUpcomingFootball_Fragment
	| EditorialModuleFields_HmSpotlight_Fragment
	| EditorialModuleFields_HmSpotlightContinueWatching_Fragment
	| EditorialModuleFields_HmSpotlightGoingViral_Fragment
	| EditorialModuleFields_HmSpotlightNewOnYourWatchlist_Fragment
	| EditorialModuleFields_HmSpotlightNewSimilarToLikedTitle_Fragment
	| EditorialModuleFields_HmSpotlightNewWithHighRatings_Fragment
	| EditorialModuleFields_HmSpotlightTrendingToday_Fragment
	| EditorialModuleFields_Hmtvod_Fragment
	| EditorialModuleFields_HmTextRecommendation_Fragment
	| EditorialModuleFields_HmTop3PerPackageToday_Fragment
	| EditorialModuleFields_HmTop10InYourCountry_Fragment
	| EditorialModuleFields_HmTopGenre_Fragment
	| EditorialModuleFields_HmTopHighlightArticle_Fragment
	| EditorialModuleFields_HmWatchedBySimilarUsers_Fragment;

export type W2WModuleFields_Hmavod_Fragment = { __typename?: 'HMAVOD' };

export type W2WModuleFields_HmBecauseYouLikedTitle_Fragment = { __typename?: 'HMBecauseYouLikedTitle' };

export type W2WModuleFields_HmContinueWatchingJwtv_Fragment = { __typename?: 'HMContinueWatchingJWTV' };

export type W2WModuleFields_HmFeatureRotator_Fragment = { __typename?: 'HMFeatureRotator' };

export type W2WModuleFields_HmHighlightArticle_Fragment = { __typename?: 'HMHighlightArticle' };

export type W2WModuleFields_HmNewPerPackageToday_Fragment = { __typename?: 'HMNewPerPackageToday' };

export type W2WModuleFields_HmPermanentAudience_Fragment = { __typename?: 'HMPermanentAudience' };

export type W2WModuleFields_Hmsqtv_Fragment = { __typename?: 'HMSQTV' };

export type W2WModuleFields_HmSportsLiveFootball_Fragment = { __typename?: 'HMSportsLiveFootball' };

export type W2WModuleFields_HmSportsUpcomingFootball_Fragment = { __typename?: 'HMSportsUpcomingFootball' };

export type W2WModuleFields_HmSpotlight_Fragment = { __typename?: 'HMSpotlight' };

export type W2WModuleFields_HmSpotlightContinueWatching_Fragment = { __typename?: 'HMSpotlightContinueWatching' };

export type W2WModuleFields_HmSpotlightGoingViral_Fragment = { __typename?: 'HMSpotlightGoingViral' };

export type W2WModuleFields_HmSpotlightNewOnYourWatchlist_Fragment = { __typename?: 'HMSpotlightNewOnYourWatchlist' };

export type W2WModuleFields_HmSpotlightNewSimilarToLikedTitle_Fragment = {
	__typename?: 'HMSpotlightNewSimilarToLikedTitle';
};

export type W2WModuleFields_HmSpotlightNewWithHighRatings_Fragment = { __typename?: 'HMSpotlightNewWithHighRatings' };

export type W2WModuleFields_HmSpotlightTrendingToday_Fragment = { __typename?: 'HMSpotlightTrendingToday' };

export type W2WModuleFields_Hmtvod_Fragment = { __typename?: 'HMTVOD' };

export type W2WModuleFields_HmTextRecommendation_Fragment = {
	__typename: 'HMTextRecommendation';
	moduleID: number;
	type: string;
	category: string;
	textRecommendation: {
		__typename: 'TextRecommendation';
		id: string;
		headline?: string | null;
		body: string;
		bodyHTML: string;
		originalHeadline?: string | null;
		originalBody?: string | null;
		originalBodyHTML?: string | null;
		watchIf?: Array<string> | null;
		skipIf?: Array<string> | null;
		customProfileType?: string | null;
		watchedAt: any;
		likeCount: number;
		likedByUser: boolean;
		ownedByUser: boolean;
		updatedAt: any;
		tags?: Array<{ __typename?: 'Tag'; technicalName: string; translatedName: string }> | null;
		watchedOn?: {
			__typename?: 'Package';
			clearName: string;
			id: string;
			shortName: string;
			technicalName: string;
			packageId: number;
			selected: boolean;
			monetizationTypes: Array<Types.MonetizationType>;
			icon: string;
			isVisibleFilterBar: boolean;
			addonParent?: { __typename?: 'Package'; id: string } | null;
		} | null;
		profile: {
			__typename: 'Profile';
			displayName: string;
			firstName: string;
			lastName: string;
			location?: string | null;
			country: any;
			bio?: string | null;
			avatarUrl?: string | null;
			isComplete: boolean;
			ownedByUser: boolean;
			profileUrl: string;
			profileType: Types.ProfileType;
			contentPersonId?: string | null;
			textRecommendationsCount: number;
			id: string;
			externalUrls?: Array<{
				__typename?: 'ProfileSpecificLink';
				type: Types.ProfileSpecificLinkType;
				name?: string | null;
				url: string;
			}> | null;
		};
		title?:
			| {
					__typename: 'Movie';
					id: string;
					objectId: number;
					objectType: Types.ObjectType;
					content: {
						__typename?: 'MovieContent';
						title: string;
						posterUrl?: string | null;
						fullPath: string;
						upcomingReleases: Array<{
							__typename?: 'UpcomingRelease';
							releaseDate?: any | null;
							releaseCountDown?: number | null;
						}>;
						scoring: {
							__typename?: 'Scoring';
							imdbScore?: number | null;
							imdbVotes?: number | null;
							tmdbPopularity?: number | null;
							tmdbScore?: number | null;
							jwRating?: number | null;
							tomatoMeter?: number | null;
							certifiedFresh?: boolean | null;
						};
					};
					watchNowOffer?: {
						__typename: 'Offer';
						id: string;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						lastChangeRetailPriceValue?: number | null;
						currency?: string | null;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						availableTo?: any | null;
						dateCreated?: any | null;
						newElementCount?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							icon: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							iconWide: string;
							hasRectangularIcon: boolean;
						};
					} | null;
					availableTo: Array<{
						__typename?: 'AvailableTo';
						availableToDate: any;
						availableCountDown: number;
					}>;
					watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
			  }
			| {
					__typename: 'Season';
					id: string;
					objectId: number;
					objectType: Types.ObjectType;
					content: {
						__typename?: 'SeasonContent';
						seasonNumber: number;
						title: string;
						posterUrl?: string | null;
						fullPath: string;
						upcomingReleases: Array<{
							__typename?: 'UpcomingRelease';
							releaseDate?: any | null;
							releaseCountDown?: number | null;
						}>;
						scoring: {
							__typename?: 'Scoring';
							imdbScore?: number | null;
							imdbVotes?: number | null;
							tmdbPopularity?: number | null;
							tmdbScore?: number | null;
							jwRating?: number | null;
							tomatoMeter?: number | null;
							certifiedFresh?: boolean | null;
						};
					};
					show: {
						__typename: 'Show';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						content: { __typename?: 'ShowContent'; title: string; fullPath: string };
						watchNowOffer?: {
							__typename: 'Offer';
							id: string;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							lastChangeRetailPriceValue?: number | null;
							currency?: string | null;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							availableTo?: any | null;
							dateCreated?: any | null;
							newElementCount?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								icon: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								iconWide: string;
								hasRectangularIcon: boolean;
							};
						} | null;
						watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						seenState: { __typename?: 'ShowSeenState'; progress: number };
						tvShowTrackingEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
					};
					watchNowOffer?: {
						__typename: 'Offer';
						id: string;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						lastChangeRetailPriceValue?: number | null;
						currency?: string | null;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						availableTo?: any | null;
						dateCreated?: any | null;
						newElementCount?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							icon: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							iconWide: string;
							hasRectangularIcon: boolean;
						};
					} | null;
					availableTo: Array<{
						__typename?: 'AvailableTo';
						availableToDate: any;
						availableCountDown: number;
					}>;
					seenState: { __typename?: 'ShowSeenState'; progress: number };
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
			  }
			| {
					__typename: 'Show';
					id: string;
					objectId: number;
					objectType: Types.ObjectType;
					content: {
						__typename?: 'ShowContent';
						title: string;
						posterUrl?: string | null;
						fullPath: string;
						upcomingReleases: Array<{
							__typename?: 'UpcomingRelease';
							releaseDate?: any | null;
							releaseCountDown?: number | null;
						}>;
						scoring: {
							__typename?: 'Scoring';
							imdbScore?: number | null;
							imdbVotes?: number | null;
							tmdbPopularity?: number | null;
							tmdbScore?: number | null;
							jwRating?: number | null;
							tomatoMeter?: number | null;
							certifiedFresh?: boolean | null;
						};
					};
					watchNowOffer?: {
						__typename: 'Offer';
						id: string;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						lastChangeRetailPriceValue?: number | null;
						currency?: string | null;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						availableTo?: any | null;
						dateCreated?: any | null;
						newElementCount?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							icon: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							iconWide: string;
							hasRectangularIcon: boolean;
						};
					} | null;
					availableTo: Array<{
						__typename?: 'AvailableTo';
						availableToDate: any;
						availableCountDown: number;
					}>;
					watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
					seenState: { __typename?: 'ShowSeenState'; progress: number };
					tvShowTrackingEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
			  };
		video?: {
			__typename?: 'Clip';
			externalId: string;
			name: string;
			provider: Types.ClipProvider;
			publishedAt: any;
			sourceUrl: string;
			streamUrl?: string | null;
		} | null;
	};
	title:
		| {
				__typename: 'Movie';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'MovieContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  }
		| {
				__typename: 'Season';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				content: {
					__typename?: 'SeasonContent';
					seasonNumber: number;
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
				show: {
					__typename: 'Show';
					id: string;
					objectType: Types.ObjectType;
					objectId: number;
					content: { __typename?: 'ShowContent'; title: string };
					watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				};
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
		  }
		| {
				__typename: 'Show';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				offerCount: number;
				watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
				customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
				seenState: {
					__typename?: 'ShowSeenState';
					seenEpisodeCount: number;
					releasedEpisodeCount: number;
					progress: number;
					caughtUp: boolean;
					lastSeenEpisodeNumber?: number | null;
					lastSeenSeasonNumber?: number | null;
				};
				watchNextEpisode?: {
					__typename?: 'Episode';
					id: string;
					objectId: number;
					objectType: Types.ObjectType;
					offerCount: number;
					season: {
						__typename?: 'Season';
						id: string;
						content: { __typename?: 'SeasonContent'; fullPath: string; posterUrl?: string | null };
						seenState: {
							__typename?: 'ShowSeenState';
							releasedEpisodeCount: number;
							seenEpisodeCount: number;
							progress: number;
						};
					};
					content: {
						__typename?: 'EpisodeContent';
						title: string;
						episodeNumber: number;
						seasonNumber: number;
						upcomingReleases?: Array<{
							__typename?: 'UpcomingRelease';
							releaseDate?: any | null;
							label: Types.UpcomingReleaseLabel;
						}>;
					};
					watchNowOffer?: {
						__typename: 'Offer';
						id: string;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						lastChangeRetailPriceValue?: number | null;
						currency?: string | null;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						availableTo?: any | null;
						dateCreated?: any | null;
						newElementCount?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							icon: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							iconWide: string;
							hasRectangularIcon: boolean;
						};
					} | null;
					show: { __typename?: 'Show'; id: string };
				} | null;
				watchNowOffer?: {
					__typename: 'Offer';
					id: string;
					standardWebURL?: string | null;
					preAffiliatedStandardWebURL?: string | null;
					streamUrl?: string | null;
					streamUrlExternalPlayer?: string | null;
					retailPrice?: string | null;
					retailPriceValue?: number | null;
					lastChangeRetailPriceValue?: number | null;
					currency?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					availableTo?: any | null;
					dateCreated?: any | null;
					newElementCount?: number | null;
					package: {
						__typename?: 'Package';
						id: string;
						icon: string;
						packageId: number;
						clearName: string;
						shortName: string;
						technicalName: string;
						iconWide: string;
						hasRectangularIcon: boolean;
					};
				} | null;
				content: {
					__typename?: 'ShowContent';
					title: string;
					originalReleaseYear?: number | null;
					runtime?: number | null;
					fullPath: string;
					posterUrl?: string | null;
					backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
					scoring: { __typename?: 'Scoring'; viral?: number | null };
				};
		  };
	authorProfile: {
		__typename: 'ProfileV2';
		id: string;
		content: {
			__typename?: 'ProfileContent';
			displayName: string;
			location?: string | null;
			bio?: string | null;
			avatarUrl?: string | null;
			ownedByUser: boolean;
			profileUrl: string;
			profileType: Types.ProfileType;
			externalUrls?: Array<{
				__typename?: 'ProfileSpecificLink';
				type: Types.ProfileSpecificLinkType;
				name?: string | null;
				url: string;
			}> | null;
		};
	};
	translatables: { __typename?: 'ModuleTranslatables'; title: string; badge: string };
};

export type W2WModuleFields_HmTop3PerPackageToday_Fragment = { __typename?: 'HMTop3PerPackageToday' };

export type W2WModuleFields_HmTop10InYourCountry_Fragment = { __typename?: 'HMTop10InYourCountry' };

export type W2WModuleFields_HmTopGenre_Fragment = { __typename?: 'HMTopGenre' };

export type W2WModuleFields_HmTopHighlightArticle_Fragment = { __typename?: 'HMTopHighlightArticle' };

export type W2WModuleFields_HmWatchedBySimilarUsers_Fragment = { __typename?: 'HMWatchedBySimilarUsers' };

export type W2WModuleFieldsFragment =
	| W2WModuleFields_Hmavod_Fragment
	| W2WModuleFields_HmBecauseYouLikedTitle_Fragment
	| W2WModuleFields_HmContinueWatchingJwtv_Fragment
	| W2WModuleFields_HmFeatureRotator_Fragment
	| W2WModuleFields_HmHighlightArticle_Fragment
	| W2WModuleFields_HmNewPerPackageToday_Fragment
	| W2WModuleFields_HmPermanentAudience_Fragment
	| W2WModuleFields_Hmsqtv_Fragment
	| W2WModuleFields_HmSportsLiveFootball_Fragment
	| W2WModuleFields_HmSportsUpcomingFootball_Fragment
	| W2WModuleFields_HmSpotlight_Fragment
	| W2WModuleFields_HmSpotlightContinueWatching_Fragment
	| W2WModuleFields_HmSpotlightGoingViral_Fragment
	| W2WModuleFields_HmSpotlightNewOnYourWatchlist_Fragment
	| W2WModuleFields_HmSpotlightNewSimilarToLikedTitle_Fragment
	| W2WModuleFields_HmSpotlightNewWithHighRatings_Fragment
	| W2WModuleFields_HmSpotlightTrendingToday_Fragment
	| W2WModuleFields_Hmtvod_Fragment
	| W2WModuleFields_HmTextRecommendation_Fragment
	| W2WModuleFields_HmTop3PerPackageToday_Fragment
	| W2WModuleFields_HmTop10InYourCountry_Fragment
	| W2WModuleFields_HmTopGenre_Fragment
	| W2WModuleFields_HmTopHighlightArticle_Fragment
	| W2WModuleFields_HmWatchedBySimilarUsers_Fragment;

export type ModuleTitleFields_Movie_Fragment = {
	__typename: 'Movie';
	id: string;
	objectId: number;
	objectType: Types.ObjectType;
	offerCount: number;
	watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
	likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
	dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
	customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
	seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
	watchNowOffer?: {
		__typename: 'Offer';
		id: string;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		lastChangeRetailPriceValue?: number | null;
		currency?: string | null;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		availableTo?: any | null;
		dateCreated?: any | null;
		newElementCount?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			icon: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			iconWide: string;
			hasRectangularIcon: boolean;
		};
	} | null;
	content: {
		__typename?: 'MovieContent';
		title: string;
		originalReleaseYear?: number | null;
		runtime?: number | null;
		fullPath: string;
		posterUrl?: string | null;
		backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
		scoring: { __typename?: 'Scoring'; viral?: number | null };
	};
};

export type ModuleTitleFields_Season_Fragment = {
	__typename: 'Season';
	id: string;
	objectId: number;
	objectType: Types.ObjectType;
	offerCount: number;
	seenState: {
		__typename?: 'ShowSeenState';
		seenEpisodeCount: number;
		releasedEpisodeCount: number;
		progress: number;
		caughtUp: boolean;
		lastSeenEpisodeNumber?: number | null;
		lastSeenSeasonNumber?: number | null;
	};
	content: {
		__typename?: 'SeasonContent';
		seasonNumber: number;
		title: string;
		originalReleaseYear?: number | null;
		runtime?: number | null;
		fullPath: string;
		posterUrl?: string | null;
		backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
		scoring: { __typename?: 'Scoring'; viral?: number | null };
	};
	show: {
		__typename: 'Show';
		id: string;
		objectType: Types.ObjectType;
		objectId: number;
		content: { __typename?: 'ShowContent'; title: string };
		watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
		likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
		dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
	};
	watchNowOffer?: {
		__typename: 'Offer';
		id: string;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		lastChangeRetailPriceValue?: number | null;
		currency?: string | null;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		availableTo?: any | null;
		dateCreated?: any | null;
		newElementCount?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			icon: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			iconWide: string;
			hasRectangularIcon: boolean;
		};
	} | null;
};

export type ModuleTitleFields_Show_Fragment = {
	__typename: 'Show';
	id: string;
	objectId: number;
	objectType: Types.ObjectType;
	offerCount: number;
	watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
	likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
	dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
	customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
	seenState: {
		__typename?: 'ShowSeenState';
		seenEpisodeCount: number;
		releasedEpisodeCount: number;
		progress: number;
		caughtUp: boolean;
		lastSeenEpisodeNumber?: number | null;
		lastSeenSeasonNumber?: number | null;
	};
	watchNextEpisode?: {
		__typename?: 'Episode';
		id: string;
		objectId: number;
		objectType: Types.ObjectType;
		offerCount: number;
		season: {
			__typename?: 'Season';
			id: string;
			content: { __typename?: 'SeasonContent'; fullPath: string; posterUrl?: string | null };
			seenState: {
				__typename?: 'ShowSeenState';
				releasedEpisodeCount: number;
				seenEpisodeCount: number;
				progress: number;
			};
		};
		content: {
			__typename?: 'EpisodeContent';
			title: string;
			episodeNumber: number;
			seasonNumber: number;
			upcomingReleases?: Array<{
				__typename?: 'UpcomingRelease';
				releaseDate?: any | null;
				label: Types.UpcomingReleaseLabel;
			}>;
		};
		watchNowOffer?: {
			__typename: 'Offer';
			id: string;
			standardWebURL?: string | null;
			preAffiliatedStandardWebURL?: string | null;
			streamUrl?: string | null;
			streamUrlExternalPlayer?: string | null;
			retailPrice?: string | null;
			retailPriceValue?: number | null;
			lastChangeRetailPriceValue?: number | null;
			currency?: string | null;
			presentationType: Types.PresentationType;
			monetizationType: Types.MonetizationType;
			availableTo?: any | null;
			dateCreated?: any | null;
			newElementCount?: number | null;
			package: {
				__typename?: 'Package';
				id: string;
				icon: string;
				packageId: number;
				clearName: string;
				shortName: string;
				technicalName: string;
				iconWide: string;
				hasRectangularIcon: boolean;
			};
		} | null;
		show: { __typename?: 'Show'; id: string };
	} | null;
	watchNowOffer?: {
		__typename: 'Offer';
		id: string;
		standardWebURL?: string | null;
		preAffiliatedStandardWebURL?: string | null;
		streamUrl?: string | null;
		streamUrlExternalPlayer?: string | null;
		retailPrice?: string | null;
		retailPriceValue?: number | null;
		lastChangeRetailPriceValue?: number | null;
		currency?: string | null;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		availableTo?: any | null;
		dateCreated?: any | null;
		newElementCount?: number | null;
		package: {
			__typename?: 'Package';
			id: string;
			icon: string;
			packageId: number;
			clearName: string;
			shortName: string;
			technicalName: string;
			iconWide: string;
			hasRectangularIcon: boolean;
		};
	} | null;
	content: {
		__typename?: 'ShowContent';
		title: string;
		originalReleaseYear?: number | null;
		runtime?: number | null;
		fullPath: string;
		posterUrl?: string | null;
		backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
		scoring: { __typename?: 'Scoring'; viral?: number | null };
	};
};

export type ModuleTitleFieldsFragment =
	| ModuleTitleFields_Movie_Fragment
	| ModuleTitleFields_Season_Fragment
	| ModuleTitleFields_Show_Fragment;

export type SportEventFields_MultiStepSportEvent_Fragment = {
	__typename: 'MultiStepSportEvent';
	id: string;
	sport: Types.SportType;
	objectType: Types.ObjectType;
	objectId: number;
	mysportlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
	watchNowOffer?: {
		__typename?: 'SportOffer';
		standardWebURL?: string | null;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		package: {
			__typename?: 'Package';
			clearName: string;
			icon: string;
			iconBlurHash?: string | null;
			id: string;
			packageId: number;
			technicalName: string;
			shortName: string;
		};
	} | null;
	competition?: {
		__typename?: 'SportCompetitionV2';
		id: string;
		objectId: number;
		objectType: Types.ObjectType;
		sport: Types.SportType;
		content: {
			__typename?: 'SportCompetitionContentV2';
			fullPath: string;
			iconBlurHash?: string | null;
			iconUrl?: string | null;
			name: string;
		};
		activeSeason?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
	} | null;
	content: {
		__typename?: 'MultiStepSportEventContent';
		endAt?: any | null;
		fullPath?: string | null;
		name: string;
		startAt: any;
		status: Types.SportEventStatus;
		competitionStage: {
			__typename?: 'SportCompetitionStageV2';
			name: Types.SportCompetitionStageName;
			number?: number | null;
		};
		season?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
	};
	children: Array<{
		__typename?: 'MultiStepSportEvent';
		id: string;
		objectId: number;
		objectType: Types.ObjectType;
		offerCount: number;
		content: {
			__typename?: 'MultiStepSportEventContent';
			name: string;
			startAt: any;
			endAt?: any | null;
			status: Types.SportEventStatus;
			venue?: { __typename?: 'SportVenue'; venueID: number; name: string } | null;
			competitionStage: {
				__typename?: 'SportCompetitionStageV2';
				name: Types.SportCompetitionStageName;
				number?: number | null;
			};
		};
		watchNowOffer?: {
			__typename?: 'SportOffer';
			monetizationType: Types.MonetizationType;
			presentationType: Types.PresentationType;
			audioLanguage?: string | null;
			standardWebURL?: string | null;
			sportObjectType: Types.SportObjectType;
			package: {
				__typename?: 'Package';
				id: string;
				packageId: number;
				technicalName: string;
				clearName: string;
				shortName: string;
				monetizationTypes: Array<Types.MonetizationType>;
				iconWide: string;
			};
		} | null;
		offers: Array<{
			__typename?: 'SportOffer';
			monetizationType: Types.MonetizationType;
			presentationType: Types.PresentationType;
			audioLanguage?: string | null;
			standardWebURL?: string | null;
			sportObjectType: Types.SportObjectType;
			package: {
				__typename?: 'Package';
				id: string;
				packageId: number;
				technicalName: string;
				clearName: string;
				shortName: string;
				monetizationTypes: Array<Types.MonetizationType>;
			};
		}>;
	}>;
	parent?: {
		__typename?: 'MultiStepSportEvent';
		id: string;
		content: {
			__typename?: 'MultiStepSportEventContent';
			name: string;
			fullPath?: string | null;
			startAt: any;
			status: Types.SportEventStatus;
		};
	} | null;
};

export type SportEventFields_SingleStepSportEvent_Fragment = {
	__typename: 'SingleStepSportEvent';
	id: string;
	sport: Types.SportType;
	objectType: Types.ObjectType;
	objectId: number;
	offerCount: number;
	mysportlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
	watchNowOffer?: {
		__typename?: 'SportOffer';
		standardWebURL?: string | null;
		presentationType: Types.PresentationType;
		monetizationType: Types.MonetizationType;
		audioLanguage?: string | null;
		sportObjectType: Types.SportObjectType;
		package: {
			__typename?: 'Package';
			clearName: string;
			icon: string;
			iconBlurHash?: string | null;
			id: string;
			packageId: number;
			technicalName: string;
			shortName: string;
			monetizationTypes: Array<Types.MonetizationType>;
			iconWide: string;
		};
	} | null;
	competition?: {
		__typename?: 'SportCompetitionV2';
		id: string;
		objectId: number;
		objectType: Types.ObjectType;
		sport: Types.SportType;
		content: {
			__typename?: 'SportCompetitionContentV2';
			fullPath: string;
			iconBlurHash?: string | null;
			iconUrl?: string | null;
			name: string;
		};
		activeSeason?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
	} | null;
	content: {
		__typename?: 'SingleStepSportEventContent';
		endAt?: any | null;
		fullPath?: string | null;
		name: string;
		startAt: any;
		status: Types.SportEventStatus;
		competitionStage: {
			__typename?: 'SportCompetitionStageV2';
			name: Types.SportCompetitionStageName;
			number?: number | null;
		};
		season?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
		venue?: { __typename?: 'SportVenue'; venueID: number; name: string } | null;
		pastEvents: Array<{
			__typename?: 'SingleStepSportEvent';
			id: string;
			objectId: number;
			objectType: Types.ObjectType;
			sport: Types.SportType;
			competition?: {
				__typename?: 'SportCompetitionV2';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				sport: Types.SportType;
				content: { __typename?: 'SportCompetitionContentV2'; fullPath: string; name: string };
			} | null;
			competitors: {
				__typename?: 'SingleStepSportCompetitorsV2';
				homeTeam: {
					__typename?: 'SingleStepSportCompetitorV2';
					score?: number | null;
					competitors: Array<{
						__typename?: 'SportCompetitorV2';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						sport: Types.SportType;
						content: {
							__typename?: 'SportCompetitorContentV2';
							firstName: string;
							fullPath?: string | null;
							lastName: string;
							name: string;
							iconUrl?: string | null;
						};
					}>;
				};
				awayTeam: {
					__typename?: 'SingleStepSportCompetitorV2';
					score?: number | null;
					competitors: Array<{
						__typename?: 'SportCompetitorV2';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						sport: Types.SportType;
						content: {
							__typename?: 'SportCompetitorContentV2';
							firstName: string;
							fullPath?: string | null;
							lastName: string;
							name: string;
							iconUrl?: string | null;
						};
					}>;
				};
			};
			content: {
				__typename?: 'SingleStepSportEventContent';
				name: string;
				startAt: any;
				status: Types.SportEventStatus;
				season?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
			};
		}>;
	};
	competitors: {
		__typename?: 'SingleStepSportCompetitorsV2';
		homeTeam: {
			__typename?: 'SingleStepSportCompetitorV2';
			score?: number | null;
			winner: boolean;
			competitors: Array<{
				__typename?: 'SportCompetitorV2';
				id: string;
				objectId: number;
				content: {
					__typename?: 'SportCompetitorContentV2';
					name: string;
					iconUrl?: string | null;
					fullPath?: string | null;
				};
			}>;
		};
		awayTeam: {
			__typename?: 'SingleStepSportCompetitorV2';
			score?: number | null;
			winner: boolean;
			competitors: Array<{
				__typename?: 'SportCompetitorV2';
				id: string;
				objectId: number;
				content: {
					__typename?: 'SportCompetitorContentV2';
					name: string;
					iconUrl?: string | null;
					fullPath?: string | null;
				};
			}>;
		};
	};
	offers: Array<{
		__typename?: 'SportOffer';
		monetizationType: Types.MonetizationType;
		presentationType: Types.PresentationType;
		audioLanguage?: string | null;
		standardWebURL?: string | null;
		sportObjectType: Types.SportObjectType;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			technicalName: string;
			clearName: string;
			shortName: string;
			monetizationTypes: Array<Types.MonetizationType>;
		};
	}>;
};

export type SportEventFieldsFragment =
	| SportEventFields_MultiStepSportEvent_Fragment
	| SportEventFields_SingleStepSportEvent_Fragment;

export type ModuleArticleFieldsFragment = {
	__typename?: 'Article';
	id: string;
	author: {
		__typename?: 'Author';
		id: string;
		content: {
			__typename?: 'AuthorContent';
			bio: string;
			clearName: string;
			imageUrl?: string | null;
			fullPath: string;
			alumniOf: Array<string>;
			brand: string;
			languagesSpoken: Array<any>;
			occupation: Array<string>;
			publications?: Array<{ __typename?: 'AuthorSpecificLink'; name: string; url: string }> | null;
			socialHandles?: Array<{ __typename?: 'AuthorSpecificLink'; name: string; url: string }> | null;
		};
	};
	content: {
		__typename: 'ArticleContent';
		id: number;
		title?: string | null;
		fullPath: string;
		highlightLabel?: string | null;
		highlightTitle?: string | null;
	};
	linkedObjects: Array<{
		__typename?: 'ArticleLinkedObject';
		node:
			| { __typename?: 'Article' }
			| { __typename?: 'Author' }
			| { __typename?: 'Bundle' }
			| { __typename?: 'Device' }
			| { __typename?: 'Episode' }
			| {
					__typename?: 'GenericTitleList';
					id: string;
					followedlistEntry?: { __typename?: 'FollowedListEntry'; createdAt: any; name: string } | null;
			  }
			| { __typename?: 'Genre' }
			| { __typename?: 'HomePage' }
			| { __typename?: 'Movie' }
			| { __typename?: 'MultiStepSportEvent' }
			| { __typename?: 'Offer' }
			| { __typename?: 'OfferHistory' }
			| { __typename?: 'Package' }
			| { __typename?: 'Page' }
			| { __typename?: 'Person' }
			| { __typename?: 'ProfileV2' }
			| { __typename?: 'Season' }
			| { __typename?: 'Show' }
			| { __typename?: 'SingleStepSportEvent' }
			| { __typename?: 'SportCompetitionV2' }
			| { __typename?: 'SportCompetitorV2' }
			| { __typename?: 'SportMatch' }
			| { __typename?: 'Url' };
	}>;
};

export const ModuleInfoFragmentDoc = gql`
	fragment ModuleInfo on HomeModule {
		__typename
		moduleID
		type
		category
		translatables {
			title
			badge
		}
	}
`;
export const ModuleTitleFieldsFragmentDoc = gql`
	fragment ModuleTitleFields on MovieOrShowOrSeason {
		__typename
		id
		objectId
		objectType
		offerCount(country: $country, platform: $platform)
		watchNowOffer(country: $country, platform: $platform, filter: $watchNowFilter) {
			...WatchNowOffer
		}
		content(country: $country, language: $language) {
			title
			originalReleaseYear
			runtime
			fullPath
			backdrops {
				backdropUrl
			}
			posterUrl
			scoring {
				viral
			}
		}
		... on MovieOrShow {
			watchlistEntryV2 {
				createdAt
			}
			likelistEntry {
				createdAt
			}
			dislikelistEntry {
				createdAt
			}
			customlistEntries {
				createdAt
			}
		}
		... on Movie {
			seenlistEntry {
				createdAt
			}
		}
		... on Show {
			seenState(country: $country) {
				seenEpisodeCount
				releasedEpisodeCount
				progress
				caughtUp
				lastSeenEpisodeNumber
				lastSeenSeasonNumber
			}
			watchNextEpisode(country: $country, includeUnreleasedEpisodes: $includeUnreleasedEpisodes) {
				id
				objectId
				objectType
				offerCount(country: $country, platform: $platform)
				season {
					id
					content(country: $country, language: $language) {
						fullPath
						posterUrl
					}
					seenState(country: $country) {
						releasedEpisodeCount
						seenEpisodeCount
						progress
					}
				}
				content(country: $country, language: $language) {
					title
					episodeNumber
					seasonNumber
					upcomingReleases(releaseTypes: [DIGITAL]) @include(if: $includeUnreleasedEpisodes) {
						releaseDate
						label
					}
				}
				watchNowOffer(country: $country, platform: $platform, filter: $watchNowFilter) {
					...WatchNowOffer
				}
				show {
					id
				}
			}
		}
		... on Season {
			seenState(country: $country) {
				seenEpisodeCount
				releasedEpisodeCount
				progress
				caughtUp
				lastSeenEpisodeNumber
				lastSeenSeasonNumber
			}
			content(country: $country, language: $language) {
				seasonNumber
			}
			show {
				__typename
				id
				objectType
				objectId
				content(country: $country, language: $language) {
					title
				}
				watchlistEntryV2 {
					createdAt
				}
				likelistEntry {
					createdAt
				}
				dislikelistEntry {
					createdAt
				}
			}
		}
	}
	${WatchNowOfferFragmentDoc}
`;
export const SpotlightModuleFieldsFragmentDoc = gql`
	fragment SpotlightModuleFields on HomeModule {
		... on HMSpotlightGoingViral {
			...ModuleInfo
			titles {
				...ModuleTitleFields
			}
		}
		... on HMSpotlightNewOnYourWatchlist {
			...ModuleInfo
			titles {
				...ModuleTitleFields
				... on MovieOrShowOrSeason {
					content(country: $country, language: $language) {
						isReleased: isReleasedV2(country: $country)
						upcomingReleases(releaseTypes: [DIGITAL]) {
							releaseDate
						}
					}
				}
			}
		}
		... on HMSpotlightNewSimilarToLikedTitle {
			...ModuleInfo
			likedTitle {
				id
				content(country: $country, language: $language) {
					backdrops {
						backdropUrl
					}
				}
			}
			titles {
				...ModuleTitleFields
				... on MovieOrShowOrSeason {
					content(country: $country, language: $language) {
						isReleased: isReleasedV2(country: $country)
						upcomingReleases(releaseTypes: [DIGITAL]) {
							releaseDate
						}
					}
				}
			}
		}
		... on HMSpotlightNewWithHighRatings {
			...ModuleInfo
			titles {
				...ModuleTitleFields
				... on MovieOrShowOrSeason {
					content(country: $country, language: $language) {
						isReleased: isReleasedV2(country: $country)
						upcomingReleases(releaseTypes: [DIGITAL]) {
							releaseDate
						}
					}
				}
			}
		}
		... on HMSpotlightContinueWatching {
			...ModuleInfo
			titles {
				...ModuleTitleFields
			}
		}
		... on HMSpotlightTrendingToday {
			...ModuleInfo
			titles {
				...ModuleTitleFields
			}
		}
	}
	${ModuleInfoFragmentDoc}
	${ModuleTitleFieldsFragmentDoc}
`;
export const SpotlightModuleContainerFragmentDoc = gql`
	fragment SpotlightModuleContainer on HMSpotlight {
		...ModuleInfo
		modules {
			...SpotlightModuleFields
		}
	}
	${ModuleInfoFragmentDoc}
	${SpotlightModuleFieldsFragmentDoc}
`;
export const TitleListModuleFieldsFragmentDoc = gql`
	fragment TitleListModuleFields on HomeModule {
		... on HMTop10InYourCountry {
			...ModuleInfo
			titles {
				...ModuleTitleFields
			}
		}
		... on HMWatchedBySimilarUsers {
			...ModuleInfo
			titles {
				...ModuleTitleFields
			}
		}
		... on HMPermanentAudience {
			...ModuleInfo
			category
			titles {
				...ModuleTitleFields
			}
		}
		... on HMTopGenre {
			...ModuleInfo
			category
			titles {
				...ModuleTitleFields
			}
		}
	}
	${ModuleInfoFragmentDoc}
	${ModuleTitleFieldsFragmentDoc}
`;
export const PackageTitlesModuleFieldsFragmentDoc = gql`
	fragment PackageTitlesModuleFields on HomeModule {
		... on HMTop3PerPackageToday {
			...ModuleInfo
			packagesWithTitles {
				package {
					id
					clearName
					shortName
					packageId
				}
				titlesWithTrend {
					title {
						...ModuleTitleFields
					}
					trend
				}
			}
		}
		... on HMNewPerPackageToday {
			...ModuleInfo
			packagesWithTitles {
				package {
					id
					clearName
					shortName
					packageId
				}
				titlesWithTrend {
					title {
						...ModuleTitleFields
					}
					trend
				}
			}
		}
	}
	${ModuleInfoFragmentDoc}
	${ModuleTitleFieldsFragmentDoc}
`;
export const RelatedTitlesModuleFragmentDoc = gql`
	fragment RelatedTitlesModule on HomeModule {
		... on HMBecauseYouLikedTitle {
			...ModuleInfo
			likedTitle {
				id
				content(country: $country, language: $language) {
					backdrops {
						backdropUrl
					}
				}
			}
			titles {
				...ModuleTitleFields
			}
		}
		... on HMSpotlightNewSimilarToLikedTitle {
			...ModuleInfo
			likedTitle {
				id
				content(country: $country, language: $language) {
					backdrops {
						backdropUrl
					}
				}
			}
			titles {
				...ModuleTitleFields
			}
		}
	}
	${ModuleInfoFragmentDoc}
	${ModuleTitleFieldsFragmentDoc}
`;
export const SportEventFieldsFragmentDoc = gql`
	fragment SportEventFields on SportEventV2 {
		id
		sport
		mysportlistEntry {
			createdAt
		}
		watchNowOffer(country: $country, platform: $platform) {
			standardWebURL
			presentationType
			monetizationType
			package {
				clearName
				icon
				iconBlurHash
				id
				packageId
				technicalName
				shortName
			}
		}
		competition {
			id
			objectId
			objectType
			sport
			content(country: $country, language: $language) {
				fullPath
				iconBlurHash
				iconUrl
				name
			}
			activeSeason(country: $country, language: $language) {
				name
				seasonID
			}
		}
		content(country: $country, language: $language) {
			competitionStage {
				name
				number
			}
			endAt
			fullPath
			name
			season {
				name
				seasonID
			}
			startAt
			status
		}
		... on SingleStepSportEvent {
			...SingleStepSportEvent
		}
		... on MultiStepSportEvent {
			...MultiStepSportEvent
		}
	}
	${SingleStepSportEventFragmentDoc}
	${MultiStepSportEventFragmentDoc}
`;
export const SportsModuleFieldsFragmentDoc = gql`
	fragment SportsModuleFields on HomeModule {
		... on HMSportsLiveFootball {
			...ModuleInfo
			events {
				... on SingleStepSportEvent {
					...SportEventFields
				}
			}
		}
		... on HMSportsUpcomingFootball {
			...ModuleInfo
			events {
				... on SingleStepSportEvent {
					...SportEventFields
				}
			}
		}
	}
	${ModuleInfoFragmentDoc}
	${SportEventFieldsFragmentDoc}
`;
export const ModuleArticleFieldsFragmentDoc = gql`
	fragment ModuleArticleFields on Article {
		id
		author {
			id
			content(country: $country, language: $language) {
				...AuthorData
			}
		}
		content {
			id
			__typename
			title
			fullPath
			highlightLabel
			highlightTitle
		}
		linkedObjects {
			node {
				... on GenericTitleList {
					id
					followedlistEntry {
						createdAt
						name
					}
				}
			}
		}
	}
	${AuthorDataFragmentDoc}
`;
export const EditorialModuleFieldsFragmentDoc = gql`
	fragment EditorialModuleFields on HomeModule {
		... on HMHighlightArticle {
			...ModuleInfo
			titles {
				...ModuleTitleFields
				appleTVPlusOffers: offers(country: $country, platform: $platform, filter: { packages: ["atp"] }) {
					...WatchNowOffer
				}
			}
			article {
				...ModuleArticleFields
			}
		}
		... on HMTopHighlightArticle {
			...ModuleInfo
			titles {
				...ModuleTitleFields
				appleTVPlusOffers: offers(country: $country, platform: $platform, filter: { packages: ["atp"] }) {
					...WatchNowOffer
				}
			}
			article {
				...ModuleArticleFields
			}
		}
	}
	${ModuleInfoFragmentDoc}
	${ModuleTitleFieldsFragmentDoc}
	${WatchNowOfferFragmentDoc}
	${ModuleArticleFieldsFragmentDoc}
`;
export const W2WModuleFieldsFragmentDoc = gql`
	fragment W2WModuleFields on HomeModule {
		... on HMTextRecommendation {
			...ModuleInfo
			textRecommendation {
				...TextRecommendation
			}
			title {
				...ModuleTitleFields
			}
			authorProfile {
				...ProfileInfoV2
			}
		}
	}
	${ModuleInfoFragmentDoc}
	${TextRecommendationFragmentDoc}
	${ModuleTitleFieldsFragmentDoc}
	${ProfileInfoV2FragmentDoc}
`;
export const FeatureRotatorContainerFragmentDoc = gql`
	fragment FeatureRotatorContainer on HomeModule {
		...ModuleInfo
	}
	${ModuleInfoFragmentDoc}
`;
export const TvodModuleContainerFragmentDoc = gql`
	fragment TVODModuleContainer on HMTVOD {
		...ModuleInfo
		titles {
			...ModuleTitleFields
		}
	}
	${ModuleInfoFragmentDoc}
	${ModuleTitleFieldsFragmentDoc}
`;
export const HomeModulesFragmentDoc = gql`
	fragment HomeModules on HomePage {
		id
		__typename
		modules {
			...SpotlightModuleContainer
			...TitleListModuleFields
			...PackageTitlesModuleFields
			...RelatedTitlesModule
			...SportsModuleFields
			...EditorialModuleFields
			...W2WModuleFields
			...FeatureRotatorContainer
			...TVODModuleContainer
		}
	}
	${SpotlightModuleContainerFragmentDoc}
	${TitleListModuleFieldsFragmentDoc}
	${PackageTitlesModuleFieldsFragmentDoc}
	${RelatedTitlesModuleFragmentDoc}
	${SportsModuleFieldsFragmentDoc}
	${EditorialModuleFieldsFragmentDoc}
	${W2WModuleFieldsFragmentDoc}
	${FeatureRotatorContainerFragmentDoc}
	${TvodModuleContainerFragmentDoc}
`;
export const AvodModuleContainerFragmentDoc = gql`
	fragment AVODModuleContainer on HMAVOD {
		...ModuleInfo
		titles {
			...ModuleTitleFields
		}
	}
	${ModuleInfoFragmentDoc}
	${ModuleTitleFieldsFragmentDoc}
`;
export const GetHomeModulesDocument = gql`
	query GetHomeModules(
		$fullPath: String!
		$site: String
		$country: Country!
		$language: Language!
		$platform: Platform! = WEB
		$locale: String!
		$watchNowFilter: WatchNowOfferFilter!
		$includeUnreleasedEpisodes: Boolean = false
		$excludeTextRecommendationTitle: Boolean = false
	) {
		urlV2(fullPath: $fullPath, site: $site) {
			__typename
			fullPath
			locale
			objectType
			heading1
			heading2
			hrefLangTags(locale: $locale) {
				href
				hrefLang
				locale
			}
			htmlContent
			htmlContentJson
			id
			urlID
			metaDescription
			metaKeywords
			metaRobots
			metaTitle
			node {
				...HomeModules
			}
		}
	}
	${HomeModulesFragmentDoc}
`;
